<template>
  <div class="c1-main c1-stats-page" @click="c1HamMenuOpen = false; c1ShiftMenuOpen = false; c1TopTab = null">

    <div class="c1-sticky-top">
    <!-- TOP BAR -->
    <div class="c1-tib" @click="s1SlideOpen = null">
      <!-- LEFT 25% — Viki face flush left -->
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': s1SlideOpen === 'nav' }"
          @click.stop="s1SlideOpen = (s1SlideOpen === 'nav' ? null : 'nav')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <!-- CENTER 50% — module title + live indicator -->
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
          Statistics
        </div>
        <div class="s1-live-dot" :class="{ active: !s1Loading }"></div>
        <div class="s1-time-display">{{ s1TimeStr }}</div>
      </div>
      <!-- RIGHT 25% — ham only -->
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" :class="{ on: $route.path === '/tasks1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" :class="{ on: $route.path === '/stats1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" :class="{ on: $route.path === '/chat1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" :class="{ on: $route.path === '/communications1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- ══ STATS TOP FILTER STRIP ══ -->
    <div class="c1-top-strip" @click.stop>
      <div class="c1-top-strip-body">

        <!-- TAB ROW -->
        <div class="c1-ts-tab-row">
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'report'}" @click.stop="c1TopTab = c1TopTab === 'report' ? null : 'report'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            <span>Report</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='report' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'date'}" @click.stop="c1TopTab = c1TopTab === 'date' ? null : 'date'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <span>Date</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='date' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'agent'}" @click.stop="c1TopTab = c1TopTab === 'agent' ? null : 'agent'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
            <span>Agent</span>
            <span v-if="s1AgentFilter && s1AgentFilter.length" class="c1-ts-badge">{{ s1AgentFilter.length }}</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='agent' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'charts'}" @click.stop="c1TopTab = c1TopTab === 'charts' ? null : 'charts'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/></svg>
            <span>Charts</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='charts' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: s1ActiveTab === 'teams'}" @click.stop="s1GoToSection('teams'); c1TopTab = null">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <span>Teams</span>
          </div>
        </div>

        <!-- REPORT DROPDOWN -->
        <div v-show="c1TopTab === 'report'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Statistics Sections</div>
          <div class="c1-fs-grid" style="padding:0 8px">
            <div class="c1-fs-card" style="--fsclr:#6366f1" :class="{ on: s1ActiveTab === 'today' }" @click.stop="s1GoToSection('today'); c1TopTab = null"><span class="c1-fs-name">Today</span></div>
            <div class="c1-fs-card" style="--fsclr:#7c3aed" :class="{ on: s1ActiveTab === 'akg' }" @click.stop="s1GoToSection('akg'); c1TopTab = null"><span class="c1-fs-name">AKG Report</span></div>
            <div class="c1-fs-card" style="--fsclr:#00b67a" :class="{ on: s1ActiveTab === 'deposits' }" @click.stop="s1GoToSection('deposits'); c1TopTab = null"><span class="c1-fs-name">Deposits</span></div>
            <div class="c1-fs-card" style="--fsclr:#f59e0b" :class="{ on: s1ActiveTab === 'leads' }" @click.stop="s1GoToSection('leads'); c1TopTab = null"><span class="c1-fs-name">Leads</span></div>
            <div class="c1-fs-card" style="--fsclr:#ef4444" :class="{ on: s1ActiveTab === 'noanswer' }" @click.stop="s1GoToSection('noanswer'); c1TopTab = null"><span class="c1-fs-name">No Answer</span></div>
            <div class="c1-fs-card" style="--fsclr:#f97316" :class="{ on: s1ActiveTab === 'scheduled' }" @click.stop="s1GoToSection('scheduled'); c1TopTab = null"><span class="c1-fs-name">Scheduled</span></div>
            <div class="c1-fs-card" style="--fsclr:#8b5cf6" :class="{ on: s1ActiveTab === 'transfers' }" @click.stop="s1GoToSection('transfers'); c1TopTab = null"><span class="c1-fs-name">Transfers</span></div>
            <div class="c1-fs-card" style="--fsclr:#a855f7" :class="{ on: s1ActiveTab === 'referrals' }" @click.stop="s1GoToSection('referrals'); c1TopTab = null"><span class="c1-fs-name">Referrals</span></div>
            <div class="c1-fs-card" style="--fsclr:#78716c" :class="{ on: s1ActiveTab === 'bad_number' }" @click.stop="s1GoToSection('bad_number'); c1TopTab = null"><span class="c1-fs-name">Bad Number</span></div>
            <div class="c1-fs-card" style="--fsclr:#b45309" :class="{ on: s1ActiveTab === 'not_interested' }" @click.stop="s1GoToSection('not_interested'); c1TopTab = null"><span class="c1-fs-name">Not Interested</span></div>
            <div class="c1-fs-card" style="--fsclr:#0057ff" :class="{ on: s1ActiveTab === 'assignments' }" @click.stop="s1GoToSection('assignments'); c1TopTab = null"><span class="c1-fs-name">Assignments</span></div>
            <div class="c1-fs-card" style="--fsclr:#14b8a6" :class="{ on: s1ActiveTab === 'countries' }" @click.stop="s1GoToSection('countries'); c1TopTab = null"><span class="c1-fs-name">Countries</span></div>
            <div class="c1-fs-card" style="--fsclr:#3b82f6" :class="{ on: s1ActiveTab === 'hours' }" @click.stop="s1GoToSection('hours'); c1TopTab = null"><span class="c1-fs-name">Hours</span></div>
            <div class="c1-fs-card" style="--fsclr:#ec4899" :class="{ on: s1ActiveTab === 'advertising' }" @click.stop="s1GoToSection('advertising'); c1TopTab = null"><span class="c1-fs-name">Campaigns</span></div>
            <div class="c1-fs-card" style="--fsclr:#64748b" :class="{ on: s1ActiveTab === 'timeline' }" @click.stop="s1GoToSection('timeline'); c1TopTab = null"><span class="c1-fs-name">Timeline</span></div>
            <div class="c1-fs-card" style="--fsclr:#06b6d4" :class="{ on: s1ActiveTab === 'campaign_stats' }" @click.stop="s1GoToSection('campaign_stats'); c1TopTab = null"><span class="c1-fs-name">Campaign Stats</span></div>
            <div class="c1-fs-card" style="--fsclr:#0ea5e9" :class="{ on: s1ActiveTab === 'broker_stats' }" @click.stop="s1GoToSection('broker_stats'); c1TopTab = null"><span class="c1-fs-name">Broker Stats</span></div>
            <div class="c1-fs-card" style="--fsclr:#f43f5e" :class="{ on: s1ActiveTab === 'costs' }" @click.stop="s1GoToSection('costs'); c1TopTab = null"><span class="c1-fs-name">Costs</span></div>
            <div class="c1-fs-card" style="--fsclr:#10b981" :class="{ on: s1ActiveTab === 'daily_report' }" @click.stop="s1GoToSection('daily_report'); c1TopTab = null"><span class="c1-fs-name">Daily Report</span></div>
            <div class="c1-fs-card" style="--fsclr:#8b5cf6" :class="{ on: s1ActiveTab === 'total_stats' }" @click.stop="s1GoToSection('total_stats'); c1TopTab = null"><span class="c1-fs-name">Total Stats</span></div>
            <div class="c1-fs-card" style="--fsclr:#22d3ee" :class="{ on: s1ActiveTab === 'live' }" @click.stop="s1GoToSection('live'); c1TopTab = null"><span class="c1-fs-name">Live</span></div>
            <div class="c1-fs-card" style="--fsclr:#f97316" :class="{ on: s1ActiveTab === 'teams' }" @click.stop="s1GoToSection('teams'); c1TopTab = null"><span class="c1-fs-name">Teams</span></div>
          </div>
        </div>

        <!-- DATE DROPDOWN -->
        <div v-show="c1TopTab === 'date'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Date Range</div>
          <div class="s1-panel-date-pills" style="padding:0 8px 8px">
            <div v-for="tf in s1TimeFrames" :key="tf.key"
                 class="s1-panel-pill" :class="{ on: s1DateFilter === tf.key }"
                 @click.stop="s1ApplyDateFilter(tf.key); c1TopTab = null">{{ tf.label }}</div>
            <div class="s1-panel-pill s1-panel-pill-cal" :class="{ on: s1DateFilter === 'custom' || s1PanelCalOpen }"
                 @click.stop="s1PanelCalOpen = !s1PanelCalOpen">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;flex-shrink:0"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Custom
            </div>
          </div>
          <!-- Inline calendar -->
          <div v-if="s1PanelCalOpen || s1DateFilter === 'custom'" class="s1-panel-cal" style="padding:0 8px 8px">
            <div v-if="s1DateFilter === 'custom' && s1CalRangeFrom" class="s1-pcal-range-bar">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:10px;height:10px;flex-shrink:0;color:#0057ff"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <span class="s1-pcal-range-lbl">{{ s1CalRangeFrom }} → {{ s1CalRangeTo || '…' }}</span>
              <button class="s1-pcal-clear" @click.stop="s1CalClearRange">Clear</button>
            </div>
            <div v-else-if="s1CalSelecting" class="s1-pcal-hint">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:10px;height:10px;flex-shrink:0"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Click end date to complete range
            </div>
            <div class="s1-pcal-nav">
              <button class="s1-pcal-btn" @click.stop="s1CalPrev"><svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg></button>
              <span class="s1-pcal-month">{{ s1CalMonthNames[s1Cal.month] }} {{ s1Cal.year }}</span>
              <button class="s1-pcal-btn" @click.stop="s1CalNext"><svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg></button>
            </div>
            <div class="s1-pcal-grid">
              <div class="s1-pcal-dow-row">
                <div v-for="(d,di) in ['M','T','W','T','F','S','S']" :key="'pdow'+di" class="s1-pcal-dow">{{ d }}</div>
              </div>
              <div v-for="(week, wi) in s1CalGrid" :key="'pw'+wi" class="s1-pcal-week">
                <div v-for="day in week" :key="'pd'+day.date" class="s1-pcal-day"
                  :class="{ today: day.today, 'other-month': !day.inMonth, selected: day.date === s1CalRangeFrom || day.date === s1CalRangeTo, 'in-range': s1CalRangeFrom && s1CalRangeTo && day.date > s1CalRangeFrom && day.date < s1CalRangeTo, 'range-start': day.date === s1CalRangeFrom, 'range-end': day.date === s1CalRangeTo, 'has-data': day.hasData }"
                  @click.stop="s1CalSelectDay(day)">
                  <span class="s1-pcal-dn">{{ day.day }}</span>
                  <span v-if="day.reg" class="s1-pcal-dot"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- AGENT DROPDOWN -->
        <div v-show="c1TopTab === 'agent'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Team Filter</div>
          <div v-if="s1AgentFilter && s1AgentFilter.length" class="s1-af-chips" style="padding:0 8px 4px">
            <div v-for="id in s1AgentFilter" :key="'chip-'+id" class="s1-af-chip">
              <span>{{ s1AgentNameById(id) }}</span>
              <svg @click.stop="s1ToggleAgent(id); s1FetchAll()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="s1-af-search" style="margin:4px 8px 4px">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="s1-af-search-inp" v-model.trim="s1AgentSearch" placeholder="Search agent..." type="text" @click.stop />
            <div v-if="s1AgentSearch" class="s1-af-search-clr" @click.stop="s1AgentSearch = ''">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="s1-af-list" style="max-height:200px;overflow-y:auto;padding:0 8px">
            <div v-for="agent in s1AgentListFiltered" :key="agent.id"
                 class="s1-af-row" :class="{ on: s1AgentFilter.includes(agent.id) }"
                 @click.stop="s1ToggleAgent(agent.id); s1FetchAll()">
              <div class="s1-af-av" :class="{ on: s1AgentFilter.includes(agent.id) }">{{ s1AgentInitials(agent) }}</div>
              <span class="s1-af-nm">{{ s1AgentFullName(agent) }}</span>
              <div class="s1-af-chk" :class="{ on: s1AgentFilter.includes(agent.id) }">
                <svg v-if="s1AgentFilter.includes(agent.id)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
            </div>
            <div v-if="!s1AgentListFiltered.length" class="s1-af-empty">No agents found</div>
          </div>
          <div v-if="s1AgentFilter && s1AgentFilter.length" class="c1-reset-bar" style="margin:6px 8px 4px" @click.stop="s1AgentFilter = []; s1FetchAll(); c1TopTab = null">
            <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
            Clear agent filter
          </div>
        </div>

        <!-- CHARTS DROPDOWN -->
        <div v-show="c1TopTab === 'charts'" class="c1-ts-dropdown">
          <div class="c1-fs-section-lbl">Chart Sections</div>
          <div class="c1-fs-grid" style="padding:0 8px">
            <div class="c1-fs-card" style="--fsclr:#6366f1" :class="{ on: s1ActiveTab === 'today' }" @click.stop="s1GoToSection('today'); c1TopTab = null"><span class="c1-fs-name">Today</span></div>
            <div class="c1-fs-card" style="--fsclr:#3b82f6" :class="{ on: s1ActiveTab === 'hours' }" @click.stop="s1GoToSection('hours'); c1TopTab = null"><span class="c1-fs-name">Hours</span></div>
            <div class="c1-fs-card" style="--fsclr:#14b8a6" :class="{ on: s1ActiveTab === 'countries' }" @click.stop="s1GoToSection('countries'); c1TopTab = null"><span class="c1-fs-name">Countries</span></div>
            <div class="c1-fs-card" style="--fsclr:#ec4899" :class="{ on: s1ActiveTab === 'advertising' }" @click.stop="s1GoToSection('advertising'); c1TopTab = null"><span class="c1-fs-name">Campaigns</span></div>
            <div class="c1-fs-card" style="--fsclr:#64748b" :class="{ on: s1ActiveTab === 'timeline' }" @click.stop="s1GoToSection('timeline'); c1TopTab = null"><span class="c1-fs-name">Timeline</span></div>
            <div class="c1-fs-card" style="--fsclr:#22d3ee" :class="{ on: s1ActiveTab === 'live' }" @click.stop="s1GoToSection('live'); c1TopTab = null"><span class="c1-fs-name">Live</span></div>
          </div>
        </div>

        <div class="c1-nm-div"></div>
        <c1-mod-calendar :items="s1HistoryData" dateField="created_at" itemLabel="records" style="flex-shrink:0" />

      </div>
    </div><!-- /c1-top-strip -->

    <!-- Panel backdrop -->
    <transition name="c1-bd-fade">
      <div v-if="s1SlideOpen" class="c1-panel-backdrop" @click.stop="s1SlideOpen = null"></div>
    </transition>

    <!-- ======== UNIFIED RIGHT PANEL ======== -->
    <div class="c1-panel" :class="{ 'c1-panel--open': s1PanelIsOpen }" @click.capture="s1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': s1PanelAtContent }">

        <!-- SCREEN 0: NAV MENU -->
        <div class="c1-panel-screen">
          <!-- ── USER STRIP ── -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- ── TIMEZONE BAR ── -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="s1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="s1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- ── PANELS MODE ── -->
          <div v-else class="c1-sl-body" style="padding:0 0 12px">

            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>

            <!-- Date Range + Calendar -->
            <div class="s1-dr-block">
              <div class="c1-psel-grp-hdr" style="margin:0;padding:10px 14px 6px">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
                Date Range
              </div>
              <div class="s1-panel-date-pills">
                <div v-for="tf in s1TimeFrames" :key="tf.key"
                     class="s1-panel-pill" :class="{ on: s1DateFilter === tf.key }"
                     @click="s1ApplyDateFilter(tf.key)">{{ tf.label }}</div>
                <div class="s1-panel-pill s1-panel-pill-cal" :class="{ on: s1DateFilter === 'custom' || s1PanelCalOpen }"
                     @click.stop="s1PanelCalOpen = !s1PanelCalOpen">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;flex-shrink:0"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  Custom
                </div>
              </div>
              <!-- Inline calendar -->
              <div v-if="s1PanelCalOpen || s1DateFilter === 'custom'" class="s1-panel-cal">
                <div v-if="s1DateFilter === 'custom' && s1CalRangeFrom" class="s1-pcal-range-bar">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:10px;height:10px;flex-shrink:0;color:#0057ff"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  <span class="s1-pcal-range-lbl">{{ s1CalRangeFrom }} → {{ s1CalRangeTo || '…' }}</span>
                  <button class="s1-pcal-clear" @click.stop="s1CalClearRange">Clear</button>
                </div>
                <div v-else-if="s1CalSelecting" class="s1-pcal-hint">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:10px;height:10px;flex-shrink:0"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  Click end date to complete range
                </div>
                <div class="s1-pcal-nav">
                  <button class="s1-pcal-btn" @click.stop="s1CalPrev"><svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg></button>
                  <span class="s1-pcal-month">{{ s1CalMonthNames[s1Cal.month] }} {{ s1Cal.year }}</span>
                  <button class="s1-pcal-btn" @click.stop="s1CalNext"><svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg></button>
                </div>
                <div class="s1-pcal-grid">
                  <div class="s1-pcal-dow-row">
                    <div v-for="(d,di) in ['M','T','W','T','F','S','S']" :key="'pdow'+di" class="s1-pcal-dow">{{ d }}</div>
                  </div>
                  <div v-for="(week, wi) in s1CalGrid" :key="'pw'+wi" class="s1-pcal-week">
                    <div v-for="day in week" :key="'pd'+day.date" class="s1-pcal-day"
                      :class="{ today: day.today, 'other-month': !day.inMonth, selected: day.date === s1CalRangeFrom || day.date === s1CalRangeTo, 'in-range': s1CalRangeFrom && s1CalRangeTo && day.date > s1CalRangeFrom && day.date < s1CalRangeTo, 'range-start': day.date === s1CalRangeFrom, 'range-end': day.date === s1CalRangeTo, 'has-data': day.hasData }"
                      @click.stop="s1CalSelectDay(day)">
                      <span class="s1-pcal-dn">{{ day.day }}</span>
                      <span v-if="day.reg" class="s1-pcal-dot"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="c1-psel-divider" style="margin:0 0 0"></div>

            <!-- ===== AGENT FILTER (TOP, COLLAPSIBLE) ===== -->
            <div class="s1-af-block">
              <!-- Header row — click to toggle expand -->
              <div class="s1-af-hdr" @click.stop="s1AgentBlockOpen = !s1AgentBlockOpen">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0;color:#7c3aed"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                <span class="s1-af-ttl">Team Filter</span>
                <span v-if="s1AgentFilter.length" class="s1-af-count-badge">{{ s1AgentFilter.length }}</span>
                <div class="c1-hp"></div>
                <span v-if="s1AgentFilter.length" class="s1-af-clear-btn" @click.stop="s1AgentFilter = []; s1FetchAll()">Clear</span>
                <svg class="s1-af-chevron" :class="{ open: s1AgentBlockOpen }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>
              </div>

              <!-- Chips: always visible when agents selected -->
              <div v-if="s1AgentFilter.length" class="s1-af-chips">
                <div v-for="id in s1AgentFilter" :key="'chip-'+id" class="s1-af-chip">
                  <span>{{ s1AgentNameById(id) }}</span>
                  <svg @click.stop="s1ToggleAgent(id); s1FetchAll()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </div>
              </div>

              <!-- Expandable: search + list -->
              <div v-if="s1AgentBlockOpen" class="s1-af-expanded">
                <div class="s1-af-search">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                  <input class="s1-af-search-inp" v-model.trim="s1AgentSearch" placeholder="Search agent..." type="text" />
                  <div v-if="s1AgentSearch" class="s1-af-search-clr" @click.stop="s1AgentSearch = ''">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </div>
                </div>
                <div class="s1-af-list">
                  <div v-for="agent in s1AgentListFiltered" :key="agent.id"
                       class="s1-af-row" :class="{ on: s1AgentFilter.includes(agent.id) }"
                       @click.stop="s1ToggleAgent(agent.id); s1FetchAll()">
                    <div class="s1-af-av" :class="{ on: s1AgentFilter.includes(agent.id) }">{{ s1AgentInitials(agent) }}</div>
                    <span class="s1-af-nm">{{ s1AgentFullName(agent) }}</span>
                    <div class="s1-af-chk" :class="{ on: s1AgentFilter.includes(agent.id) }">
                      <svg v-if="s1AgentFilter.includes(agent.id)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                  </div>
                  <div v-if="!s1AgentListFiltered.length" class="s1-af-empty">No agents found</div>
                </div>
              </div>
            </div>

            <div class="c1-psel-divider" style="margin:0 0 4px"></div>

            <!-- Statistics sections group -->
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              Statistics
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'today' }" @click.stop="s1GoToSection('today')">
              <span class="c1-psel-sub-dot" style="background:#6366f1"></span>
              <span class="c1-psel-sub-lbl">Today</span>
              <svg v-if="s1ActiveTab === 'today'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'akg' }" @click.stop="s1GoToSection('akg')">
              <span class="c1-psel-sub-dot" style="background:#7c3aed"></span>
              <span class="c1-psel-sub-lbl">AKG Report</span>
              <svg v-if="s1ActiveTab === 'akg'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'deposits' }" @click.stop="s1GoToSection('deposits')">
              <span class="c1-psel-sub-dot" style="background:#00b67a"></span>
              <span class="c1-psel-sub-lbl">Deposits</span>
              <svg v-if="s1ActiveTab === 'deposits'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'leads' }" @click.stop="s1GoToSection('leads')">
              <span class="c1-psel-sub-dot" style="background:#f59e0b"></span>
              <span class="c1-psel-sub-lbl">Leads</span>
              <svg v-if="s1ActiveTab === 'leads'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'noanswer' }" @click.stop="s1GoToSection('noanswer')">
              <span class="c1-psel-sub-dot" style="background:#ef4444"></span>
              <span class="c1-psel-sub-lbl">No Answer</span>
              <svg v-if="s1ActiveTab === 'noanswer'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'scheduled' }" @click.stop="s1GoToSection('scheduled')">
              <span class="c1-psel-sub-dot" style="background:#f97316"></span>
              <span class="c1-psel-sub-lbl">Scheduled</span>
              <svg v-if="s1ActiveTab === 'scheduled'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'transfers' }" @click.stop="s1GoToSection('transfers')">
              <span class="c1-psel-sub-dot" style="background:#8b5cf6"></span>
              <span class="c1-psel-sub-lbl">Transfers</span>
              <svg v-if="s1ActiveTab === 'transfers'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'referrals' }" @click.stop="s1GoToSection('referrals')">
              <span class="c1-psel-sub-dot" style="background:#a855f7"></span>
              <span class="c1-psel-sub-lbl">Referrals</span>
              <svg v-if="s1ActiveTab === 'referrals'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'bad_number' }" @click.stop="s1GoToSection('bad_number')">
              <span class="c1-psel-sub-dot" style="background:#78716c"></span>
              <span class="c1-psel-sub-lbl">Bad Number</span>
              <svg v-if="s1ActiveTab === 'bad_number'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'not_interested' }" @click.stop="s1GoToSection('not_interested')">
              <span class="c1-psel-sub-dot" style="background:#b45309"></span>
              <span class="c1-psel-sub-lbl">Not Interested</span>
              <svg v-if="s1ActiveTab === 'not_interested'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'assignments' }" @click.stop="s1GoToSection('assignments')">
              <span class="c1-psel-sub-dot" style="background:#0057ff"></span>
              <span class="c1-psel-sub-lbl">Assignments</span>
              <svg v-if="s1ActiveTab === 'assignments'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'countries' }" @click.stop="s1GoToSection('countries')">
              <span class="c1-psel-sub-dot" style="background:#14b8a6"></span>
              <span class="c1-psel-sub-lbl">Countries</span>
              <svg v-if="s1ActiveTab === 'countries'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'hours' }" @click.stop="s1GoToSection('hours')">
              <span class="c1-psel-sub-dot" style="background:#3b82f6"></span>
              <span class="c1-psel-sub-lbl">Hours</span>
              <svg v-if="s1ActiveTab === 'hours'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'advertising' }" @click.stop="s1GoToSection('advertising')">
              <span class="c1-psel-sub-dot" style="background:#ec4899"></span>
              <span class="c1-psel-sub-lbl">Campaigns</span>
              <svg v-if="s1ActiveTab === 'advertising'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'timeline' }" @click.stop="s1GoToSection('timeline')">
              <span class="c1-psel-sub-dot" style="background:#64748b"></span>
              <span class="c1-psel-sub-lbl">Timeline</span>
              <svg v-if="s1ActiveTab === 'timeline'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'live' }" @click.stop="s1GoToSection('live')">
              <span class="c1-live-dot" style="display:inline-block;flex-shrink:0"></span>
              <span class="c1-psel-sub-lbl">Live</span>
              <svg v-if="s1ActiveTab === 'live'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            
            <div class="c1-psel-divider" style="margin:4px 0"></div>

            <!-- ===== ADVANCED REPORTS GROUP ===== -->
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
              Reports
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'campaign_stats' }" @click.stop="s1GoToSection('campaign_stats')">
              <span class="c1-psel-sub-dot" style="background:#06b6d4"></span>
              <span class="c1-psel-sub-lbl">Campaign Stats</span>
              <svg v-if="s1ActiveTab === 'campaign_stats'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'broker_stats' }" @click.stop="s1GoToSection('broker_stats')">
              <span class="c1-psel-sub-dot" style="background:#0ea5e9"></span>
              <span class="c1-psel-sub-lbl">Broker Stats</span>
              <svg v-if="s1ActiveTab === 'broker_stats'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'costs' }" @click.stop="s1GoToSection('costs')">
              <span class="c1-psel-sub-dot" style="background:#f43f5e"></span>
              <span class="c1-psel-sub-lbl">Costs</span>
              <svg v-if="s1ActiveTab === 'costs'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'daily_report' }" @click.stop="s1GoToSection('daily_report')">
              <span class="c1-psel-sub-dot" style="background:#10b981"></span>
              <span class="c1-psel-sub-lbl">Daily Report</span>
              <svg v-if="s1ActiveTab === 'daily_report'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: s1ActiveTab === 'total_stats' }" @click.stop="s1GoToSection('total_stats')">
              <span class="c1-psel-sub-dot" style="background:#8b5cf6"></span>
              <span class="c1-psel-sub-lbl">Total Stats</span>
              <svg v-if="s1ActiveTab === 'total_stats'" class="c1-psel-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>

            <div class="c1-psel-divider"></div>


          </div><!-- end v-else panels -->
        </div>

        <!-- SCREEN 1: unused -->
        <div class="c1-panel-screen"></div>
      </div><!-- /c1-panel-track -->
    </div><!-- /c1-panel -->

    <!-- LOADING BAR -->
    <div v-if="s1Loading" class="s1-loading-bar"><div class="s1-loading-fill"></div></div>

    <!-- ERROR BANNER -->
    <div v-if="s1Error" class="s1-error-banner">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
      {{ s1Error }}
      <button @click="s1FetchAll">Retry</button>
    </div>

    <!-- MAIN BODY -->
    <div class="c1-body" :class="{ 's1-body-panel-open': s1PanelIsOpen }">
      <div class="s1-body-inner">

      <!-- TITLE ROW -->
      <div class="s1-title-row">
        <div class="s1-title-main">Statistics</div>
        <span class="s1-active-range-badge">{{ s1ActiveRangeLabel }}</span>
        <span v-if="s1AgentFilter.length" class="s1-active-agent-badge">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:10px;height:10px"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
          {{ s1AgentFilter.length }} agent{{ s1AgentFilter.length > 1 ? 's' : '' }}
          <span class="s1-badge-x" @click="s1AgentFilter = []; s1FetchAll()">×</span>
        </span>
        <div class="c1-hp"></div>
        <button class="s1-refresh-btn" @click="s1FetchAll" :disabled="s1Loading">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" :class="{ 's1-spin': s1Loading }"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.87"/></svg>
          Refresh
        </button>
      </div>

      <!-- TAB PANELS -->
      <div class="s1-tab-panels">

        <div v-if="s1ActiveTab === 'today'" class="s1-tab-panel">
        <!-- KPI HERO ROW -->
        <div class="s1-kpi-hero-wrap">
          <div class="s1-kpi-today-badge">TODAY LIVE</div>
          <div class="s1-kpi-hero">
            <div class="s1-kpi-hero-card" v-for="kpi in s1KpiCards" :key="kpi.key">
              <div class="s1-kpi-hero-top">
                <div class="s1-kpi-hero-dot" :style="{ background: kpi.color }"></div>
                <div class="s1-kpi-hero-lbl">{{ kpi.label }}</div>
              </div>
              <div class="s1-kpi-hero-num" :style="{ color: kpi.color }">{{ kpi.value }}</div>
              <div class="s1-kpi-hero-sub" v-if="kpi.sub">{{ kpi.sub }}</div>
              <div class="s1-kpi-hero-bar">
                <div class="s1-kpi-hero-bar-fill" :style="{ width: kpi.pct + '%', background: kpi.color + '33' }">
                  <div class="s1-kpi-hero-bar-inner" :style="{ width: (kpi.pct > 0 ? '100%' : '0'), background: kpi.color }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Deposit Goals -->
        <div class="s1-goals-wrap">
          <div class="s1-goals-hdr">
            <span class="s1-goals-title">Deposit Goals</span>
            <span class="s1-goals-edit-btn" @click="s1GoalsEditMode = !s1GoalsEditMode">{{ s1GoalsEditMode ? 'Done' : 'Edit' }}</span>
          </div>
          <div class="s1-goals-grid">
            <div v-for="g in s1Goals" :key="g.period" class="s1-goal-card">
              <div class="s1-goal-period">{{ g.period.charAt(0).toUpperCase() + g.period.slice(1) }}</div>
              <div class="s1-goal-bar-wrap">
                <div class="s1-goal-bar" :style="{ width: Math.min(100, g.pct) + '%', background: g.pct >= 80 ? '#00b67a' : g.pct >= 50 ? '#f59e0b' : '#ef4444' }"></div>
              </div>
              <div class="s1-goal-nums">
                <span class="s1-goal-actual">{{ g.actual || 0 }}</span>
                <span class="s1-goal-sep"> / </span>
                <span class="s1-goal-target">{{ g.target || '—' }}</span>
              </div>
              <div class="s1-goal-pct" :style="{ color: g.pct >= 80 ? '#00b67a' : g.pct >= 50 ? '#f59e0b' : '#ef4444' }">{{ g.pct || 0 }}%</div>
              <div v-if="s1GoalsEditMode" class="s1-goal-edit">
                <input class="s1-goal-input" type="number" v-model.number="g.editTarget" :placeholder="g.target || 'Set goal'" min="0" />
                <button class="s1-goal-save" @click="s1SaveGoal(g)">Save</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Agent Rankings -->
        <div class="s1-transfer-wrap">
          <div class="s1-section-hdr" style="margin:0 0 10px;padding:0;border:none;"><span>Agent Rankings</span></div>
          <div v-if="s1TransferLoading" class="s1-empty-state">Loading...</div>
          <div v-else-if="!s1TransferRecs.length" class="s1-empty-state">No ranking data available</div>
          <div v-else class="s1-transfer-list">
            <div v-for="(agent, i) in s1TransferRecs.slice(0,8)" :key="i" class="s1-transfer-row">
              <span class="s1-transfer-rank" :style="i < 3 ? 'color:#00b67a' : (i > s1TransferRecs.length - 3 ? 'color:#ef4444' : 'color:#64748b')">#{{ i+1 }}</span>
              <span class="s1-transfer-name">{{ agent.name || agent.agent_name || agent.username || ('Agent ' + (agent.agent_id || i)) }}</span>
              <span class="s1-transfer-deps">{{ agent.deposits_count || agent.total || agent.count || 0 }} dep</span>
            </div>
          </div>
        </div>

        <div class="s1-section-hdr">
          <span>Today's 11-Metric Breakdown</span>
          <span class="s1-section-hint">Hover bars for details</span>
        </div>
        <div class="s1-today-chart">
          <div v-for="bar in s1TodayBarsComputed" :key="'tb-'+bar.key" class="s1-tc-row"
            @mouseenter="s1TooltipShow($event, bar.label + ': ' + bar.val)"
            @mouseleave="s1TooltipHide">
            <div class="s1-tc-lbl">{{ bar.key }}</div>
            <div class="s1-tc-track">
              <div class="s1-tc-fill" :style="{ width: bar.pct + '%', background: bar.color }">
                <span v-if="bar.pct > 12" class="s1-tc-inline-val">{{ bar.val }}</span>
              </div>
              <span v-if="bar.pct <= 12 && bar.val > 0" class="s1-tc-out-val">{{ bar.val }}</span>
            </div>
          </div>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'deposits'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Deposits</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: s1DepView === 'broker' }"   @click="s1DepView = 'broker'">By Broker</div>
            <div class="s1-toggle-btn" :class="{ on: s1DepView === 'agent' }"    @click="s1DepView = 'agent'">By Agent</div>
            <div class="s1-toggle-btn" :class="{ on: s1DepView === 'status' }"   @click="s1DepView = 'status'">By Status</div>
            <div class="s1-toggle-btn" :class="{ on: s1DepView === 'quantity' }" @click="s1DepView = 'quantity'">By Quantity</div>
          </div>
        </div>
        <div class="s1-table-hdr"><span>Name</span><span>Count</span><span>%</span></div>
        <div v-show="s1DepView === 'broker'" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1DepBrokers">
          <div :key="'db-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'dep_broker') }"
            @mouseenter="s1TooltipShow($event, s1DepTooltip(item))" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'dep_broker')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'dep_broker') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-dp" :style="{ width: s1DepBrokerPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ (Array.isArray(item.count)?item.count[0]:item.count)||0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct((Array.isArray(item.count)?item.count[0]:item.count)||0, s1DepBrokerTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'dep_broker')" :key="'db-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1DepBrokers.length" class="s1-empty-state"><div v-if="s1LoadingDeposits" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1DepBrokers.length" class="s1-table-total"><span>Total</span><span>{{ s1DepBrokerTotal }}</span><span>100%</span></div>
        </div>
        <div v-show="s1DepView === 'agent'" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1DepUsers">
          <div :key="'du-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'dep_user') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||'')+': '+((Array.isArray(item.count)?item.count[0]:item.count)||0))" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'dep_user')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'dep_user') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-dp" :style="{ width: s1DepUserPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ (Array.isArray(item.count)?item.count[0]:item.count)||0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct((Array.isArray(item.count)?item.count[0]:item.count)||0, s1DepUserTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'dep_user')" :key="'du-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1DepUsers.length" class="s1-empty-state"><div v-if="s1LoadingDeposits" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1DepUsers.length" class="s1-table-total"><span>Total</span><span>{{ s1DepUserTotal }}</span><span>100%</span></div>
        </div>
        <div v-show="s1DepView === 'status'" class="s1-hbar-list">
          <div v-for="item in s1DepStatus" :key="'ds-'+item.id" class="s1-hbar-row"
            @mouseenter="s1TooltipShow($event, (item.title||item.status||'—')+': '+(item.clients_count||item.count||0))" @mouseleave="s1TooltipHide">
            <div class="s1-hbar-lbl">{{ item.title || item.status || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-dp" :style="{ width: s1DepStatusPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.clients_count || item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.clients_count||item.count||0, s1DepStatusTotal) }}%</div>
          </div>
          <div v-if="!s1DepStatus.length" class="s1-empty-state"><div v-if="s1LoadingDeposits" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1DepStatus.length" class="s1-table-total"><span>Total</span><span>{{ s1DepStatusTotal }}</span><span>100%</span></div>
        </div>
        <div v-show="s1DepView === 'quantity'" class="s1-hbar-list">
          <div v-for="item in s1DepQuantity" :key="'dq-'+item.id" class="s1-hbar-row"
            @mouseenter="s1TooltipShow($event, (item.title||item.id+' Brokers')+': '+((Array.isArray(item.count)?item.count[0]:item.count)||0))" @mouseleave="s1TooltipHide">
            <div class="s1-hbar-lbl">{{ item.title || (item.id + ' Brokers') }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-dp" :style="{ width: s1DepQuantityPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ (Array.isArray(item.count)?item.count[0]:item.count)||0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct((Array.isArray(item.count)?item.count[0]:item.count)||0, s1DepQuantityTotal) }}%</div>
          </div>
          <div v-if="!s1DepQuantity.length" class="s1-empty-state"><div v-if="s1LoadingDeposits" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1DepQuantity.length" class="s1-table-total"><span>Total</span><span>{{ s1DepQuantityTotal }}</span><span>100%</span></div>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'leads'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Leads Breakdown</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: s1LeadsView === 'broker' }" @click="s1LeadsView = 'broker'">By Broker</div>
            <div class="s1-toggle-btn" :class="{ on: s1LeadsView === 'agent' }"  @click="s1LeadsView = 'agent'">By Agent</div>
          </div>
        </div>
        <div class="s1-table-hdr"><span>Name</span><span>Count</span><span>%</span></div>
        <div v-show="s1LeadsView === 'broker'" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1LeadsBrokers">
          <div :key="'lb-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'lead_broker') }"
            @mouseenter="s1TooltipShow($event, item.title+': '+item.count)" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'lead_broker')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'lead_broker') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-ld" :style="{ width: s1LeadsBrokerPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1LeadsBrokerTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'lead_broker')" :key="'lb-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1LeadsBrokers.length" class="s1-empty-state"><div v-if="s1LoadingLeads" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1LeadsBrokers.length" class="s1-table-total"><span>Total</span><span>{{ s1LeadsBrokerTotal }}</span><span>100%</span></div>
        </div>
        <div v-show="s1LeadsView === 'agent'" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1LeadsUsers">
          <div :key="'lu-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'lead_user') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name)+': '+item.count)" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'lead_user')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'lead_user') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-sc" :style="{ width: s1LeadsUserPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1LeadsUserTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'lead_user')" :key="'lu-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1LeadsUsers.length" class="s1-empty-state"><div v-if="s1LoadingLeads" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1LeadsUsers.length" class="s1-table-total"><span>Total</span><span>{{ s1LeadsUserTotal }}</span><span>100%</span></div>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'noanswer'" class="s1-tab-panel">
        <div class="s1-section-hdr"><span>No Answer — by Agent</span></div>
        <div class="s1-table-hdr"><span>Agent</span><span>Count</span><span>%</span></div>
        <div v-if="s1NAUsers.length" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1NAUsers">
          <div :key="'na-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'na_user') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name)+': '+item.count+' NA')" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'na_user')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'na_user') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-na" :style="{ width: s1NAUserPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1NATotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'na_user')" :key="'na-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div class="s1-table-total"><span>Total</span><span>{{ s1NATotal }}</span><span>100%</span></div>
        </div>
        <div v-else class="s1-empty-state"><div v-if="s1LoadingNA" class="c1-spinner"></div><span v-else>No data</span></div>
        </div>

        <div v-if="s1ActiveTab === 'scheduled'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Scheduled Calls</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: s1ScView === 'agent' }"    @click="s1ScView = 'agent'">By Agent</div>
            <div class="s1-toggle-btn" :class="{ on: s1ScView === 'reason' }"   @click="s1ScView = 'reason'">By Reason</div>
            <div class="s1-toggle-btn" :class="{ on: s1ScView === 'priority' }" @click="s1ScView = 'priority'">By Priority</div>
          </div>
        </div>
        <div class="s1-table-hdr"><span>Name</span><span>Count</span><span>%</span></div>
        <div v-show="s1ScView === 'agent'" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1SCUsers">
          <div :key="'sc-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'sc_user') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name)+': '+item.count)" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'sc_user')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'sc_user') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-sc2" :style="{ width: s1SCUserPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1SCTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'sc_user')" :key="'sc-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1SCUsers.length" class="s1-empty-state"><div v-if="s1LoadingSC" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1SCUsers.length" class="s1-table-total"><span>Total</span><span>{{ s1SCTotal }}</span><span>100%</span></div>
        </div>
        <div v-show="s1ScView === 'reason'" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1SCReasons">
          <div :key="'scr-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'sc_reason') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||item.status||'—')+': '+(item.count||0))" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'sc_reason')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'sc_reason') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name || item.status || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-sc2" :style="{ width: s1SCReasonsPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1SCReasonsTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'sc_reason')" :key="'scr-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1SCReasons.length" class="s1-empty-state"><div v-if="s1LoadingSC" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1SCReasons.length" class="s1-table-total"><span>Total</span><span>{{ s1SCReasonsTotal }}</span><span>100%</span></div>
        </div>
        <div v-show="s1ScView === 'priority'" class="s1-hbar-list">
          <div v-for="item in s1CAPriority" :key="'cap-'+item.id" class="s1-hbar-row"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||item.priority||'—')+': '+(item.count||0))" @mouseleave="s1TooltipHide">
            <div class="s1-hbar-lbl">{{ item.title || item.name || item.priority || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-sc2" :style="{ width: s1CAPriorityPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1CAPriorityTotal) }}%</div>
          </div>
          <div v-if="!s1CAPriority.length" class="s1-empty-state"><div v-if="s1LoadingSC" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1CAPriority.length" class="s1-table-total"><span>Total</span><span>{{ s1CAPriorityTotal }}</span><span>100%</span></div>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'transfers'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Transfers</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: s1TransferView === 'lv' }"   @click="s1TransferView = 'lv'">TR-Live</div>
            <div class="s1-toggle-btn" :class="{ on: s1TransferView === 'on' }"   @click="s1TransferView = 'on'">TR-Online</div>
            <div class="s1-toggle-btn" :class="{ on: s1TransferView === 'type' }" @click="s1TransferView = 'type'">By Type</div>
          </div>
        </div>
        <div class="s1-table-hdr"><span>Name</span><span>Count</span><span>%</span></div>
        <div v-show="s1TransferView === 'lv'" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1TransferUsersLV">
          <div :key="'trlv-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'tr_lv') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||'—')+': '+(item.count||0)+' TR-LV')" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'tr_lv')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'tr_lv') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name || item.full_name || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-tr-lv" :style="{ width: s1TrLVPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1TrLVTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'tr_lv')" :key="'trlv-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1TransferUsersLV.length" class="s1-empty-state"><div v-if="s1LoadingTransfers" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1TransferUsersLV.length" class="s1-table-total"><span>Total</span><span>{{ s1TrLVTotal }}</span><span>100%</span></div>
        </div>
        <div v-show="s1TransferView === 'on'" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1TransferUsersON">
          <div :key="'tron-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'tr_on') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||'—')+': '+(item.count||0)+' TR-ON')" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'tr_on')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'tr_on') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name || item.full_name || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-tr-on" :style="{ width: s1TrONPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1TrONTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'tr_on')" :key="'tron-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1TransferUsersON.length" class="s1-empty-state"><div v-if="s1LoadingTransfers" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1TransferUsersON.length" class="s1-table-total"><span>Total</span><span>{{ s1TrONTotal }}</span><span>100%</span></div>
        </div>
        <div v-show="s1TransferView === 'type'" class="s1-hbar-list">
          <div v-for="item in s1TransferTypes" :key="'trtype-'+item.id" class="s1-hbar-row"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||item.type||'—')+': '+(item.count||0))" @mouseleave="s1TooltipHide">
            <div class="s1-hbar-lbl">{{ item.title || item.name || item.type || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-tr-lv" :style="{ width: Math.round((item.count||0)/Math.max(...s1TransferTypes.map(t=>t.count||0),1)*100) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1TransferTypes.reduce((s,t)=>s+(t.count||0),0)||1) }}%</div>
          </div>
          <div v-if="!s1TransferTypes.length" class="s1-empty-state"><div v-if="s1LoadingTransfers" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1TransferTypes.length" class="s1-table-total"><span>Total</span><span>{{ s1TransferTypes.reduce((s,t)=>s+(t.count||0),0) }}</span><span>100%</span></div>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'referrals'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Referrals</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: !s1RefView }"            @click="s1RefView = false">By Broker</div>
            <div class="s1-toggle-btn" :class="{ on: s1RefView === 'agent' }" @click="s1RefView = 'agent'">By Agent</div>
          </div>
        </div>
        <div class="s1-table-hdr"><span>Name</span><span>Count</span><span>%</span></div>
        <div v-show="!s1RefView" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1ReferralBrokers">
          <div :key="'rfb-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'ref_broker') }"
            @mouseenter="s1TooltipShow($event, (item.title||'—')+': '+(item.count||0)+' referrals')"
            @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'ref_broker')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'ref_broker') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-rf" :style="{ width: s1RefBrokerPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1RefBrokerTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'ref_broker')" :key="'rfb-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1ReferralBrokers.length" class="s1-empty-state"><div v-if="s1LoadingReferrals" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1ReferralBrokers.length" class="s1-table-total"><span>Total</span><span>{{ s1RefBrokerTotal }}</span><span>100%</span></div>
        </div>
        <div v-show="s1RefView === 'agent'" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1ReferralUsers">
          <div :key="'rfu-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'ref_user') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||'—')+': '+(item.count||0)+' referrals')" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'ref_user')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'ref_user') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-rf" :style="{ width: s1RefUserPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1RefUserTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'ref_user')" :key="'rfu-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1ReferralUsers.length" class="s1-empty-state"><div v-if="s1LoadingReferrals" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1ReferralUsers.length" class="s1-table-total"><span>Total</span><span>{{ s1RefUserTotal }}</span><span>100%</span></div>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'bad_number'" class="s1-tab-panel">
        <div class="s1-section-hdr"><span>Bad Number — by Reason</span></div>
        <div class="s1-table-hdr"><span>Reason</span><span>Count</span><span>%</span></div>
        <div v-if="s1BNReasons.length" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1BNReasons">
          <div :key="'bn-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'bn') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||item.status||'—')+': '+(item.count||0))" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'bn')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'bn') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name || item.status || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-bn" :style="{ width: s1BNPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1BNTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'bn')" :key="'bn-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div class="s1-table-total"><span>Total</span><span>{{ s1BNTotal }}</span><span>100%</span></div>
        </div>
        <div v-else class="s1-empty-state"><div v-if="s1LoadingBN" class="c1-spinner"></div><span v-else>No data</span></div>
        </div>

        <div v-if="s1ActiveTab === 'not_interested'" class="s1-tab-panel">
        <div class="s1-section-hdr"><span>Not Interested — by Reason</span></div>
        <div class="s1-table-hdr"><span>Reason</span><span>Count</span><span>%</span></div>
        <div v-if="s1NIReasons.length" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1NIReasons">
          <div :key="'ni-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'ni') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||item.status||'—')+': '+(item.count||0))" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'ni')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'ni') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name || item.status || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-ni" :style="{ width: s1NIPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1NITotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'ni')" :key="'ni-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div class="s1-table-total"><span>Total</span><span>{{ s1NITotal }}</span><span>100%</span></div>
        </div>
        <div v-else class="s1-empty-state"><div v-if="s1LoadingNI" class="c1-spinner"></div><span v-else>No data</span></div>
        </div>

        <div v-if="s1ActiveTab === 'assignments'" class="s1-tab-panel">
        <div class="s1-section-hdr"><span>Assignments — by Agent</span></div>
        <div class="s1-table-hdr"><span>Agent</span><span>Count</span><span>%</span></div>
        <div v-if="s1AssignUsers.length" class="s1-hbar-list">
          <template v-for="(item, _ii) in s1AssignUsers">
          <div :key="'as-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'assign') }"
            @mouseenter="s1TooltipShow($event, (item.title||item.name||item.full_name||'—')+': '+(item.count||0)+' assignments')" @mouseleave="s1TooltipHide" @click="s1ToggleDrill(item, 'assign')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'assign') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || item.name || item.full_name || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-assign" :style="{ width: s1AssignPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ item.count || 0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct(item.count||0, s1AssignTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'assign')" :key="'as-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <div class="s1-dil-col">
                <div class="s1-dil-title">Status Breakdown</div>
                <div v-if="s1Drill && s1Drill.loadingExpand" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!s1DrillExpRows.length" class="s1-dil-empty">No breakdown data</div>
                <div v-else v-for="row in s1DrillExpRows" :key="'e-'+row.key" class="s1-dil-row">
                  <span class="s1-dil-lbl">{{ row.label }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: row.pct+'%', background: row.color }"></div></div>
                  <span class="s1-dil-num">{{ row.val }}</span>
                  <span class="s1-dil-pct">{{ row.pct }}%</span>
                </div>
              </div>
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'p-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'pi'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div class="s1-table-total"><span>Total</span><span>{{ s1AssignTotal }}</span><span>100%</span></div>
        </div>
        <div v-else class="s1-empty-state"><div v-if="s1LoadingAssign" class="c1-spinner"></div><span v-else>No data</span></div>
        </div>

        <div v-if="s1ActiveTab === 'akg'" class="s1-tab-panel s1-akg-panel">
        <div class="s1-section-hdr">
          <span>AKG Daily Report</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: s1AkgTimeFrame === 7 }"  @click="s1FetchAkg(7)">7 Days</div>
            <div class="s1-toggle-btn" :class="{ on: s1AkgTimeFrame === 30 }" @click="s1FetchAkg(30)">30 Days</div>
            <div class="s1-toggle-btn" :class="{ on: s1AkgTimeFrame === 90 }" @click="s1FetchAkg(90)">90 Days</div>
          </div>
        </div>
        <div v-if="s1LoadingAkg" class="s1-empty-state"><div class="c1-spinner"></div></div>
        <div v-else-if="!s1AkgRows.length" class="s1-empty-state"><span>No AKG data</span></div>
        <div v-else class="s1-akg-wrap">
          <table class="s1-akg-table">
            <thead>
              <tr>
                <th class="s1-akg-th s1-akg-date-col">Date</th>
                <th v-for="col in s1AkgCols" :key="'akgh-'+col.key" class="s1-akg-th" :style="{ color: col.color }">{{ col.label }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, ri) in s1AkgRows">
              <tr :key="'akgr-'+ri" class="s1-akg-tr s1-akg-tr-clickable" @click="s1AkgToggleDay(row.date)">
                <td class="s1-akg-td s1-akg-date-col">
                  <span class="s1-akg-expand-ico">{{ s1AkgExpand[row.date] && s1AkgExpand[row.date].open ? '▾' : '▸' }}</span>
                  {{ row.date }}
                </td>
                <td v-for="col in s1AkgCols" :key="'akgc-'+col.key" class="s1-akg-td s1-akg-num"
                  :class="{ 's1-akg-zero': !s1AkgCellVal(row, col.key) || s1AkgCellVal(row, col.key) === '—' }"
                  :style="{ color: (s1AkgCellVal(row, col.key) && s1AkgCellVal(row, col.key) !== '—') ? col.color : '' }">
                  {{ s1AkgCellVal(row, col.key) }}
                </td>
              </tr>
              <!-- Expanded user breakdown rows -->
              <template v-if="s1AkgExpand[row.date] && s1AkgExpand[row.date].open">
                <tr v-if="s1AkgExpand[row.date].loading" :key="'akgexp-load-'+ri">
                  <td :colspan="s1AkgCols.length + 1" class="s1-akg-td s1-akg-exp-loading">
                    <div class="c1-spinner" style="width:14px;height:14px;margin:4px auto"></div>
                  </td>
                </tr>
                <tr v-else-if="!s1AkgExpand[row.date].users || !s1AkgExpand[row.date].users.length" :key="'akgexp-empty-'+ri">
                  <td :colspan="s1AkgCols.length + 1" class="s1-akg-td s1-akg-exp-empty">No user data for this date</td>
                </tr>
                <tr v-else v-for="(u, ui) in s1AkgExpand[row.date].users" :key="'akgexp-'+ri+'-'+ui" class="s1-akg-user-row">
                  <td class="s1-akg-td s1-akg-date-col s1-akg-user-name-col">
                    <span class="s1-akg-user-av">{{ s1AkgUserInitials(u.name) }}</span>
                    {{ u.name }}
                  </td>
                  <td v-for="col in s1AkgCols" :key="'akgusr-'+col.key" class="s1-akg-td s1-akg-num"
                    :class="{ 's1-akg-zero': !u[col.key] }"
                    :style="{ color: u[col.key] ? col.color : '' }">
                    {{ u[col.key] || '—' }}
                  </td>
                </tr>
              </template>
              </template>
            </tbody>
            <tfoot>
              <tr class="s1-akg-total-row">
                <td class="s1-akg-td s1-akg-date-col">TOTAL</td>
                <td v-for="col in s1AkgCols" :key="'akgt-'+col.key" class="s1-akg-td s1-akg-num s1-akg-total-cell"
                  :style="{ color: col.color }">
                  {{ s1AkgTotals[col.key] || 0 }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'countries'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Countries</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: s1CountriesView === 'country' }" @click="s1CountriesView = 'country'">By Country</div>
            <div class="s1-toggle-btn" :class="{ on: s1CountriesView === 'tier' }"    @click="s1CountriesView = 'tier'">By Tier</div>
            <div class="s1-toggle-btn" :class="{ on: s1CountriesView === 'region' }"  @click="s1CountriesView = 'region'">By Region</div>
          </div>
        </div>
        <div class="s1-table-hdr"><span>Name</span><span>Count</span><span>%</span></div>
        <div class="s1-hbar-list">
          <template v-for="(item, _ci) in s1CountriesActive">
          <div :key="'cnt-'+item.id" class="s1-hbar-row" :class="{ 's1-hbar-row--open': s1IsDrillOpen(item,'country') }"
            @mouseenter="s1TooltipShow($event, (item.title||'—')+': '+((Array.isArray(item.count)?item.count[0]:item.count)||0))" @mouseleave="s1TooltipHide"
            @click="s1ToggleDrill(item, 'country')">
            <span class="s1-arr">{{ s1IsDrillOpen(item,'country') ? '▾' : '▸' }}</span>
            <div class="s1-hbar-lbl">{{ item.title || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-countries" :style="{ width: s1CountriesPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ (Array.isArray(item.count)?item.count[0]:item.count)||0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct((Array.isArray(item.count)?item.count[0]:item.count)||0, s1CountriesTotal) }}%</div>
          </div>
          <div v-if="s1IsDrillOpen(item,'country')" :key="'cnt-d-'+item.id" class="s1-dil-wrap">
            <div class="s1-dil-body">
              <template v-for="(panel, _pi) in (s1Drill ? s1Drill.panels : [])">
              <div :key="'cp-'+_pi" class="s1-dil-col s1-dil-col-right">
                <div class="s1-dil-title">{{ panel.title }}</div>
                <div v-if="panel.loading" class="s1-dil-spin"><div class="c1-spinner" style="width:13px;height:13px"></div></div>
                <div v-else-if="!panel.items.length" class="s1-dil-empty">No data</div>
                <div v-else v-for="(rel, ri) in panel.items.slice(0,8)" :key="'cp'+_pi+'-'+ri" class="s1-dil-row">
                  <span class="s1-dil-lbl s1-dil-lbl-wide">{{ rel.title || rel.name || '—' }}</span>
                  <div class="s1-dil-track"><div class="s1-dil-fill" :style="{ width: s1DrillPanelPct(panel, rel)+'%', background: panel.color }"></div></div>
                  <span class="s1-dil-num">{{ s1DrillCount(rel) }}</span>
                </div>
              </div>
              </template>
            </div>
          </div>
          </template>
          <div v-if="!s1CountriesActive.length" class="s1-empty-state"><div v-if="s1LoadingCountries" class="c1-spinner"></div><span v-else>No data</span></div>
          <div v-if="s1CountriesActive.length" class="s1-table-total"><span>Total</span><span>{{ s1CountriesTotal }}</span><span>100%</span></div>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'hours'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Hourly Distribution</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: s1HoursMetric === 'reg' }"     @click="s1FetchHours('reg')">REG</div>
            <div class="s1-toggle-btn" :class="{ on: s1HoursMetric === 'dep' }"     @click="s1FetchHours('dep')">DEP</div>
            <div class="s1-toggle-btn" :class="{ on: s1HoursMetric === 'ca_f' }"    @click="s1FetchHours('ca_f')">CA</div>
            <div class="s1-toggle-btn" :class="{ on: s1HoursMetric === 'assign' }"  @click="s1FetchHours('assign')">Assign</div>
            <div class="s1-toggle-btn" :class="{ on: s1HoursMetric === 'na_tag' }"  @click="s1FetchHours('na_tag')">NA</div>
            <div class="s1-toggle-btn" :class="{ on: s1HoursMetric === 'tra' }"     @click="s1FetchHours('tra')">Transfer</div>
          </div>
        </div>
        <div v-if="s1LoadingHours" class="s1-empty-state"><div class="c1-spinner"></div></div>
        <div v-else-if="!s1HoursData.length" class="s1-empty-state"><span>No hourly data</span></div>
        <div v-else class="s1-hours-chart">
          <div v-for="item in s1HoursData" :key="'hr-'+item.date" class="s1-hour-col"
            @mouseenter="s1TooltipShow($event, (item.date < 10 ? '0'+item.date : item.date)+':00  →  '+(item.count||0))" @mouseleave="s1TooltipHide">
            <div class="s1-hour-bar-wrap">
              <div class="s1-hour-bar-fill" :style="{ height: s1HoursPct(item) + '%' }"></div>
            </div>
            <div class="s1-hour-val">{{ item.count || 0 }}</div>
            <div class="s1-hour-lbl">{{ String(item.date).padStart(2,'0') }}</div>
          </div>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'advertising'" class="s1-tab-panel">
        <div class="s1-section-hdr"><span>Campaign Sources (AAID)</span></div>
        <div class="s1-table-hdr"><span>Campaign</span><span>Count</span><span>%</span></div>
        <div v-if="s1AdvertisingList.length" class="s1-hbar-list">
          <div v-for="item in s1AdvertisingList" :key="'adv-'+item.id" class="s1-hbar-row"
            @mouseenter="s1TooltipShow($event, (item.title||item.id||'—')+': '+((Array.isArray(item.count)?item.count[0]:item.count)||0))" @mouseleave="s1TooltipHide">
            <div class="s1-hbar-lbl">{{ item.title || item.id || '—' }}</div>
            <div class="s1-hbar-track"><div class="s1-hbar-fill s1-fill-adv" :style="{ width: s1AdvertisingPct(item) + '%' }"></div></div>
            <div class="s1-hbar-val">{{ (Array.isArray(item.count)?item.count[0]:item.count)||0 }}</div>
            <div class="s1-hbar-pct">{{ s1SharePct((Array.isArray(item.count)?item.count[0]:item.count)||0, s1AdvertisingTotal) }}%</div>
          </div>
          <div class="s1-table-total"><span>Total</span><span>{{ s1AdvertisingTotal }}</span><span>100%</span></div>
        </div>
        <div v-else class="s1-empty-state"><div v-if="s1LoadingAdvertising" class="c1-spinner"></div><span v-else>No campaign data</span></div>
        </div>

        <div v-if="s1ActiveTab === 'timeline'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Registration Timeline</span>
          <span class="s1-section-hint">Volatility chart</span>
        </div>
        <div v-if="s1TimelinePoints" class="s1-timeline-wrap">
          <svg class="s1-timeline-svg" :viewBox="'0 0 ' + s1TlW + ' ' + s1TlH" preserveAspectRatio="none">
            <defs>
              <linearGradient id="s1tlgrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#6366f1" stop-opacity="0.3"/>
                <stop offset="100%" stop-color="#6366f1" stop-opacity="0"/>
              </linearGradient>
            </defs>
            <polygon :points="s1TimelineArea" fill="url(#s1tlgrad)"/>
            <polyline :points="s1TimelinePoints" fill="none" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle v-for="(pt, i) in s1TlDotPoints" :key="'tldot-'+i"
              :cx="pt.x" :cy="pt.y" r="3" fill="#6366f1" style="cursor:pointer"
              @mouseenter="s1TooltipShow($event, pt.label)"
              @mouseleave="s1TooltipHide"/>
          </svg>
          <div class="s1-tl-x-labels">
            <span v-for="(lbl, i) in s1TlXLabels" :key="'tlx-'+i" class="s1-tl-x-lbl">{{ lbl }}</span>
          </div>
        </div>
        <div v-else class="s1-empty-state">
          <div v-if="s1LoadingTimeline" class="c1-spinner"></div>
          <span v-else>No timeline data</span>
        </div>
        </div>

        <div v-if="s1ActiveTab === 'live'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Live Stats</span>
          <span class="s1-live-badge">
            <span class="s1-live-pulse"></span>
            AUTO-REFRESH 30s
          </span>
        </div>
        <div class="s1-live-grid">
          <div v-for="kpi in s1LiveKpis" :key="'kpi-'+kpi.key" class="s1-live-cell">
            <div class="s1-live-key" :style="{ color: kpi.color }">{{ kpi.key }}</div>
            <div class="s1-live-val" :style="{ color: kpi.color }">{{ kpi.val }}</div>
            <div class="s1-live-lbl">{{ kpi.label }}</div>
            <div class="s1-live-pulse-ring" :style="{ borderColor: kpi.color + '44' }"></div>
          </div>
        </div>
        <div class="s1-live-footer">Last updated: {{ s1LiveUpdatedAt }}</div>
        </div>


        <!-- ═══ CAMPAIGN STATS TAB ═══ -->
        <div v-if="s1ActiveTab === 'campaign_stats'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Campaign Stats</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: s1CampView === 'leads' }"    @click="s1CampView = 'leads'">Leads</div>
            <div class="s1-toggle-btn" :class="{ on: s1CampView === 'deposits' }" @click="s1CampView = 'deposits'">Deposits</div>
            <div class="s1-toggle-btn" :class="{ on: s1CampView === 'cr' }"       @click="s1CampView = 'cr'">CR%</div>
          </div>
        </div>
        <div v-if="s1CampaignData.length" class="s1-report-table-wrap">
          <table class="s1-report-table">
            <thead>
              <tr>
                <th class="s1-rt-th s1-rt-name">Campaign</th>
                <th class="s1-rt-th s1-rt-num">Leads</th>
                <th class="s1-rt-th s1-rt-num">Deposits</th>
                <th class="s1-rt-th s1-rt-num">CR%</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in s1CampaignDataSorted" :key="'camp-'+row.id" class="s1-rt-tr"
                @mouseenter="s1TooltipShow($event, (row.title||row.name||row.campaign||'—')+' — Leads: '+(row.leads||row.count||0)+', Deps: '+(row.deposits||0))"
                @mouseleave="s1TooltipHide">
                <td class="s1-rt-td s1-rt-name">{{ row.title || row.name || row.campaign || '—' }}</td>
                <td class="s1-rt-td s1-rt-num">{{ row.leads || row.count || 0 }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#00b67a">{{ row.deposits || 0 }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#0057ff">{{ s1CalcCR(row.leads||row.count||0, row.deposits||0) }}%</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="s1-rt-total">
                <td class="s1-rt-td s1-rt-name">TOTAL</td>
                <td class="s1-rt-td s1-rt-num">{{ s1CampTotalLeads }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#00b67a">{{ s1CampTotalDeposits }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#0057ff">{{ s1CalcCR(s1CampTotalLeads, s1CampTotalDeposits) }}%</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div v-else class="s1-empty-state"><div v-if="s1LoadingCampaignStats" class="c1-spinner"></div><span v-else>No campaign data</span></div>
        </div>

        <!-- ═══ BROKER STATS TAB ═══ -->
        <div v-if="s1ActiveTab === 'broker_stats'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Broker Stats</span>
          <div class="s1-toggle-btns">
            <div class="s1-toggle-btn" :class="{ on: s1BrokerStView === 'deposits' }" @click="s1BrokerStView = 'deposits'">Deposits</div>
            <div class="s1-toggle-btn" :class="{ on: s1BrokerStView === 'leads' }"    @click="s1BrokerStView = 'leads'">Leads</div>
            <div class="s1-toggle-btn" :class="{ on: s1BrokerStView === 'cr' }"       @click="s1BrokerStView = 'cr'">CR%</div>
          </div>
        </div>
        <div v-if="s1BrokerStatsData.length" class="s1-report-table-wrap">
          <table class="s1-report-table">
            <thead>
              <tr>
                <th class="s1-rt-th s1-rt-name">Broker</th>
                <th class="s1-rt-th s1-rt-num">Clients</th>
                <th class="s1-rt-th s1-rt-num">Deposits</th>
                <th class="s1-rt-th s1-rt-num">CR%</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in s1BrokerStatsDataSorted" :key="'brst-'+row.id" class="s1-rt-tr"
                @mouseenter="s1TooltipShow($event, (row.title||row.name||'—')+' — Clients: '+(row.clients||row.count||0)+', Deps: '+(row.deposits||0))"
                @mouseleave="s1TooltipHide">
                <td class="s1-rt-td s1-rt-name">{{ row.title || row.name || '—' }}</td>
                <td class="s1-rt-td s1-rt-num">{{ row.clients || row.count || 0 }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#00b67a">{{ row.deposits || 0 }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#0057ff">{{ s1CalcCR(row.clients||row.count||0, row.deposits||0) }}%</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="s1-rt-total">
                <td class="s1-rt-td s1-rt-name">TOTAL</td>
                <td class="s1-rt-td s1-rt-num">{{ s1BrokerStTotalClients }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#00b67a">{{ s1BrokerStTotalDeposits }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#0057ff">{{ s1CalcCR(s1BrokerStTotalClients, s1BrokerStTotalDeposits) }}%</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div v-else class="s1-empty-state"><div v-if="s1LoadingBrokerStats" class="c1-spinner"></div><span v-else>No broker data</span></div>
        </div>

        <!-- ═══ COSTS TAB ═══ -->
        <div v-if="s1ActiveTab === 'costs'" class="s1-tab-panel">
        <div class="s1-section-hdr"><span>Costs Breakdown</span></div>
        <div v-if="s1CostsData && (s1CostsData.total !== undefined || s1CostsItems.length)" class="s1-costs-wrap">
          <!-- Summary cards -->
          <div class="s1-costs-summary">
            <div class="s1-costs-card">
              <div class="s1-costs-card-lbl">Total Cost</div>
              <div class="s1-costs-card-val" style="color:#f43f5e">{{ s1FormatCurrency(s1CostsData.total || s1CostsData.cost || 0) }}</div>
            </div>
            <div class="s1-costs-card" v-if="s1CostsData.cpl !== undefined">
              <div class="s1-costs-card-lbl">CPL</div>
              <div class="s1-costs-card-val" style="color:#0057ff">{{ s1FormatCurrency(s1CostsData.cpl || 0) }}</div>
            </div>
            <div class="s1-costs-card" v-if="s1CostsData.cpd !== undefined">
              <div class="s1-costs-card-lbl">CPD</div>
              <div class="s1-costs-card-val" style="color:#00b67a">{{ s1FormatCurrency(s1CostsData.cpd || 0) }}</div>
            </div>
            <div class="s1-costs-card" v-if="s1CostsData.roi !== undefined">
              <div class="s1-costs-card-lbl">ROI</div>
              <div class="s1-costs-card-val" style="color:#8b5cf6">{{ s1CostsData.roi }}%</div>
            </div>
          </div>
          <!-- Cost items table -->
          <div v-if="s1CostsItems.length" class="s1-report-table-wrap" style="margin-top:16px">
            <table class="s1-report-table">
              <thead><tr><th class="s1-rt-th s1-rt-name">Category</th><th class="s1-rt-th s1-rt-num">Amount</th><th class="s1-rt-th s1-rt-num">%</th></tr></thead>
              <tbody>
                <tr v-for="(item, idx) in s1CostsItems" :key="'cost-'+idx" class="s1-rt-tr">
                  <td class="s1-rt-td s1-rt-name">{{ item.title || item.name || item.category || '—' }}</td>
                  <td class="s1-rt-td s1-rt-num">{{ s1FormatCurrency(item.amount || item.cost || item.total || 0) }}</td>
                  <td class="s1-rt-td s1-rt-num" style="color:#f43f5e">{{ s1SharePct(item.amount||item.cost||item.total||0, s1CostsData.total||1) }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="s1-empty-state"><div v-if="s1LoadingCosts" class="c1-spinner"></div><span v-else>No cost data</span></div>
        </div>

        <!-- ═══ DAILY REPORT TAB ═══ -->
        <div v-if="s1ActiveTab === 'daily_report'" class="s1-tab-panel">
        <div class="s1-section-hdr">
          <span>Daily Report — Agent Breakdown</span>
          <span class="s1-section-hint">Today's performance by agent</span>
        </div>
        <div v-if="s1DailyReportData.length" class="s1-report-table-wrap">
          <table class="s1-report-table">
            <thead>
              <tr>
                <th class="s1-rt-th s1-rt-name">Agent</th>
                <th class="s1-rt-th s1-rt-num">REG</th>
                <th class="s1-rt-th s1-rt-num">DEP</th>
                <th class="s1-rt-th s1-rt-num">CA</th>
                <th class="s1-rt-th s1-rt-num">NA</th>
                <th class="s1-rt-th s1-rt-num">NI</th>
                <th class="s1-rt-th s1-rt-num">TR</th>
                <th class="s1-rt-th s1-rt-num">LD</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="agent in s1DailyReportData" :key="'dr-'+agent.id" class="s1-rt-tr"
                @mouseenter="s1TooltipShow($event, (agent.name||agent.full_name||'—')+' — REG:'+( agent.REG||agent.reg||0)+' DEP:'+(agent.DP||agent.dep||0))"
                @mouseleave="s1TooltipHide">
                <td class="s1-rt-td s1-rt-name">
                  <div style="display:flex;align-items:center;gap:6px">
                    <span class="s1-dr-av">{{ s1DRInitials(agent) }}</span>
                    {{ agent.name || agent.full_name || '—' }}
                  </div>
                </td>
                <td class="s1-rt-td s1-rt-num" style="color:#0057ff">{{ agent.REG || agent.reg || 0 }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#00b67a">{{ agent.DP || agent.dep || agent.deposits || 0 }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#7c3aed">{{ agent.CA || agent.ca || agent.scheduled || 0 }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#ef4444">{{ agent.NA || agent.na || 0 }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#b45309">{{ agent.NI || agent.ni || 0 }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#8b5cf6">{{ (agent['TR-LV']||agent.tr_lv||0) + (agent['TR-ON']||agent.tr_on||0) }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#f59e0b">{{ agent.LD || agent.ld || agent.leads || 0 }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="s1-rt-total">
                <td class="s1-rt-td s1-rt-name">TOTAL</td>
                <td class="s1-rt-td s1-rt-num" style="color:#0057ff">{{ s1DRTotals.REG }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#00b67a">{{ s1DRTotals.DP }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#7c3aed">{{ s1DRTotals.CA }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#ef4444">{{ s1DRTotals.NA }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#b45309">{{ s1DRTotals.NI }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#8b5cf6">{{ s1DRTotals.TR }}</td>
                <td class="s1-rt-td s1-rt-num" style="color:#f59e0b">{{ s1DRTotals.LD }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div v-else class="s1-empty-state"><div v-if="s1LoadingDailyReport" class="c1-spinner"></div><span v-else>No daily report data</span></div>
        </div>

        <!-- ═══ TOTAL STATS TAB ═══ -->
        <div v-if="s1ActiveTab === 'total_stats'" class="s1-tab-panel">
        <div class="s1-section-hdr"><span>Total Stats — Aggregate KPIs</span></div>
        <!-- KPI Summary cards -->
        <div class="s1-total-kpi-grid">
          <div v-for="kpi in s1TotalStatsKpis" :key="'tskpi-'+kpi.key" class="s1-total-kpi-card"
            @mouseenter="s1TooltipShow($event, kpi.label+': '+kpi.value)" @mouseleave="s1TooltipHide">
            <div class="s1-total-kpi-dot" :style="{ background: kpi.color }"></div>
            <div class="s1-total-kpi-lbl">{{ kpi.label }}</div>
            <div class="s1-total-kpi-val" :style="{ color: kpi.color }">{{ kpi.value }}</div>
            <div class="s1-total-kpi-sub" v-if="kpi.sub">{{ kpi.sub }}</div>
          </div>
        </div>
        <!-- Detailed breakdown -->
        <div v-if="s1TotalStatsRows.length" class="s1-report-table-wrap" style="margin-top:20px">
          <table class="s1-report-table">
            <thead><tr><th class="s1-rt-th s1-rt-name">Metric</th><th class="s1-rt-th s1-rt-num">Count</th><th class="s1-rt-th s1-rt-num">Change</th></tr></thead>
            <tbody>
              <tr v-for="row in s1TotalStatsRows" :key="'tsrow-'+row.key" class="s1-rt-tr">
                <td class="s1-rt-td s1-rt-name"><span class="s1-ts-dot" :style="{ background: row.color }"></span>{{ row.label }}</td>
                <td class="s1-rt-td s1-rt-num" :style="{ color: row.color }">{{ row.value }}</td>
                <td class="s1-rt-td s1-rt-num">
                  <span v-if="row.delta > 0" style="color:#00b67a">+{{ row.delta }}%</span>
                  <span v-else-if="row.delta < 0" style="color:#ef4444">{{ row.delta }}%</span>
                  <span v-else style="color:var(--c1-muted)">—</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="!s1LoadingTotalStats" class="s1-empty-state"><span>No total stats data</span></div>
        <div v-if="s1LoadingTotalStats" class="s1-empty-state"><div class="c1-spinner"></div></div>
        </div>

        <!-- ═══════════════════════════════════════════════════════════ -->
        <!-- TEAMS COMPETITION SECTION                                   -->
        <!-- ═══════════════════════════════════════════════════════════ -->
        <div v-if="s1ActiveTab === 'teams'" class="s1-tab-panel s1-teams-section">

          <!-- BLOCK A: Scope Toggle -->
          <div class="s1-scope-toggle">
            <div class="s1-scope-pill" :class="{ on: s1TeamsScope === 'all' }" @click="s1TeamsScope = 'all'">All</div>
            <div class="s1-scope-pill" :class="{ on: s1TeamsScope === 'team1' }" @click="s1TeamsScope = 'team1'">
              <span>{{ s1Team1.emoji }}</span> {{ s1Team1.name }}
            </div>
            <div class="s1-scope-pill" :class="{ on: s1TeamsScope === 'team2' }" @click="s1TeamsScope = 'team2'">
              <span>{{ s1Team2.emoji }}</span> {{ s1Team2.name }}
            </div>
          </div>

          <!-- BLOCK B: Head-to-Head KPI Cards -->
          <div class="s1-h2h" v-if="!s1TeamsLoading">
            <!-- TEAM 1 PANEL -->
            <div class="s1-team-panel">
              <div class="s1-tp-header" :style="{ background: s1Team1.color + '33', borderBottom: '2px solid ' + s1Team1.color }">
                <span class="s1-tp-emoji">{{ s1Team1.emoji }}</span>
                <span class="s1-tp-name">{{ s1Team1.name }}</span>
              </div>
              <div class="s1-tp-body">
                <div class="s1-tp-kpi-grid">
                  <div v-for="kpi in s1TeamsKpis" :key="'t1-'+kpi.key"
                       class="s1-kpi-card" :class="{ winning: s1TeamKpiWinner(kpi.key) === 1 }">
                    <div class="s1-kpi-lbl">{{ kpi.label }}</div>
                    <div class="s1-kpi-val">
                      {{ kpi.fmt === 'money' ? s1FmtMoney(s1TeamsVal(1, kpi.key)) : s1TeamsVal(1, kpi.key) }}
                      <span v-if="s1TeamKpiWinner(kpi.key) === 1" class="s1-kpi-crown">🏆</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- VS badge -->
            <div class="s1-vs-badge">VS</div>

            <!-- TEAM 2 PANEL -->
            <div class="s1-team-panel">
              <div class="s1-tp-header" :style="{ background: s1Team2.color + '33', borderBottom: '2px solid ' + s1Team2.color }">
                <span class="s1-tp-emoji">{{ s1Team2.emoji }}</span>
                <span class="s1-tp-name">{{ s1Team2.name }}</span>
              </div>
              <div class="s1-tp-body">
                <div class="s1-tp-kpi-grid">
                  <div v-for="kpi in s1TeamsKpis" :key="'t2-'+kpi.key"
                       class="s1-kpi-card" :class="{ winning: s1TeamKpiWinner(kpi.key) === 2 }">
                    <div class="s1-kpi-lbl">{{ kpi.label }}</div>
                    <div class="s1-kpi-val">
                      {{ kpi.fmt === 'money' ? s1FmtMoney(s1TeamsVal(2, kpi.key)) : s1TeamsVal(2, kpi.key) }}
                      <span v-if="s1TeamKpiWinner(kpi.key) === 2" class="s1-kpi-crown">🏆</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- LOADING STATE -->
          <div v-if="s1TeamsLoading" class="s1-empty-state"><div class="c1-spinner"></div> Loading team data…</div>

          <!-- BLOCK C: Period Selector + Dual Line Chart -->
          <div class="s1-section-hdr" style="margin-top:20px">
            <span>Performance Over Time</span>
            <div style="display:flex;gap:6px">
              <div class="s1-toggle-btn" :class="{ on: s1TeamsPeriod === 'today' }" @click="s1TeamsPeriod='today'; s1FetchTeamsData()">Today</div>
              <div class="s1-toggle-btn" :class="{ on: s1TeamsPeriod === 'week' }" @click="s1TeamsPeriod='week'; s1FetchTeamsData()">This Week</div>
              <div class="s1-toggle-btn" :class="{ on: s1TeamsPeriod === 'month' }" @click="s1TeamsPeriod='month'; s1FetchTeamsData()">This Month</div>
            </div>
            <div style="display:flex;gap:6px">
              <div class="s1-toggle-btn" :class="{ on: s1TeamsChartMetric === 'deposits' }" @click="s1TeamsChartMetric='deposits'">Deposits</div>
              <div class="s1-toggle-btn" :class="{ on: s1TeamsChartMetric === 'leads' }" @click="s1TeamsChartMetric='leads'">Leads</div>
              <div class="s1-toggle-btn" :class="{ on: s1TeamsChartMetric === 'clients' }" @click="s1TeamsChartMetric='clients'">Clients</div>
            </div>
          </div>

          <!-- SVG Dual-line chart -->
          <div class="s1-teams-chart-wrap">
            <svg class="s1-teams-svg" viewBox="0 0 600 160" preserveAspectRatio="none" v-if="s1TeamsChartPoints.t1.length > 1">
              <!-- Grid lines -->
              <line v-for="i in 4" :key="'gl'+i" x1="0" :y1="i*32" x2="600" :y2="i*32" stroke="rgba(255,255,255,.06)" stroke-width="1"/>
              <!-- Team 1 line -->
              <polyline
                :points="s1TeamsChartPoints.t1.map((p,i) => (i * (600/(s1TeamsChartPoints.t1.length-1||1))) + ',' + p).join(' ')"
                fill="none" stroke="#0e7490" stroke-width="2.5" stroke-linejoin="round" stroke-linecap="round"/>
              <!-- Team 2 line -->
              <polyline
                :points="s1TeamsChartPoints.t2.map((p,i) => (i * (600/(s1TeamsChartPoints.t2.length-1||1))) + ',' + p).join(' ')"
                fill="none" stroke="#7c3aed" stroke-width="2.5" stroke-linejoin="round" stroke-linecap="round"/>
              <!-- Team 1 dots -->
              <circle v-for="(p,i) in s1TeamsChartPoints.t1" :key="'d1'+i"
                :cx="i * (600/(s1TeamsChartPoints.t1.length-1||1))" :cy="p" r="3" fill="#0e7490"/>
              <!-- Team 2 dots -->
              <circle v-for="(p,i) in s1TeamsChartPoints.t2" :key="'d2'+i"
                :cx="i * (600/(s1TeamsChartPoints.t2.length-1||1))" :cy="p" r="3" fill="#7c3aed"/>
            </svg>
            <div v-else class="s1-teams-chart-empty">No chart data yet for this period</div>
            <!-- Legend -->
            <div class="s1-teams-chart-legend">
              <div class="s1-tcl-item"><span style="background:#0e7490"></span>{{ s1Team1.name }}</div>
              <div class="s1-tcl-item"><span style="background:#7c3aed"></span>{{ s1Team2.name }}</div>
            </div>
          </div>

          <!-- BLOCK D: Cross-Team Agent Leaderboard -->
          <div class="s1-section-hdr" style="margin-top:24px">
            <span>Agent Leaderboard</span>
            <div style="display:flex;gap:6px">
              <div class="s1-toggle-btn" :class="{ on: s1LeaderboardMetric === 'deposits' }" @click="s1LeaderboardMetric='deposits'; s1FetchLeaderboard()">Deposits</div>
              <div class="s1-toggle-btn" :class="{ on: s1LeaderboardMetric === 'leads' }" @click="s1LeaderboardMetric='leads'; s1FetchLeaderboard()">Leads</div>
              <div class="s1-toggle-btn" :class="{ on: s1LeaderboardMetric === 'clients' }" @click="s1LeaderboardMetric='clients'; s1FetchLeaderboard()">Clients</div>
            </div>
          </div>

          <div v-if="s1Leaderboard.length" style="overflow-x:auto">
            <table class="s1-lb-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th></th>
                  <th style="text-align:left">Agent</th>
                  <th>Team</th>
                  <th style="text-align:right">Score</th>
                  <th style="text-align:center">Trend</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(agent, i) in s1Leaderboard" :key="'lb'+i">
                  <td class="s1-lb-rank">
                    <span v-if="i===0">🥇</span>
                    <span v-else-if="i===1">🥈</span>
                    <span v-else-if="i===2">🥉</span>
                    <span v-else style="color:rgba(255,255,255,.4)">{{ i+1 }}</span>
                  </td>
                  <td>
                    <div class="s1-lb-av" :style="{ background: s1AvatarColors[i % s1AvatarColors.length] }">
                      {{ s1AgentInitialsFromName(agent.name || agent.agent_name || '') }}
                    </div>
                  </td>
                  <td class="s1-lb-name">{{ agent.name || agent.agent_name || ('Agent ' + (i+1)) }}</td>
                  <td>
                    <span class="s1-lb-team-badge"
                      :style="{ background: agent.team_id === 1 ? s1Team1.color : s1Team2.color }">
                      {{ agent.team_id === 1 ? s1Team1.name : s1Team2.name }}
                    </span>
                  </td>
                  <td style="text-align:right;font-family:'DM Mono',monospace;font-weight:700;color:#fff">
                    {{ s1LeaderboardMetric === 'deposits' ? s1FmtMoney(agent.score || agent.deposits || 0) : (agent.score || agent.count || 0) }}
                  </td>
                  <td style="text-align:center;font-size:14px">
                    <span v-if="(agent.trend||0) > 0" style="color:#22c55e">↑</span>
                    <span v-else-if="(agent.trend||0) < 0" style="color:#ef4444">↓</span>
                    <span v-else style="color:rgba(255,255,255,.3)">→</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else-if="!s1TeamsLoading" class="s1-empty-state">No leaderboard data available</div>

          <!-- BLOCK E: Goals vs Actuals -->
          <div class="s1-section-hdr" style="margin-top:24px">
            <span>Goals vs Actuals</span>
          </div>
          <div class="s1-goals-section" v-if="s1TeamsGoals.length">
            <div v-for="(tg, ti) in s1TeamsGoals" :key="'tg'+ti" style="margin-bottom:20px">
              <div style="font-size:11px;font-weight:700;color:rgba(255,255,255,.5);text-transform:uppercase;margin-bottom:8px">
                {{ ti === 0 ? s1Team1.emoji + ' ' + s1Team1.name : s1Team2.emoji + ' ' + s1Team2.name }}
              </div>
              <div v-for="goal in (tg.goals||[])" :key="'g'+ti+goal.key" class="s1-goal-row">
                <div class="s1-goal-label">
                  <span>{{ goal.label }}: {{ goal.fmt === 'money' ? s1FmtMoney(goal.actual) : goal.actual }} / {{ goal.fmt === 'money' ? s1FmtMoney(goal.target) : goal.target }} target</span>
                  <span>{{ goal.target > 0 ? Math.round(goal.actual/goal.target*100) : 0 }}%</span>
                </div>
                <div class="s1-goal-bar-track">
                  <div class="s1-goal-bar-fill"
                    :style="{ width: (goal.target > 0 ? Math.min(100, Math.round(goal.actual/goal.target*100)) : 0) + '%', background: ti === 0 ? s1Team1.color : s1Team2.color }">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="s1-empty-state" style="font-size:12px;color:rgba(255,255,255,.3)">
            No goals set yet — <span style="color:#0e7490;cursor:pointer" @click="s1GoToSection('settings')">Set goals in Settings</span>
          </div>

        </div><!-- /teams section -->

      </div><!-- /s1-tab-panels -->

      <!-- CALENDAR removed from main body — now lives in the Filters panel (Custom date range) -->
      <div v-if="false" class="s1-cal-widget">
        <div class="s1-cal-widget-hdr">
          <div class="s1-cal-widget-title"></div>
          <div class="s1-cal-nav"></div>
        </div>
        <div class="s1-cal-body">
          <div class="s1-cal-dow-row">
            <div v-for="(d, di) in ['M','T','W','T','F','S','S']" :key="'dow3-'+di" class="s1-cal-dow">{{ d }}</div>
          </div>
          <div v-for="(week, wi) in s1CalGrid" :key="'week3-'+wi" class="s1-cal-week">
            <div v-for="day in week" :key="'w3'+day.date" class="s1-cal-day"
              :class="{ today: day.today, 'other-month': !day.inMonth, selected: s1CalSelected === day.date || day.date === s1CalRangeFrom || day.date === s1CalRangeTo, 'in-range': s1CalRangeFrom && s1CalRangeTo && day.date > s1CalRangeFrom && day.date < s1CalRangeTo, 'range-start': day.date === s1CalRangeFrom, 'range-end': day.date === s1CalRangeTo, 'has-data': day.hasData }"
              @click="s1CalSelectDay(day)">
              <span class="s1-cal-dn">{{ day.day }}</span>
              <span v-if="day.reg" class="s1-cal-badge s1-cb-reg">{{ day.reg }}</span>
            </div>
          </div>
        </div>
      </div><!-- /s1-cal-widget -->

      </div><!-- /s1-body-inner -->
    </div><!-- /c1-body -->

    <!-- TOOLTIP -->
    <div class="s1-tooltip" v-show="s1Tooltip.visible" :style="{ top: s1Tooltip.y + 'px', left: s1Tooltip.x + 'px' }">{{ s1Tooltip.text }}</div>

  </div>
</template>

<script>
import axios from "axios";
import VikiFace from "../../clients1.feature/VikiFace.vue";
import C1ModCalendar from '../../../components/C1ModCalendar.vue';

const CARD_META = [
  { key: "REG",   label: "Registrations",  color: "#6366f1" },
  { key: "LD",    label: "Leads",          color: "#f59e0b" },
  { key: "DP",    label: "Deposits",       color: "#22c55e" },
  { key: "NA",    label: "No Answer",      color: "#ef4444" },
  { key: "RF",    label: "Referrals",      color: "#a855f7" },
  { key: "CA",    label: "Sched. Calls",   color: "#f97316" },
  { key: "NEW",   label: "New Clients",    color: "#3b82f6" },
  { key: "BN",    label: "Bad Number",     color: "#78716c" },
  { key: "NI",    label: "Not Interested", color: "#b45309" },
  { key: "TR-ON", label: "Transfer On",    color: "#8b5cf6" },
  { key: "TR-LV", label: "Transfer Live",  color: "#14b8a6" },
];

const ROLE_MAP = { 1:"Admin", 2:"Team Leader", 3:"Manager", 4:"Senior Agent", 5:"Agent", 6:"Junior Agent", 7:"New Agent", 8:"Support", 9:"Retention", 10:"Finance", 12:"Super Admin" };

export default {
  name: "Stats1Container",

  components: { VikiFace, C1ModCalendar },

  data() {
    return {
      c1Status: 'available',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      c1TopTab: null,
      s1SlideOpen: null,
      s1PanelActiveContent: null,
      s1FilterSubTab: 'date',
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      s1Loading: false,
      s1Error: null,
      s1TimeStr: "",

      s1ActiveTab: "today",
      s1Tabs: [
        { key: "today",          label: "Today" },
        { key: "akg",            label: "AKG Report" },
        { key: "deposits",       label: "Deposits" },
        { key: "leads",          label: "Leads" },
        { key: "noanswer",       label: "No Answer" },
        { key: "scheduled",      label: "Scheduled" },
        { key: "transfers",      label: "Transfers" },
        { key: "referrals",      label: "Referrals" },
        { key: "bad_number",     label: "Bad Number" },
        { key: "not_interested", label: "Not Interested" },
        { key: "assignments",    label: "Assignments" },
        { key: "countries",      label: "Countries" },
        { key: "hours",          label: "Hours" },
        { key: "advertising",    label: "Campaigns" },
        { key: "timeline",       label: "Timeline" },
        { key: "live",           label: "Live", live: true },
        { key: "campaign_stats", label: "Campaign Stats" },
        { key: "broker_stats",   label: "Broker Stats" },
        { key: "costs",          label: "Costs" },
        { key: "daily_report",   label: "Daily Report" },
        { key: "total_stats",    label: "Total Stats" },
      ],

      s1DateFilter: "today",
      s1TimeFrames: [
        { key: "today",     label: "Today",       period: 0  },
        { key: "yesterday", label: "Yesterday",   period: 1  },
        { key: "30days",    label: "30 Days",      period: 30 },
        { key: "90days",    label: "90 Days",      period: 90 },
      ],
      s1AgentFilter: [],

      s1TodayData: {},
      s1TitleInfo: { reg: 0, dep: 0, cost: 0 },
      s1HistoryData: [],

      s1DepBrokers: [],
      s1DepUsers: [],
      s1DepStatus: [],
      s1DepQuantity: [],
      s1LeadsBrokers: [],
      s1LeadsUsers: [],
      s1NAUsers: [],
      s1SCUsers: [],
      s1SCReasons: [],
      s1CAPriority: [],
      s1TransferTypes: [],
      s1TransferUsersLV: [],
      s1TransferUsersON: [],
      s1ReferralBrokers: [],
      s1ReferralUsers: [],
      s1BNReasons: [],
      s1NIReasons: [],
      s1AssignUsers: [],
      s1AkgReports: [],
      s1AkgTimeFrame: 30,
      s1AkgExpand: {},
      s1CountriesList: [],
      s1CountriesTiers: [],
      s1CountriesParents: [],
      s1CountriesView: "country",
      s1HoursData: [],
      s1HoursMetric: "reg",
      s1AdvertisingList: [],
      s1TimelineRaw: [],
      s1LiveData: {},
      s1LiveUpdatedAt: "--:--",

      s1LoadingDeposits: false,
      s1LoadingLeads: false,
      s1LoadingNA: false,
      s1LoadingSC: false,
      s1LoadingTransfers: false,
      s1LoadingReferrals: false,
      s1LoadingBN: false,
      s1LoadingNI: false,
      s1LoadingAssign: false,
      s1LoadingAkg: false,
      s1LoadingCountries: false,
      s1LoadingHours: false,
      s1LoadingAdvertising: false,
      s1LoadingTimeline: false,

      s1LeadsView: "broker",
      s1DepView: "broker",
      s1TransferView: "lv",
      s1ScView: "agent",
      s1RefView: false,

      s1Cal: { year: new Date().getFullYear(), month: new Date().getMonth() },
      s1CalMonthNames: ["January","February","March","April","May","June","July","August","September","October","November","December"],
      s1CalSelected: null,
      s1CalRangeFrom: null,
      s1CalRangeTo:   null,
      s1CalSelecting: false,
      s1DayHistory: {},

      s1AgentBlockOpen: false,
      s1PanelCalOpen: false,
      s1AgentList: [],
      s1AgentSearch: '',


      // ── New report section data ─────────────────────
      s1CampaignData: [],
      s1BrokerStatsData: [],
      s1CostsData: {},
      s1CostsItems: [],
      s1DailyReportData: [],
      s1TotalStatsRaw: {},

      s1LoadingCampaignStats: false,
      s1LoadingBrokerStats: false,
      s1LoadingCosts: false,
      s1LoadingDailyReport: false,
      s1LoadingTotalStats: false,

      s1CampView: 'leads',
      s1BrokerStView: 'deposits',

      s1Drill: null,
      s1AvatarColors: ["#7C5CFC","#C75450","#D4A017","#2D9D5E","#E8891C","#1144bc","#E05A3A","#6366f1","#22c55e","#f59e0b"],
      s1Tooltip: { visible: false, text: "", x: 0, y: 0 },
      s1TlW: 600,
      s1TlH: 160,

      // ── Deposit Goals ─────────────────────────────
      s1Goals: [
        { period: 'daily',   target: null, actual: 0, pct: 0, id: null, editTarget: null },
        { period: 'weekly',  target: null, actual: 0, pct: 0, id: null, editTarget: null },
        { period: 'monthly', target: null, actual: 0, pct: 0, id: null, editTarget: null },
      ],
      s1GoalsEditMode: false,

      // ── Agent Transfer Recommendations ───────────────────
      s1TransferRecs: [],
      s1TransferLoading: false,

      // ── Teams Competition ─────────────────────────────────
      s1TeamsScope: 'all',
      s1TeamsPeriod: 'month',
      s1TeamsChartMetric: 'deposits',
      s1TeamsData: null,
      s1TeamsLoading: false,
      s1Leaderboard: [],
      s1LeaderboardMetric: 'deposits',
      s1LeaderboardPeriod: 'month',
      s1TeamsGoals: [],
      s1Team1: { name: 'Team 1', emoji: '🔵', color: '#0e7490' },
      s1Team2: { name: 'Team 2', emoji: '🟣', color: '#7c3aed' },
      s1TeamsKpis: [
        { key: 'leads',      label: 'Leads Today',   fmt: 'number' },
        { key: 'deposits',   label: 'Deposits $',     fmt: 'money'  },
        { key: 'conversion', label: 'Conversion',     fmt: 'pct'    },
        { key: 'clients',    label: 'Active Clients', fmt: 'number' },
        { key: 'calls',      label: 'Calls Made',     fmt: 'number' },
        { key: 'revenue',    label: 'Revenue $',      fmt: 'money'  },
      ],
      s1TeamsChartData: { t1: [], t2: [] },
    };
  },

  computed: {
    s1UserInitials() {
      const u = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user) || (this.$store.state.auth && this.$store.state.auth.user);
      if (!u) return "GN";
      return (((u.first_name || "")[0] || "") + ((u.last_name || "")[0] || "")).toUpperCase() || "GN";
    },
    s1UserName() {
      const u = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user) || (this.$store.state.auth && this.$store.state.auth.user);
      if (!u) return "User";
      return ((u.first_name || "") + " " + (u.last_name || "")).trim();
    },
    s1RoleLabel() {
      const u = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user) || (this.$store.state.auth && this.$store.state.auth.user);
      return ROLE_MAP[(u && u.role)] || "User";
    },
    s1Token() {
      const s = this.$store.state;
      const fromStore = (s.main && s.main.token) || (s.user && s.user.auth && s.user.auth.token) || (s.auth && s.auth.token);
      return fromStore || localStorage.getItem("user-token") || localStorage.getItem("token") || "";
    },
    s1DateLabel() {
      const d = new Date().toLocaleDateString("en-GB");
      const map = { today: "Today — " + d, yesterday: "Yesterday", "30days": "Last 30 Days", "90days": "Last 90 Days" };
      return map[this.s1DateFilter] || "Today — " + d;
    },
    s1Period() {
      const map = { today: 0, yesterday: 1, "30days": 30, "90days": 90 };
      return map[this.s1DateFilter] !== undefined ? map[this.s1DateFilter] : 0;
    },
    s1DateParams() {
      const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      const today = new Date();
      if (this.s1DateFilter === 'custom' && this.s1CalRangeFrom && this.s1CalRangeTo) {
        const base = { registered_on_from: this.s1CalRangeFrom, registered_on_to: this.s1CalRangeTo };
        if (this.s1AgentFilter.length) base.group_assigned = this.s1AgentFilter;
        return base;
      }
      if (this.s1DateFilter === 'yesterday') {
        const y = new Date(today); y.setDate(y.getDate() - 1);
        return { registered_on_from: fmt(y), registered_on_to: fmt(y), ...(this.s1AgentFilter.length ? { group_assigned: this.s1AgentFilter } : {}) };
      }
      if (this.s1DateFilter === '30days') {
        const f = new Date(today); f.setDate(f.getDate() - 30);
        return { registered_on_from: fmt(f), registered_on_to: fmt(today), ...(this.s1AgentFilter.length ? { group_assigned: this.s1AgentFilter } : {}) };
      }
      if (this.s1DateFilter === '90days') {
        const f = new Date(today); f.setDate(f.getDate() - 90);
        return { registered_on_from: fmt(f), registered_on_to: fmt(today), ...(this.s1AgentFilter.length ? { group_assigned: this.s1AgentFilter } : {}) };
      }
      return { registered_on_from: fmt(today), registered_on_to: fmt(today), ...(this.s1AgentFilter.length ? { group_assigned: this.s1AgentFilter } : {}) };
    },
    s1Cards() {
      return CARD_META.map(m => {
        const k2 = m.key.replace("-", "");
        const val = this.s1TodayData[m.key] !== undefined ? this.s1TodayData[m.key] : (this.s1TodayData[k2] || 0);
        const prev = (this.s1HistoryData[this.s1HistoryData.length - 2] || {})[m.key] || 0;
        const delta = prev > 0 ? Math.round(((val - prev) / prev) * 100) : 0;
        return { ...m, val, delta, spark: this.s1SparkData(m.key) };
      });
    },

    s1TodayBarsComputed() {
      const keys = ["REG","LD","DP","NA","RF","CA","NEW","BN","NI","TR-ON","TR-LV"];
      const vals = keys.map(k => {
        const k2 = k.replace("-", "");
        return this.s1TodayData[k] !== undefined ? this.s1TodayData[k] : (this.s1TodayData[k2] || 0);
      });
      const max = Math.max(...vals, 1);
      return keys.map((k, i) => {
        const meta = CARD_META.find(m => m.key === k) || {};
        return { key: k, label: meta.label || k, val: vals[i], pct: Math.round((vals[i] / max) * 100), color: meta.color || "#6366f1" };
      });
    },

    s1Week() {
      if (this.s1HistoryData.length < 2) {
        return ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"].map(label => ({ label, reg: 0, dep: 0 }));
      }
      return this.s1HistoryData.slice(-7).map((d, i) => ({
        label: ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"][i] || "D",
        reg: d.REG || 0,
        dep: d.DP || d.DEP || 0,
      }));
    },
    s1TrendPolyReg() { return this.s1BuildTrendPoly(this.s1Week.map(d => d.reg)); },
    s1TrendPolyDep() { return this.s1BuildTrendPoly(this.s1Week.map(d => d.dep)); },
    s1DrillTypeLabel() {
      if (!this.s1Drill) return '';
      const labels = { dep_broker:'Deposits by Campaign', dep_user:'Deposits by Agent', lead_broker:'Leads by Campaign', lead_user:'Leads by Agent', na_user:'No Answer by Agent', sc_user:'Scheduled by Agent', sc_reason:'Scheduled by Reason', tr_lv:'TR-Live by Agent', tr_on:'TR-Online by Agent', ref_broker:'Referrals by Campaign', ref_user:'Referrals by Agent', bn:'Bad Number by Reason', ni:'Not Interested by Reason', assign:'Assignments by Agent' };
      return labels[this.s1Drill.type] || this.s1Drill.type;
    },
    s1DrillTotal() {
      if (!this.s1Drill) return 0;
      const c = this.s1Drill.item.count;
      return Array.isArray(c) ? (c[0] || 0) : (c || 0);
    },
    s1DrillExpRows() {
      if (!this.s1Drill || !this.s1Drill.expansion) return [];
      const exp = this.s1Drill.expansion;
      const total = exp.total ? (Array.isArray(exp.total.count) ? (exp.total.count[0] || 1) : (exp.total.count || 1)) : 1;
      const KEYS = [
        { key:'active', label:'Active', color:'#22c55e' },
        { key:'na',     label:'NA',     color:'#ef4444' },
        { key:'ni',     label:'NI',     color:'#b45309' },
        { key:'bn',     label:'BN',     color:'#78716c' },
        { key:'ended',  label:'Ended',  color:'#64748b' },
        { key:'merged', label:'Merged', color:'#a855f7' },
        { key:'t4',     label:'T4',     color:'#0ea5e9' },
      ];
      return KEYS.map(k => {
        const entry = exp[k.key];
        if (!entry) return null;
        const val = Array.isArray(entry.count) ? (entry.count[0] || 0) : (entry.count || 0);
        if (!val) return null;
        return { ...k, val, pct: Math.round(val / total * 100) };
      }).filter(Boolean);
    },

    s1CalGrid() {
      const { year, month } = this.s1Cal;
      const firstDay = new Date(year, month, 1);
      const startDow = (firstDay.getDay() + 6) % 7;
      const cursor = new Date(year, month, 1 - startDow);
      const _td = new Date(); const today = `${_td.getFullYear()}-${String(_td.getMonth()+1).padStart(2,'0')}-${String(_td.getDate()).padStart(2,'0')}`;
      const weeks = [];
      for (let w = 0; w < 6; w++) {
        const week = [];
        for (let d = 0; d < 7; d++) {
          const y = cursor.getFullYear(), m = String(cursor.getMonth() + 1).padStart(2, "0"), dy = String(cursor.getDate()).padStart(2, "0");
          const dateStr = `${y}-${m}-${dy}`;
          const snap = this.s1DayHistory[dateStr];
          week.push({ date: dateStr, day: cursor.getDate(), inMonth: cursor.getMonth() === month, today: dateStr === today, reg: snap ? (snap.REG || 0) : 0, hasData: !!snap });
          cursor.setDate(cursor.getDate() + 1);
        }
        weeks.push(week);
        if (w >= 3 && cursor.getMonth() !== month) break;
      }
      return weeks;
    },

    s1TimelinePoints() {
      const data = this.s1TimelineRaw;
      if (!data.length) return null;
      const vals = data.map(d => d.count || d.value || d.reg || 0);
      const max = Math.max(...vals, 1);
      const w = this.s1TlW, h = this.s1TlH - 20;
      const step = vals.length > 1 ? w / (vals.length - 1) : w;
      return vals.map((v, i) => `${i * step},${h - (v / max) * (h - 10)}`).join(" ");
    },
    s1TimelineArea() {
      const pts = this.s1TimelinePoints;
      if (!pts) return "";
      const h = this.s1TlH - 20;
      const parts = pts.split(" ");
      const firstX = parts[0].split(",")[0];
      const lastX  = parts[parts.length - 1].split(",")[0];
      return `${firstX},${h} ${pts} ${lastX},${h}`;
    },
    s1TlDotPoints() {
      const data = this.s1TimelineRaw;
      if (!data.length) return [];
      const vals = data.map(d => d.count || d.value || d.reg || 0);
      const max = Math.max(...vals, 1);
      const w = this.s1TlW, h = this.s1TlH - 20;
      const step = vals.length > 1 ? w / (vals.length - 1) : w;
      return vals.map((v, i) => ({
        x: i * step,
        y: h - (v / max) * (h - 10),
        label: (data[i].date || data[i].label || ("Day " + (i + 1))) + ": " + v,
      }));
    },
    s1TlXLabels() {
      const data = this.s1TimelineRaw;
      if (!data.length) return [];
      const labels = data.map(d => d.date || d.label || "");
      if (labels.length <= 10) return labels;
      const step = Math.floor(labels.length / 8);
      return labels.filter((_, i) => i % step === 0);
    },

    s1TimelineParams() {
      const base = this.s1DateParams;
      const p = {};
      if (base.registered_on_from) p.deposit_at_from = base.registered_on_from;
      if (base.registered_on_to)   p.deposit_at_to   = base.registered_on_to;
      if (this.s1AgentFilter.length) p.deposit_users  = this.s1AgentFilter;
      return p;
    },

    s1LiveKpis() {
      const d = this.s1LiveData;
      return [
        { key: "COST", label: "Total Cost",    val: d.Cost || d.cost || 0, color: "#6366f1" },
        { key: "REG",  label: "Registrations", val: d.REG  || d.reg  || 0, color: "#3b82f6" },
        { key: "DUP",  label: "Duplicates",    val: d.DUP  || d.dup  || 0, color: "#78716c" },
        { key: "NEW",  label: "New Clients",   val: d.NEW  || d.new  || 0, color: "#22c55e" },
        { key: "ON",   label: "Online Now",    val: d.ON   || d.on   || 0, color: "#14b8a6" },
        { key: "DP",   label: "Deposits",      val: d.DP   || d.dep  || 0, color: "#22c55e" },
      ];
    },

    s1KpiCards() {
      const d = this.s1TodayData || {};
      // titleInfo returns array [reg, dep] or [cost, reg, dep] — always last two are reg/dep
      const raw = this.s1TitleInfo;
      const infoReg = Array.isArray(raw) ? (raw[raw.length - 2] || 0) : (raw && (raw.reg || raw.REG) || 0);
      const infoDep = Array.isArray(raw) ? (raw[raw.length - 1] || 0) : (raw && (raw.dep || raw.DEP || raw.DP) || 0);
      const cards = [
        { key: 'reg', label: 'Registrations', abbr: 'REG', color: '#0057ff', value: d.REG  || infoReg || 0 },
        { key: 'dep', label: 'Deposits',       abbr: 'DEP', color: '#00b67a', value: d.DP   || infoDep || 0 },
        { key: 'na',  label: 'No Answer',      abbr: 'NA',  color: '#ef4444', value: d.NA   || 0 },
        { key: 'ld',  label: 'Leads',          abbr: 'LD',  color: '#f59e0b', value: d.LD   || 0 },
        { key: 'sc',  label: 'Sched. Calls',   abbr: 'CA',  color: '#7c3aed', value: d.CA   || 0 },
      ];
      const maxVal = Math.max(...cards.map(c => c.value), 1);
      return cards.map(c => ({ ...c, pct: Math.round((c.value / maxVal) * 100) }));
    },

    s1DepMaxCount()    { return Math.max(...this.s1DepBrokers.map(b => (Array.isArray(b.count) ? b.count[0] : b.count) || 0), 1); },
    s1DepMaxUser()     { return Math.max(...this.s1DepUsers.map(b => (Array.isArray(b.count) ? b.count[0] : b.count) || 0), 1); },
    s1DepStatusMax()   { return Math.max(...this.s1DepStatus.map(b => b.clients_count || b.count || 0), 1); },
    s1DepQuantityMax() { const c = (i) => Array.isArray(i.count) ? i.count[0] : (i.count || 0); return Math.max(...this.s1DepQuantity.map(c), 1); },
    s1DepStatusTotal() { return this.s1DepStatus.reduce((s, b) => s + (b.clients_count || b.count || 0), 0) || 1; },
    s1DepBrokerTotal() { return this.s1DepBrokers.reduce((s, b) => s + ((Array.isArray(b.count)?b.count[0]:b.count)||0), 0) || 1; },
    s1DepUserTotal()   { return this.s1DepUsers.reduce((s, b) => s + ((Array.isArray(b.count)?b.count[0]:b.count)||0), 0) || 1; },
    s1DepQuantityTotal(){ const c = (i) => Array.isArray(i.count)?i.count[0]:(i.count||0); return this.s1DepQuantity.reduce((s,b)=>s+c(b),0)||1; },
    s1LeadsMaxBroker() { return Math.max(...this.s1LeadsBrokers.map(b => b.count || 0), 1); },
    s1LeadsMaxUser()   { return Math.max(...this.s1LeadsUsers.map(b => b.count || 0), 1); },
    s1LeadsBrokerTotal(){ return this.s1LeadsBrokers.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1LeadsUserTotal() { return this.s1LeadsUsers.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1NAMax()          { return Math.max(...this.s1NAUsers.map(b => b.count || 0), 1); },
    s1NATotal()        { return this.s1NAUsers.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1SCMax()          { return Math.max(...this.s1SCUsers.map(b => b.count || 0), 1); },
    s1SCReasonsMax()   { return Math.max(...this.s1SCReasons.map(b => b.count || 0), 1); },
    s1CAPriorityMax()  { return Math.max(...this.s1CAPriority.map(b => b.count || 0), 1); },
    s1SCTotal()        { return this.s1SCUsers.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1SCReasonsTotal() { return this.s1SCReasons.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1CAPriorityTotal(){ return this.s1CAPriority.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1TrLVMax()        { return Math.max(...this.s1TransferUsersLV.map(b => b.count || 0), 1); },
    s1TrONMax()        { return Math.max(...this.s1TransferUsersON.map(b => b.count || 0), 1); },
    s1TrLVTotal()      { return this.s1TransferUsersLV.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1TrONTotal()      { return this.s1TransferUsersON.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1RefBrokerMax()   { return Math.max(...this.s1ReferralBrokers.map(b => b.count || 0), 1); },
    s1RefUserMax()     { return Math.max(...this.s1ReferralUsers.map(b => b.count || 0), 1); },
    s1RefBrokerTotal() { return this.s1ReferralBrokers.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1RefUserTotal()   { return this.s1ReferralUsers.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1BNMax()          { return Math.max(...this.s1BNReasons.map(b => b.count || 0), 1); },
    s1BNTotal()        { return this.s1BNReasons.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1NIMax()          { return Math.max(...this.s1NIReasons.map(b => b.count || 0), 1); },
    s1NITotal()        { return this.s1NIReasons.reduce((s,b)=>s+(b.count||0),0)||1; },
    s1AssignMax()      { return Math.max(...this.s1AssignUsers.map(b => b.count || 0), 1); },
    s1AssignTotal()    { return this.s1AssignUsers.reduce((s,b)=>s+(b.count||0),0)||1; },

    // AKG — list of column keys shown in the table
    s1AkgCols() {
      return [
        { key: 'REG',   label: 'REG',   color: '#0057ff' },
        { key: 'NEW',   label: 'NEW',   color: '#3b82f6' },
        { key: 'DP',    label: 'DEP',   color: '#00b67a' },
        { key: 'NA',    label: 'NA',    color: '#ef4444' },
        { key: 'CA',    label: 'CA',    color: '#7c3aed' },
        { key: 'LD',    label: 'LD',    color: '#f59e0b' },
        { key: 'RF',    label: 'RF',    color: '#f97316' },
        { key: 'BN',    label: 'BN',    color: '#78716c' },
        { key: 'NI',    label: 'NI',    color: '#b45309' },
        { key: 'TR-LV', label: 'TR-LV', color: '#8b5cf6' },
        { key: 'TR-ON', label: 'TR-ON', color: '#14b8a6' },
        { key: 'ENDED', label: 'END',   color: '#64748b' },
      ];
    },
    s1AkgRows() {
      return (this.s1AkgReports || []).map(r => ({
        date: r.date || '',
        ...( r.report || r ),
      }));
    },
    s1AkgTotals() {
      const rows = this.s1AkgRows;
      const totals = {};
      this.s1AkgCols.forEach(c => {
        totals[c.key] = rows.reduce((s, r) => s + (r[c.key] || 0), 0);
      });
      return totals;
    },

    // Countries
    s1CountriesActive() {
      if (this.s1CountriesView === 'tier')   return this.s1CountriesTiers;
      if (this.s1CountriesView === 'region') return this.s1CountriesParents;
      return this.s1CountriesList;
    },
    s1CountriesMax() {
      const c = (i) => Array.isArray(i.count) ? i.count[0] : (i.count || 0);
      return Math.max(...this.s1CountriesActive.map(c), 1);
    },
    s1CountriesTotal() {
      const c = (i) => Array.isArray(i.count) ? i.count[0] : (i.count || 0);
      return this.s1CountriesActive.reduce((s, b) => s + c(b), 0) || 1;
    },

    // Hours
    s1HoursMax() { return Math.max(...this.s1HoursData.map(h => h.count || 0), 1); },

    // Advertising
    s1AdvertisingMax()   { const c=(i)=>Array.isArray(i.count)?i.count[0]:(i.count||0); return Math.max(...this.s1AdvertisingList.map(c),1); },
    s1AdvertisingTotal() { const c=(i)=>Array.isArray(i.count)?i.count[0]:(i.count||0); return this.s1AdvertisingList.reduce((s,b)=>s+c(b),0)||1; },


    // ── Campaign Stats computed ────────────────────
    s1CampaignDataSorted() {
      const data = [...this.s1CampaignData];
      const key = this.s1CampView;
      if (key === 'leads') return data.sort((a, b) => (b.leads||b.count||0) - (a.leads||a.count||0));
      if (key === 'deposits') return data.sort((a, b) => (b.deposits||0) - (a.deposits||0));
      return data.sort((a, b) => {
        const crA = this.s1CalcCRNum(a.leads||a.count||0, a.deposits||0);
        const crB = this.s1CalcCRNum(b.leads||b.count||0, b.deposits||0);
        return crB - crA;
      });
    },
    s1CampTotalLeads() { return this.s1CampaignData.reduce((s,r) => s + (r.leads||r.count||0), 0); },
    s1CampTotalDeposits() { return this.s1CampaignData.reduce((s,r) => s + (r.deposits||0), 0); },

    // ── Broker Stats computed ──────────────────────
    s1BrokerStatsDataSorted() {
      const data = [...this.s1BrokerStatsData];
      const key = this.s1BrokerStView;
      if (key === 'deposits') return data.sort((a, b) => (b.deposits||0) - (a.deposits||0));
      if (key === 'leads') return data.sort((a, b) => (b.clients||b.count||0) - (a.clients||a.count||0));
      return data.sort((a, b) => {
        const crA = this.s1CalcCRNum(a.clients||a.count||0, a.deposits||0);
        const crB = this.s1CalcCRNum(b.clients||b.count||0, b.deposits||0);
        return crB - crA;
      });
    },
    s1BrokerStTotalClients() { return this.s1BrokerStatsData.reduce((s,r) => s + (r.clients||r.count||0), 0); },
    s1BrokerStTotalDeposits() { return this.s1BrokerStatsData.reduce((s,r) => s + (r.deposits||0), 0); },

    // ── Daily Report computed ──────────────────────
    s1DRTotals() {
      const data = this.s1DailyReportData;
      return {
        REG: data.reduce((s,a) => s + (a.REG||a.reg||0), 0),
        DP:  data.reduce((s,a) => s + (a.DP||a.dep||a.deposits||0), 0),
        CA:  data.reduce((s,a) => s + (a.CA||a.ca||a.scheduled||0), 0),
        NA:  data.reduce((s,a) => s + (a.NA||a.na||0), 0),
        NI:  data.reduce((s,a) => s + (a.NI||a.ni||0), 0),
        TR:  data.reduce((s,a) => s + (a['TR-LV']||a.tr_lv||0) + (a['TR-ON']||a.tr_on||0), 0),
        LD:  data.reduce((s,a) => s + (a.LD||a.ld||a.leads||0), 0),
      };
    },

    // ── Total Stats computed ───────────────────────
    s1TotalStatsKpis() {
      const d = this.s1TotalStatsRaw;
      const t = this.s1TodayData || {};
      return [
        { key: 'total_reg', label: 'Total Leads', value: d.total_leads||d.leads||d.reg||t.REG||0, color: '#0057ff', sub: this.s1ActiveRangeLabel },
        { key: 'total_dep', label: 'Total Deposits', value: d.total_deposits||d.deposits||d.dep||t.DP||0, color: '#00b67a', sub: this.s1ActiveRangeLabel },
        { key: 'total_calls', label: 'Total Calls', value: d.total_calls||d.calls||d.ca||t.CA||0, color: '#7c3aed' },
        { key: 'cr_pct', label: 'CR%', value: this.s1CalcCR(d.total_leads||d.leads||d.reg||t.REG||0, d.total_deposits||d.deposits||d.dep||t.DP||0), color: '#f59e0b', sub: 'Conversion Rate' },
        { key: 'total_na', label: 'No Answer', value: d.total_na||d.na||t.NA||0, color: '#ef4444' },
        { key: 'total_new', label: 'New Clients', value: d.total_new||d.new_clients||t.NEW||0, color: '#3b82f6' },
      ];
    },
    s1TotalStatsRows() {
      const d = this.s1TotalStatsRaw;
      if (!d || !Object.keys(d).length) return [];
      return [
        { key: 'all', label: 'All Clients', value: d.all||0, color: '#64748b', delta: 0 },
        { key: 'new', label: 'New', value: d.new_clients||d.NEW||0, color: '#3b82f6', delta: d.new_delta||0 },
        { key: 'active', label: 'Active', value: d.active||0, color: '#22c55e', delta: d.active_delta||0 },
        { key: 'leads', label: 'Leads', value: d.total_leads||d.leads||0, color: '#f59e0b', delta: d.leads_delta||0 },
        { key: 'deposits', label: 'Deposits', value: d.total_deposits||d.deposits||0, color: '#00b67a', delta: d.dep_delta||0 },
        { key: 'na', label: 'No Answer', value: d.total_na||d.na||0, color: '#ef4444', delta: d.na_delta||0 },
        { key: 'ca', label: 'Scheduled', value: d.total_calls||d.calls||0, color: '#7c3aed', delta: 0 },
        { key: 'dup', label: 'Duplicates', value: d.duplicates||d.dup||0, color: '#78716c', delta: 0 },
        { key: 'ended', label: 'Ended', value: d.ended||0, color: '#64748b', delta: 0 },
        { key: 'referrals', label: 'Referrals', value: d.referrals||d.rf||0, color: '#f97316', delta: 0 },
      ].filter(r => r.value > 0 || r.key === 'all');
    },

    s1PanelIsOpen() {
      return !!this.s1SlideOpen && this.s1SlideOpen !== 'menu';
    },
    s1PanelAtContent() {
      return this.s1PanelIsOpen && this.s1SlideOpen !== 'nav';
    },
    s1ActiveRangeLabel() {
      if (this.s1DateFilter === 'custom' && this.s1CalRangeFrom && this.s1CalRangeTo) {
        return this.s1CalRangeFrom + ' → ' + this.s1CalRangeTo;
      }
      const tf = this.s1TimeFrames.find(t => t.key === this.s1DateFilter);
      return tf ? tf.label : '';
    },
    s1AgentListFiltered() {
      if (!this.s1AgentSearch) return this.s1AgentList;
      const q = this.s1AgentSearch.toLowerCase();
      return this.s1AgentList.filter(a => {
        const name = (a.full_name || a.title || a.name || a.username || '').toLowerCase();
        return name.includes(q);
      });
    },
    s1ActivePanelLabel() {
      if (!this.s1PanelIsOpen || this.s1SlideOpen === 'nav') return 'Filters';
      if (this.s1PanelActiveContent === 'filters') {
        return this.s1FilterSubTab === 'agents' ? 'Agents' : 'Date Range';
      }
      if (this.s1PanelActiveContent === 'calendar') return 'Calendar';
      return 'Filters';
    },
    c1CurrentPageLabel() {
      const map = {
        '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
        '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
        '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
        '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
        '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return ((u.first_name || "") + " " + (u.last_name || "")).trim() || "User";
    },
    c1RoleLabel() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      return ROLE_MAP[(u && u.role)] || "User";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },

    // ── Teams: SVG chart points (Y coords, 0=top, 160=bottom) ──
    s1TeamsChartPoints() {
      const raw1 = this.s1TeamsChartData.t1 || [];
      const raw2 = this.s1TeamsChartData.t2 || [];
      const allVals = [...raw1, ...raw2].map(v => typeof v === 'object' ? (v[this.s1TeamsChartMetric] || v.value || 0) : (v || 0));
      const max = Math.max(...allVals, 1);
      const toY = (v) => Math.round(140 - ((typeof v === 'object' ? (v[this.s1TeamsChartMetric] || v.value || 0) : (v || 0)) / max) * 130);
      return {
        t1: raw1.map(toY),
        t2: raw2.map(toY),
      };
    },
  },

  created() {
    const _keepNav = sessionStorage.getItem('c1keepNav'); if (_keepNav) sessionStorage.removeItem('c1keepNav');
    const _openPanel = sessionStorage.getItem('c1openPanel'); if (_openPanel) sessionStorage.removeItem('c1openPanel');
    if (_openPanel) { this.s1SlideOpen = 'filters'; }
    else if (_keepNav) { this.s1SlideOpen = 'nav'; this.c1NavMode = 'panels'; }
    const tick = () => {
      const d = new Date();
      this.s1TimeStr = [d.getHours(), d.getMinutes(), d.getSeconds()].map(n => String(n).padStart(2, "0")).join(":");
    };
    tick();
    this._s1Ticker      = setInterval(tick, 1000);
    this._s1RefreshInt  = setInterval(() => { this.s1FetchToday(); this.s1FetchLive(); }, 120000);
    this._s1LiveInt     = setInterval(() => { this.s1FetchLive(); }, 30000);
  },

  mounted() {
    // Shift tracking
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      if (!this.c1Status) this.c1Status = 'shift';
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus && !this.c1Status) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
    document.documentElement.style.setProperty('--gnm-sw', '0px');
    this.s1FetchAll();
    this.s1LoadAgentList();
    this.s1FetchDayHistory();
    this.s1LoadGoals();
    this.s1LoadTransferRecs();
  },

  beforeDestroy() {
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
    clearInterval(this._s1Ticker);
    clearInterval(this._s1RefreshInt);
    clearInterval(this._s1LiveInt);
  },

  watch: {
    s1SlideOpen(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.s1PanelActiveContent = val;
      }
    },
    s1ActiveTab(val) {
      if (val === 'teams') {
        this.s1FetchTeamsData();
        this.s1FetchLeaderboard();
        this.s1FetchGoals();
      }
    },
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      if (!this.c1Status) this.c1Status = 'shift';
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },
    // ── Tab bar scrolling ─────────────────────────────────────
    s1SetTab(key) {
      this.s1ActiveTab = key;
    },
    s1ToggleTab(key) {
      this.s1ActiveTab = this.s1ActiveTab === key ? null : key;
    },
    s1GoToSection(key) {
      this.s1ActiveTab = key;
      this.s1SlideOpen = null;
      this.$nextTick(() => {
        const el = this.$el.querySelector(`.s1-tab-panel`);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },

    // ── Unified panel ─────────────────────────────────────────
    s1PanelBtnClick() {
      this.s1SlideOpen = this.s1PanelIsOpen ? null : 'nav';
    },
    s1SelectPanel(panel, sub) {
      if (panel === 'filters') {
        this.s1FilterSubTab = sub || 'date';
        this.s1SlideOpen = 'filters';
      } else if (panel === 'calendar') {
        this.s1SlideOpen = 'calendar';
      }
    },
    s1FilterPanelClick(e) {
      // prevent click from reaching backdrop's document handler
    },

    s1OpenSlide(name) { this.s1SlideOpen = this.s1SlideOpen === name ? null : name; },

    s1AgentInitials(agent) {
      const name = agent.full_name || agent.title || agent.name || agent.username || "";
      const parts = name.trim().split(" ");
      return (((parts[0] || "")[0] || "") + ((parts[1] || "")[0] || "")).toUpperCase() || "?";
    },
    s1AgentShortName(agent) {
      const name = agent.full_name || agent.title || agent.name || agent.username || "";
      return name.trim().split(" ")[0] || name;
    },
    s1AgentFullName(agent) {
      return agent.full_name || agent.title || agent.name || agent.username || '—';
    },
    s1AgentNameById(id) {
      const agent = this.s1AgentList.find(a => a.id === id);
      return agent ? (this.s1AgentFullName(agent).split(' ')[0] || '?') : '?';
    },
    s1ToggleAgent(id) {
      const idx = this.s1AgentFilter.indexOf(id);
      idx === -1 ? this.s1AgentFilter.push(id) : this.s1AgentFilter.splice(idx, 1);
    },
    s1ApplyDateFilter(preset) {
      this.s1DateFilter = preset;
      this.s1CalRangeFrom = null;
      this.s1CalRangeTo = null;
      this.s1CalSelecting = false;
      this.s1FetchAll();
    },

    s1LoadAgentList() {
      const fromStore = (this.$store.state.clients && this.$store.state.clients.salesPersonList) || [];
      if (fromStore.length) this.s1AgentList = fromStore;
      try {
        this.$store.dispatch("clients/getSalesPersonList").then(() => {
          const updated = (this.$store.state.clients && this.$store.state.clients.salesPersonList) || [];
          if (updated.length) this.s1AgentList = updated;
        }).catch(() => {});
      } catch(e) { console.warn(e); }
    },

    s1Headers() {
      const t = this.s1Token;
      return t ? { Authorization: `Bearer ${t}` } : {};
    },

    async s1FetchAll() {
      this.s1Loading = true;
      await Promise.allSettled([
        this.s1FetchTitleInfo(),
        this.s1FetchToday(),
        this.s1FetchAkg(),
        this.s1FetchDeposits(),
        this.s1FetchLeads(),
        this.s1FetchNA(),
        this.s1FetchSC(),
        this.s1FetchTransfers(),
        this.s1FetchReferrals(),
        this.s1FetchBN(),
        this.s1FetchNI(),
        this.s1FetchAssignments(),
        this.s1FetchCountries(),
        this.s1FetchHours(),
        this.s1FetchAdvertising(),
        this.s1FetchTimeline(),
        this.s1FetchLive(),
        this.s1FetchCampaignStats(),
        this.s1FetchBrokerStats(),
        this.s1FetchCosts(),
        this.s1FetchDailyReport(),
        this.s1FetchTotalStats(),
      ]);
      this.s1Loading = false;
    },

    async s1FetchTitleInfo() {
      try {
        const res = await axios.get("/api/client/stats/titleInfo", { headers: this.s1Headers() });
        const d = (res.data && res.data.data) || res.data || {};
        this.s1TitleInfo = d;
      } catch(e) { console.warn(e); }
    },

    async s1FetchToday() {
      this.s1Error = null;
      try {
        // today_chart only works for today — no date params needed
        const res = await axios.get("/api/client/stats/today_chart", { headers: this.s1Headers() });
        const raw = res.data;
        // response can be {data:{...}, factory:{...}} or {data:{...}} or {REG:x, NA:x, ...}
        const data = (raw && raw.data && typeof raw.data === 'object' && !Array.isArray(raw.data) && Object.keys(raw.data).length > 0)
          ? raw.data
          : (raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {});
        this.s1TodayData = data;
        this.s1HistoryData = [...this.s1HistoryData.slice(-6), data];
      } catch(e) {
        this.s1Error = "Stats load failed. " + ((e.response && e.response.data && e.response.data.message) || e.message || "");
      }
    },

    async s1FetchDeposits() {
      this.s1LoadingDeposits = true;
      try {
        const [rb, ru, rs, rq] = await Promise.allSettled([
          axios.get("/api/client/stats/multiselect/deposits/brokers",  { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/deposits/users",    { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/deposits/status",   { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/deposits/quantity", { headers: this.s1Headers(), params: this.s1DateParams }),
        ]);
        if (rb.status === "fulfilled") { const d = rb.value.data; this.s1DepBrokers  = Array.isArray(d) ? d : ((d && d.data) || []); }
        if (ru.status === "fulfilled") { const d = ru.value.data; this.s1DepUsers    = Array.isArray(d) ? d : ((d && d.data) || []); }
        if (rs.status === "fulfilled") { const d = rs.value.data; this.s1DepStatus   = Array.isArray(d) ? d : ((d && d.data) || []); }
        if (rq.status === "fulfilled") { const d = rq.value.data; this.s1DepQuantity = Array.isArray(d) ? d : ((d && d.data) || []); }
      } catch(e) { console.warn(e); } finally { this.s1LoadingDeposits = false; }
    },

    async s1FetchLeads() {
      this.s1LoadingLeads = true;
      try {
        const [rb, ru] = await Promise.allSettled([
          axios.get("/api/client/stats/multiselect/leads/brokers", { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/leads/users",   { headers: this.s1Headers(), params: this.s1DateParams }),
        ]);
        if (rb.status === "fulfilled") {
          const d = rb.value.data;
          this.s1LeadsBrokers = Array.isArray(d) ? d : ((d && d.data) || []);
        }
        if (ru.status === "fulfilled") {
          const d = ru.value.data;
          this.s1LeadsUsers = Array.isArray(d) ? d : ((d && d.data) || []);
        }
      } catch(e) { console.warn(e); } finally { this.s1LoadingLeads = false; }
    },

    async s1FetchNA() {
      this.s1LoadingNA = true;
      try {
        const res = await axios.get("/api/client/stats/multiselect/no_answer/users", { headers: this.s1Headers(), params: this.s1DateParams });
        const d = res.data;
        this.s1NAUsers = Array.isArray(d) ? d : ((d && d.data) || []);
      } catch(e) { console.warn(e); } finally { this.s1LoadingNA = false; }
    },

    async s1FetchSC() {
      this.s1LoadingSC = true;
      try {
        const [ru, rr, rp] = await Promise.allSettled([
          axios.get("/api/client/stats/multiselect/call_again/users",    { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/call_again/reasons",  { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/call_again/priority", { headers: this.s1Headers(), params: this.s1DateParams }),
        ]);
        if (ru.status === "fulfilled") { const d = ru.value.data; this.s1SCUsers    = Array.isArray(d) ? d : ((d && d.data) || []); }
        if (rr.status === "fulfilled") { const d = rr.value.data; this.s1SCReasons  = Array.isArray(d) ? d : ((d && d.data) || []); }
        if (rp.status === "fulfilled") { const d = rp.value.data; this.s1CAPriority = Array.isArray(d) ? d : ((d && d.data) || []); }
      } catch(e) { console.warn(e); } finally { this.s1LoadingSC = false; }
    },

    async s1FetchTransfers() {
      this.s1LoadingTransfers = true;
      try {
        const [rt, rlv, ron] = await Promise.allSettled([
          axios.get("/api/client/stats/multiselect/transfer/types",   { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/transfer/users/1", { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/transfer/users/2", { headers: this.s1Headers(), params: this.s1DateParams }),
        ]);
        if (rt.status === "fulfilled") {
          const d = rt.value.data;
          this.s1TransferTypes = Array.isArray(d) ? d : ((d && d.data) || []);
        }
        if (rlv.status === "fulfilled") {
          const d = rlv.value.data;
          this.s1TransferUsersLV = Array.isArray(d) ? d : ((d && d.data) || []);
        }
        if (ron.status === "fulfilled") {
          const d = ron.value.data;
          this.s1TransferUsersON = Array.isArray(d) ? d : ((d && d.data) || []);
        }
      } catch(e) { console.warn(e); } finally { this.s1LoadingTransfers = false; }
    },

    async s1FetchReferrals() {
      this.s1LoadingReferrals = true;
      try {
        const [rb, ru] = await Promise.allSettled([
          axios.get("/api/client/stats/multiselect/referral/brokers", { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/referral/users",   { headers: this.s1Headers(), params: this.s1DateParams }),
        ]);
        if (rb.status === "fulfilled") {
          const d = rb.value.data;
          this.s1ReferralBrokers = Array.isArray(d) ? d : ((d && d.data) || []);
        }
        if (ru.status === "fulfilled") {
          const d = ru.value.data;
          this.s1ReferralUsers = Array.isArray(d) ? d : ((d && d.data) || []);
        }
      } catch(e) { console.warn(e); } finally { this.s1LoadingReferrals = false; }
    },

    async s1FetchAkg(tf) {
      this.s1LoadingAkg = true;
      this.s1AkgExpand = {};
      const timeFrame = tf || this.s1AkgTimeFrame;
      try {
        const params = { ...this.s1DateParams };
        if (this.s1AgentFilter.length) params.group_assigned = this.s1AgentFilter;
        const res = await axios.get(`/api/client/stats/akg/${timeFrame}`, { headers: this.s1Headers(), params });
        const d = res.data;
        const reports = (d && d.reports) || (Array.isArray(d) ? d : []);
        this.s1AkgReports = reports;
        this.s1AkgTimeFrame = timeFrame;
      } catch(e) {
        this.s1Error = "AKG load failed. " + ((e.response && e.response.data && e.response.data.message) || e.message || "");
      } finally { this.s1LoadingAkg = false; }
    },

    s1AkgToggleDay(date) {
      const cur = this.s1AkgExpand[date];
      if (cur && cur.open) {
        this.$set(this.s1AkgExpand, date, { ...cur, open: false });
      } else if (cur && cur.users) {
        this.$set(this.s1AkgExpand, date, { ...cur, open: true });
      } else {
        this.$set(this.s1AkgExpand, date, { open: true, loading: true, users: [] });
        this.s1FetchAkgDayUsers(date);
      }
    },

    async s1FetchAkgDayUsers(date) {
      try {
        const res = await axios.get(`/api/client/stats/akg/day/${date}/users`, { headers: this.s1Headers() });
        const users = Array.isArray(res.data) ? res.data : [];
        this.$set(this.s1AkgExpand, date, { open: true, loading: false, users });
      } catch(e) {
        this.$set(this.s1AkgExpand, date, { open: true, loading: false, users: [] });
      }
    },

    s1AkgUserInitials(name) {
      if (!name) return '?';
      return name.split(' ').filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
    },

    async s1FetchCountries() {
      this.s1LoadingCountries = true;
      try {
        const [rc, rt, rp] = await Promise.allSettled([
          axios.get("/api/client/stats/multiselect/countries/countries", { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/countries/tiers",     { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/countries/parents",   { headers: this.s1Headers(), params: this.s1DateParams }),
        ]);
        if (rc.status === "fulfilled") { const d = rc.value.data; this.s1CountriesList    = Array.isArray(d) ? d : ((d && d.data) || []); }
        if (rt.status === "fulfilled") { const d = rt.value.data; this.s1CountriesTiers   = Array.isArray(d) ? d : ((d && d.data) || []); }
        if (rp.status === "fulfilled") { const d = rp.value.data; this.s1CountriesParents = Array.isArray(d) ? d : ((d && d.data) || []); }
      } catch(e) { console.warn(e); } finally { this.s1LoadingCountries = false; }
    },

    async s1FetchHours(metric) {
      this.s1LoadingHours = true;
      const preset = metric || this.s1HoursMetric;
      try {
        const res = await axios.get(`/api/client/stats/calendar/hours_stats/${preset}`, { headers: this.s1Headers(), params: this.s1DateParams });
        const d = res.data;
        this.s1HoursData = Array.isArray(d) ? d : ((d && d.data) || []);
        this.s1HoursMetric = preset;
      } catch(e) { console.warn(e); } finally { this.s1LoadingHours = false; }
    },

    async s1FetchAdvertising() {
      this.s1LoadingAdvertising = true;
      try {
        const res = await axios.get("/api/client/stats/multiselect/advertising", { headers: this.s1Headers(), params: this.s1DateParams });
        const d = res.data;
        this.s1AdvertisingList = Array.isArray(d) ? d : ((d && d.data) || []);
      } catch(e) { console.warn(e); } finally { this.s1LoadingAdvertising = false; }
    },

    async s1FetchBN() {
      this.s1LoadingBN = true;
      try {
        const res = await axios.get("/api/client/stats/multiselect/bad_number", { headers: this.s1Headers(), params: this.s1DateParams });
        const d = res.data;
        this.s1BNReasons = Array.isArray(d) ? d : ((d && d.data) || []);
      } catch(e) { console.warn(e); } finally { this.s1LoadingBN = false; }
    },

    async s1FetchNI() {
      this.s1LoadingNI = true;
      try {
        const res = await axios.get("/api/client/stats/multiselect/not_interested", { headers: this.s1Headers(), params: this.s1DateParams });
        const d = res.data;
        this.s1NIReasons = Array.isArray(d) ? d : ((d && d.data) || []);
      } catch(e) { console.warn(e); } finally { this.s1LoadingNI = false; }
    },

    async s1FetchAssignments() {
      this.s1LoadingAssign = true;
      try {
        const res = await axios.get("/api/client/stats/multiselect/assignments/assignments", { headers: this.s1Headers(), params: this.s1DateParams });
        const d = res.data;
        this.s1AssignUsers = Array.isArray(d) ? d : ((d && d.data) || []);
      } catch(e) { console.warn(e); } finally { this.s1LoadingAssign = false; }
    },

    async s1FetchTimeline() {
      this.s1LoadingTimeline = true;
      try {
        const res = await axios.get("/api/client/stats/dynamic/volatility", { headers: this.s1Headers(), params: this.s1TimelineParams });
        const d = res.data;
        this.s1TimelineRaw = Array.isArray(d) ? d : ((d && d.data) || []);
      } catch(e) { console.warn(e); } finally { this.s1LoadingTimeline = false; }
    },

    async s1FetchLive() {
      try {
        const res = await axios.get("/api/client/stats/live_leads_stats", { headers: this.s1Headers() });
        this.s1LiveData = (res.data && res.data.data) || res.data || {};
        this.s1LiveUpdatedAt = new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
      } catch(e) { console.warn(e); }
    },

    s1CalSelectDay(day) {
      if (!day.inMonth) return;
      const d = day.date;
      if (!this.s1CalSelecting || !this.s1CalRangeFrom) {
        // first click — set FROM
        this.s1CalRangeFrom = d;
        this.s1CalRangeTo   = null;
        this.s1CalSelecting = true;
        this.s1CalSelected  = d;
      } else {
        // second click — set TO (swap if needed)
        const from = this.s1CalRangeFrom;
        this.s1CalRangeTo   = d >= from ? d : from;
        this.s1CalRangeFrom = d >= from ? from : d;
        this.s1CalSelecting = false;
        this.s1CalSelected  = null;
        this.s1DateFilter   = 'custom';
        this.s1FetchAll();
      }
    },
    s1CalClearRange() {
      this.s1CalRangeFrom = null;
      this.s1CalRangeTo   = null;
      this.s1CalSelecting = false;
      this.s1CalSelected  = null;
      this.s1DateFilter   = 'today';
      this.s1FetchAll();
    },

    s1CalPrev() {
      this.s1Cal.month === 0 ? (this.s1Cal.month = 11, this.s1Cal.year--) : this.s1Cal.month--;
      this.s1FetchDayHistory();
    },
    s1CalNext() {
      this.s1Cal.month === 11 ? (this.s1Cal.month = 0, this.s1Cal.year++) : this.s1Cal.month++;
      this.s1FetchDayHistory();
    },

    async s1FetchDayHistory() {
      const { year, month } = this.s1Cal;
      const pad = n => String(n).padStart(2, '0');
      const from = `${year}-${pad(month + 1)}-01`;
      const lastDay = new Date(year, month + 1, 0).getDate();
      const to = `${year}-${pad(month + 1)}-${pad(lastDay)}`;
      try {
        const res = await axios.get('/api/client/stats/calendar/reg/days', {
          headers: this.s1Headers(),
          params: { registered_on_from: from, registered_on_to: to }
        });
        const list = Array.isArray(res.data) ? res.data : ((res.data && res.data.data) || []);
        const hist = {};
        list.forEach(item => {
          if (item.date && /^\d{4}-\d{2}-\d{2}$/.test(item.date)) {
            hist[item.date] = { REG: item.count || 0 };
          }
        });
        this.s1DayHistory = hist;
      } catch(e) { console.warn(e); }
    },

    s1SparkData(key) {
      if (this.s1HistoryData.length < 2) return [0, 1, 0, 2, 1, 3, 2];
      return this.s1HistoryData.slice(-7).map(d => d[key] || 0);
    },
    s1SparkPoints(vals) {
      if (!vals || !vals.length) return "";
      const max = Math.max(...vals, 1);
      const w = 60 / (vals.length - 1 || 1);
      return vals.map((v, i) => `${i * w},${24 - (v / max) * 20}`).join(" ");
    },
    s1BuildTrendPoly(vals) {
      if (!vals || !vals.length) return "";
      const max = Math.max(...vals, 1);
      const w = (this.s1Week.length * 56) / (vals.length - 1 || 1);
      return vals.map((v, i) => `${i * w + 28},${8 + 60 - (v / max) * 60}`).join(" ");
    },
    // bar pct (relative to max — drives bar width)
    s1DepBrokerPct(item)   { const c=(Array.isArray(item.count)?item.count[0]:item.count)||0; return Math.round(c/this.s1DepMaxCount*100); },
    s1DepUserPct(item)     { const c=(Array.isArray(item.count)?item.count[0]:item.count)||0; return Math.round(c/this.s1DepMaxUser*100); },
    s1DepStatusPct(item)   { const c=item.clients_count||item.count||0; return Math.round(c/this.s1DepStatusMax*100); },
    s1DepQuantityPct(item) { const c=(Array.isArray(item.count)?item.count[0]:item.count)||0; return Math.round(c/this.s1DepQuantityMax*100); },
    s1LeadsBrokerPct(item) { return Math.round((item.count||0)/this.s1LeadsMaxBroker*100); },
    s1LeadsUserPct(item)   { return Math.round((item.count||0)/this.s1LeadsMaxUser*100); },
    s1NAUserPct(item)      { return Math.round((item.count||0)/this.s1NAMax*100); },
    s1SCUserPct(item)      { return Math.round((item.count||0)/this.s1SCMax*100); },
    s1SCReasonsPct(item)   { return Math.round((item.count||0)/this.s1SCReasonsMax*100); },
    s1CAPriorityPct(item)  { return Math.round((item.count||0)/this.s1CAPriorityMax*100); },
    s1TrLVPct(item)        { return Math.round((item.count||0)/this.s1TrLVMax*100); },
    s1TrONPct(item)        { return Math.round((item.count||0)/this.s1TrONMax*100); },
    s1RefBrokerPct(item)   { return Math.round((item.count||0)/this.s1RefBrokerMax*100); },
    s1RefUserPct(item)     { return Math.round((item.count||0)/this.s1RefUserMax*100); },
    s1BNPct(item)          { return Math.round((item.count||0)/this.s1BNMax*100); },
    s1NIPct(item)          { return Math.round((item.count||0)/this.s1NIMax*100); },
    s1AssignPct(item)      { return Math.round((item.count||0)/this.s1AssignMax*100); },
    s1CountriesPct(item)   { const c=Array.isArray(item.count)?item.count[0]:(item.count||0); return Math.round(c/this.s1CountriesMax*100); },
    s1AdvertisingPct(item) { const c=Array.isArray(item.count)?item.count[0]:(item.count||0); return Math.round(c/this.s1AdvertisingMax*100); },
    s1HoursPct(item)       { return Math.round((item.count||0)/this.s1HoursMax*100); },
    s1AkgCellVal(row, key) {
      const v = row[key];
      if (v === undefined || v === null) return '—';
      return typeof v === 'number' ? v : (Array.isArray(v) ? v[0] : v);
    },
    // share of total pct (shown as number in rightmost column)
    s1SharePct(val, total) { return Math.round((val/(total||1))*100); },
    s1DepTooltip(item) {
      const c = item.count;
      if (!Array.isArray(c)) return (item.title || "") + ": " + (c || 0);
      return (item.title || "") + "\nFreq: " + (c[0]||0) + "\nClients: " + (c[1]||0) + "\nCC Dec: " + (c[2]||0) + "\nDev: " + (c[3]||0);
    },


    // ── CR% helper ──────────────────────────────────
    s1CalcCR(leads, deps) {
      if (!leads || leads <= 0) return '0.0';
      return ((deps / leads) * 100).toFixed(1);
    },
    s1CalcCRNum(leads, deps) {
      if (!leads || leads <= 0) return 0;
      return (deps / leads) * 100;
    },
    s1FormatCurrency(val) {
      if (val === undefined || val === null) return '$0';
      const num = typeof val === 'string' ? parseFloat(val) : val;
      if (isNaN(num)) return '$0';
      if (Math.abs(num) >= 1000000) return '$' + (num / 1000000).toFixed(1) + 'M';
      if (Math.abs(num) >= 1000) return '$' + (num / 1000).toFixed(1) + 'K';
      return '$' + num.toFixed(2);
    },
    s1DRInitials(agent) {
      const name = agent.name || agent.full_name || '';
      const parts = name.trim().split(' ');
      return (((parts[0]||'')[0]||'') + ((parts[1]||'')[0]||'')).toUpperCase() || '?';
    },

    // ── Campaign Stats fetch ────────────────────────
    async s1FetchCampaignStats() {
      this.s1LoadingCampaignStats = true;
      try {
        const res = await axios.get("/api/client/stats/multiselect/advertising", { headers: this.s1Headers(), params: this.s1DateParams });
        const d = res.data;
        const list = Array.isArray(d) ? d : ((d && d.data) || []);
        this.s1CampaignData = list.map((item, i) => ({
          id: item.id || i,
          title: item.title || item.name || item.id || ('Campaign ' + (i+1)),
          leads: (Array.isArray(item.count) ? item.count[0] : item.count) || 0,
          deposits: (Array.isArray(item.count) ? (item.count[1]||0) : 0),
          count: (Array.isArray(item.count) ? item.count[0] : item.count) || 0,
        }));
      } catch(e) { this.s1CampaignData = []; } finally { this.s1LoadingCampaignStats = false; }
    },

    // ── Broker Stats fetch ──────────────────────────
    async s1FetchBrokerStats() {
      this.s1LoadingBrokerStats = true;
      try {
        const [rDep, rLead] = await Promise.allSettled([
          axios.get("/api/client/stats/multiselect/deposits/brokers", { headers: this.s1Headers(), params: this.s1DateParams }),
          axios.get("/api/client/stats/multiselect/leads/brokers",    { headers: this.s1Headers(), params: this.s1DateParams }),
        ]);
        const depData  = rDep.status  === 'fulfilled' ? (Array.isArray(rDep.value.data)  ? rDep.value.data  : ((rDep.value.data  && rDep.value.data.data)  || [])) : [];
        const leadData = rLead.status === 'fulfilled' ? (Array.isArray(rLead.value.data) ? rLead.value.data : ((rLead.value.data && rLead.value.data.data) || [])) : [];
        const brokerMap = {};
        leadData.forEach(item => {
          const key = item.id || item.title;
          brokerMap[key] = { id: item.id, title: item.title || item.name || '—', clients: (Array.isArray(item.count) ? item.count[0] : item.count) || 0, deposits: 0 };
        });
        depData.forEach(item => {
          const key = item.id || item.title;
          if (!brokerMap[key]) brokerMap[key] = { id: item.id, title: item.title || item.name || '—', clients: 0, deposits: 0 };
          brokerMap[key].deposits = (Array.isArray(item.count) ? item.count[0] : item.count) || 0;
        });
        this.s1BrokerStatsData = Object.values(brokerMap);
      } catch(e) { this.s1BrokerStatsData = []; } finally { this.s1LoadingBrokerStats = false; }
    },

    // ── Costs fetch ─────────────────────────────────
    async s1FetchCosts() {
      this.s1LoadingCosts = true;
      try {
        const res = await axios.get("/api/client/stats/costs", { headers: this.s1Headers(), params: this.s1DateParams });
        const d = (res.data && res.data.data) || res.data || {};
        if (Array.isArray(d)) {
          this.s1CostsItems = d;
          this.s1CostsData = { total: d.reduce((s, i) => s + (i.amount||i.cost||i.total||0), 0) };
        } else if (typeof d === 'object') {
          this.s1CostsData = d;
          this.s1CostsItems = d.items || d.categories || d.breakdown || [];
        }
      } catch(e) {} finally { this.s1LoadingCosts = false; }
    },

    // ── Daily Report fetch ──────────────────────────
    async s1FetchDailyReport() {
      this.s1LoadingDailyReport = true;
      try {
        const res = await axios.get("/api/client/stats/akg/day/" + this.s1TodayDateStr() + "/users", { headers: this.s1Headers() });
        this.s1DailyReportData = Array.isArray(res.data) ? res.data : [];
      } catch(e) { this.s1DailyReportData = []; } finally { this.s1LoadingDailyReport = false; }
    },

    s1TodayDateStr() {
      const d = new Date();
      return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
    },

    // ── Total Stats fetch ───────────────────────────
    async s1FetchTotalStats() {
      this.s1LoadingTotalStats = true;
      try {
        const calls = [
          axios.get("/api/client/stats/clients/all",        { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
          axios.get("/api/client/stats/clients/new",         { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
          axios.get("/api/client/stats/clients/active",      { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
          axios.get("/api/client/stats/clients/leads",       { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
          axios.get("/api/client/stats/clients/deposits",    { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
          axios.get("/api/client/stats/clients/na",          { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
          axios.get("/api/client/stats/clients/scheduled_calls", { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
          axios.get("/api/client/stats/clients/duplicates",  { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
          axios.get("/api/client/stats/clients/ended",       { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
          axios.get("/api/client/stats/clients/referrals",   { headers: this.s1Headers(), params: this.s1DateParams }).catch(() => null),
        ];
        const results = await Promise.all(calls);
        const extract = (r) => {
          if (!r || !r.data) return 0;
          const d = r.data;
          if (typeof d === 'number') return d;
          if (d.data !== undefined) return typeof d.data === 'number' ? d.data : (d.data.count || d.data.total || 0);
          return d.count || d.total || d.value || 0;
        };
        this.s1TotalStatsRaw = {
          all: extract(results[0]),
          new_clients: extract(results[1]),
          active: extract(results[2]),
          total_leads: extract(results[3]) || (this.s1TodayData && this.s1TodayData.LD) || 0,
          total_deposits: extract(results[4]) || (this.s1TodayData && this.s1TodayData.DP) || 0,
          total_na: extract(results[5]) || (this.s1TodayData && this.s1TodayData.NA) || 0,
          total_calls: extract(results[6]) || (this.s1TodayData && this.s1TodayData.CA) || 0,
          duplicates: extract(results[7]),
          ended: extract(results[8]),
          referrals: extract(results[9]),
        };
      } catch(e) {} finally { this.s1LoadingTotalStats = false; }
    },

    s1IsDrillOpen(item, type) {
      return !!(this.s1Drill && this.s1Drill.type === type && this.s1Drill.item.id === item.id);
    },

    s1ToggleDrill(item, type) {
      if (this.s1IsDrillOpen(item, type)) {
        this.s1Drill = null;
      } else {
        this.s1OpenDrill(item, type);
      }
    },

    s1OpenDrill(item, type) {
      const USER_TYPES   = ['na_user','sc_user','dep_user','lead_user','tr_lv','tr_on','ref_user','assign'];
      const BROKER_TYPES = ['dep_broker','lead_broker','ref_broker'];
      const isUser    = USER_TYPES.includes(type);
      const isCountry = type === 'country';
      const id = item.id;

      let panels = [];
      if (isUser) {
        panels = [
          { title: 'Top Campaigns',      loading: true, items: [], color: '#7C5CFC', endpoint: '/api/client/stats/multiselect/leads/brokers',       param: { group_assigned: [id] } },
          { title: 'Top Countries',      loading: true, items: [], color: '#0ea5e9', endpoint: '/api/client/stats/multiselect/countries/countries',  param: { group_assigned: [id] } },
          { title: 'Deposit Brokers',    loading: true, items: [], color: '#f59e0b', endpoint: '/api/client/stats/multiselect/deposits/brokers',     param: { group_assigned: [id] } },
          { title: 'Deposit Agents',     loading: true, items: [], color: '#22c55e', endpoint: '/api/client/stats/multiselect/deposits/users',       param: { group_assigned: [id] } },
        ];
      } else if (type === 'dep_broker') {
        panels = [
          { title: 'Top Agents',         loading: true, items: [], color: '#7C5CFC', endpoint: '/api/client/stats/multiselect/deposits/users',       param: { deposit_brokers: [id] } },
          { title: 'Top Countries',      loading: true, items: [], color: '#0ea5e9', endpoint: '/api/client/stats/multiselect/countries/countries',  param: { deposit_brokers: [id] } },
          { title: 'Source Campaigns',   loading: true, items: [], color: '#f59e0b', endpoint: '/api/client/stats/multiselect/leads/brokers',        param: { deposit_brokers: [id] } },
          { title: 'Lead Agents',        loading: true, items: [], color: '#22c55e', endpoint: '/api/client/stats/multiselect/leads/users',          param: { deposit_brokers: [id] } },
        ];
      } else if (type === 'lead_broker') {
        panels = [
          { title: 'Top Agents',         loading: true, items: [], color: '#7C5CFC', endpoint: '/api/client/stats/multiselect/leads/users',          param: { lead_campaigns: [id] } },
          { title: 'Deposit Agents',     loading: true, items: [], color: '#22c55e', endpoint: '/api/client/stats/multiselect/deposits/users',       param: { lead_campaigns: [id] } },
          { title: 'Top Countries',      loading: true, items: [], color: '#0ea5e9', endpoint: '/api/client/stats/multiselect/countries/countries',  param: { lead_campaigns: [id] } },
          { title: 'Deposit Brokers',    loading: true, items: [], color: '#f59e0b', endpoint: '/api/client/stats/multiselect/deposits/brokers',     param: { lead_campaigns: [id] } },
        ];
      } else if (type === 'ref_broker') {
        panels = [
          { title: 'Top Agents',         loading: true, items: [], color: '#7C5CFC', endpoint: '/api/client/stats/multiselect/referral/users',       param: { deposit_brokers: [id] } },
          { title: 'Top Countries',      loading: true, items: [], color: '#0ea5e9', endpoint: '/api/client/stats/multiselect/countries/countries',  param: { deposit_brokers: [id] } },
        ];
      } else if (isCountry) {
        panels = [
          { title: 'Top Deposit Agents', loading: true, items: [], color: '#22c55e', endpoint: '/api/client/stats/multiselect/deposits/users',       param: { countries: [id] } },
          { title: 'Top Lead Agents',    loading: true, items: [], color: '#7C5CFC', endpoint: '/api/client/stats/multiselect/leads/users',           param: { countries: [id] } },
          { title: 'Top Campaigns',      loading: true, items: [], color: '#8b5cf6', endpoint: '/api/client/stats/multiselect/leads/brokers',         param: { countries: [id] } },
          { title: 'Deposit Brokers',    loading: true, items: [], color: '#f59e0b', endpoint: '/api/client/stats/multiselect/deposits/brokers',      param: { countries: [id] } },
        ];
      }
      // sc_reason, bn, ni, assign: no panels — expansion only

      this.s1Drill = {
        item, type,
        loadingExpand: !isCountry,
        expansion: null,
        panels,
      };
      this.s1FetchDrillData(item, type);
    },

    async s1FetchDrillData(item, type) {
      const ENDPOINTS = {
        dep_broker: '/api/client/stats/multiselect/deposits/brokers',
        dep_user:   '/api/client/stats/multiselect/deposits/users',
        lead_broker:'/api/client/stats/multiselect/leads/brokers',
        lead_user:  '/api/client/stats/multiselect/leads/users',
        na_user:    '/api/client/stats/multiselect/no_answer/users',
        sc_user:    '/api/client/stats/multiselect/call_again/users',
        sc_reason:  '/api/client/stats/multiselect/call_again/reasons',
        tr_lv:      '/api/client/stats/multiselect/transfer/users/1',
        tr_on:      '/api/client/stats/multiselect/transfer/users/2',
        ref_broker: '/api/client/stats/multiselect/referral/brokers',
        ref_user:   '/api/client/stats/multiselect/referral/users',
        bn:         '/api/client/stats/multiselect/bad_number',
        ni:         '/api/client/stats/multiselect/not_interested',
        assign:     '/api/client/stats/multiselect/assignments/assignments',
      };
      const isCountry = type === 'country';

      // ── Step 1: expansion (status breakdown) — skip for country ──────────
      if (!isCountry) {
        const endpoint = ENDPOINTS[type];
        if (!endpoint || !this.s1Drill) return;
        const params = { ...this.s1DateParams, with_expand: 'true' };
        try {
          const res = await axios.get(endpoint, { headers: this.s1Headers(), params });
          const data = Array.isArray(res.data) ? res.data : ((res.data && res.data.data) || []);
          const found = data.find(d => String(d.id) === String(item.id));
          if (this.s1Drill && this.s1Drill.item.id === item.id) {
            this.s1Drill = { ...this.s1Drill, loadingExpand: false, expansion: (found && found.expansion) || null };
          }
        } catch(e) {
          if (this.s1Drill && this.s1Drill.item.id === item.id) {
            this.s1Drill = { ...this.s1Drill, loadingExpand: false };
          }
        }
      }

      // ── Step 2: fetch all panels in parallel ──────────────────────────────
      if (!this.s1Drill || this.s1Drill.item.id !== item.id) return;
      const panels = this.s1Drill.panels;
      if (!panels || !panels.length) return;

      await Promise.all(panels.map(async (panel, pi) => {
        try {
          const res = await axios.get(panel.endpoint, {
            headers: this.s1Headers(),
            params: { ...this.s1DateParams, ...panel.param },
          });
          const data = Array.isArray(res.data) ? res.data : ((res.data && res.data.data) || []);
          if (this.s1Drill && this.s1Drill.item.id === item.id) {
            const np = [...this.s1Drill.panels];
            np[pi] = { ...np[pi], loading: false, items: data.filter(r => this.s1DrillCount(r) > 0).slice(0, 10) };
            this.s1Drill = { ...this.s1Drill, panels: np };
          }
        } catch(e) {
          if (this.s1Drill && this.s1Drill.item.id === item.id) {
            const np = [...this.s1Drill.panels];
            np[pi] = { ...np[pi], loading: false, items: [] };
            this.s1Drill = { ...this.s1Drill, panels: np };
          }
        }
      }));
    },

    s1DrillCount(item) {
      const c = item.count;
      return Array.isArray(c) ? (c[0] || 0) : (c || 0);
    },

    s1DrillPanelPct(panel, rel) {
      if (!panel || !panel.items || !panel.items.length) return 0;
      const max = Math.max(...panel.items.map(r => this.s1DrillCount(r)), 1);
      return Math.round(this.s1DrillCount(rel) / max * 100);
    },

    s1TooltipShow(e, text) {
      const rect = this.$el.getBoundingClientRect();
      this.s1Tooltip = { visible: true, text, x: e.clientX - rect.left + 12, y: e.clientY - rect.top - 36 };
    },
    s1TooltipHide() { this.s1Tooltip.visible = false; },

    // ── Deposit Goals ─────────────────────────────
    async s1LoadGoals() {
      for (const g of this.s1Goals) {
        try {
          const tRes = await axios.get(`/api/admin/settings/deposits/goal/${g.period}`, { headers: this.s1Headers() });
          const tData = tRes.data;
          if (tData && tData.goal) { g.target = tData.goal; g.id = tData.id; g.editTarget = tData.goal; }
          const aRes = await axios.get(`/api/client/stats/clients/deposits/goal/${g.period}`, { headers: this.s1Headers() });
          const aData = aRes.data;
          g.actual = aData && aData.actual !== undefined ? aData.actual : (aData || 0);
          g.pct = g.target ? Math.round((g.actual / g.target) * 100) : 0;
        } catch(e) { /* graceful — leave defaults */ }
      }
    },
    async s1SaveGoal(goal) {
      if (!goal.editTarget) return;
      try {
        if (goal.id) {
          await axios.put(`/api/admin/settings/deposits/goal/update/${goal.id}`, { goal: goal.editTarget, period: goal.period }, { headers: this.s1Headers() });
        } else {
          const res = await axios.post('/api/admin/settings/deposits/goal/new', { goal: goal.editTarget, period: goal.period }, { headers: this.s1Headers() });
          if (res.data && res.data.id) goal.id = res.data.id;
        }
        goal.target = goal.editTarget;
        goal.pct = goal.target ? Math.round((goal.actual / goal.target) * 100) : 0;
      } catch(e) { console.error('Save goal failed', e); }
    },

    // ── Agent Transfer Recommendations ────────────────────────────
    async s1LoadTransferRecs() {
      this.s1TransferLoading = true;
      try {
        const r = await axios.get(this.$store.getters.getServerPath + '/client/stats/assigned/ranking/assigned', { headers: this.s1Headers() });
        this.s1TransferRecs = Array.isArray(r.data) ? r.data : (r.data.data || r.data.agents || []);
      } catch(e) { this.s1TransferRecs = []; }
      this.s1TransferLoading = false;
    },

    // ── Teams Competition ────────────────────────────────────────
    async s1FetchTeamsData() {
      this.s1TeamsLoading = true;
      try {
        const now = new Date();
        const from = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-01`;
        const to   = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
        const r = await axios.get('/api/admin/teams/stats', {
          headers: this.s1Headers(),
          params: { from, to, period: this.s1TeamsPeriod },
        });
        const d = (r.data && r.data.data) ? r.data.data : r.data;
        this.s1TeamsData = d;
        // Extract team config if returned
        if (d && d.team1 && d.team1.name) { this.s1Team1 = { ...this.s1Team1, name: d.team1.name, emoji: d.team1.emoji || '🔵', color: d.team1.color || '#0e7490' }; }
        if (d && d.team2 && d.team2.name) { this.s1Team2 = { ...this.s1Team2, name: d.team2.name, emoji: d.team2.emoji || '🟣', color: d.team2.color || '#7c3aed' }; }
        // Extract chart data if returned
        if (d && d.timeline) {
          this.s1TeamsChartData = { t1: d.timeline.team1 || [], t2: d.timeline.team2 || [] };
        }
      } catch(e) {
        console.warn('Teams stats fetch failed', e);
        this.s1TeamsData = null;
      }
      this.s1TeamsLoading = false;
    },

    async s1FetchLeaderboard() {
      try {
        const r = await axios.get('/api/admin/teams/leaderboard', {
          headers: this.s1Headers(),
          params: { metric: this.s1LeaderboardMetric, period: this.s1LeaderboardPeriod },
        });
        const d = (r.data && r.data.data) ? r.data.data : r.data;
        this.s1Leaderboard = Array.isArray(d) ? d : (d && d.agents ? d.agents : []);
      } catch(e) {
        this.s1Leaderboard = [];
        console.warn('Leaderboard fetch failed', e);
      }
    },

    async s1FetchGoals() {
      try {
        const now = new Date();
        const month = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}`;
        const r = await axios.get('/api/admin/teams/goals', {
          headers: this.s1Headers(),
          params: { month },
        });
        const d = (r.data && r.data.data) ? r.data.data : r.data;
        this.s1TeamsGoals = Array.isArray(d) ? d : [];
      } catch(e) {
        this.s1TeamsGoals = [];
      }
    },

    s1TeamKpiWinner(kpi) {
      if (!this.s1TeamsData) return 0;
      const v1 = this.s1TeamsVal(1, kpi);
      const v2 = this.s1TeamsVal(2, kpi);
      if (v1 > v2) return 1;
      if (v2 > v1) return 2;
      return 0;
    },

    s1TeamsVal(teamNum, kpi) {
      if (!this.s1TeamsData) return 0;
      const tKey = teamNum === 1 ? 'team1' : 'team2';
      const team = this.s1TeamsData[tKey];
      if (!team) return 0;
      return team[kpi] || 0;
    },

    s1FmtMoney(val) {
      if (!val && val !== 0) return '$0';
      const n = parseFloat(val) || 0;
      if (n >= 1000000) return '$' + (n/1000000).toFixed(1) + 'M';
      if (n >= 1000) return '$' + Math.round(n/1000) + 'K';
      return '$' + n.toLocaleString('en-US');
    },

    s1AgentInitialsFromName(name) {
      const parts = (name || '').trim().split(' ');
      return (((parts[0] || '')[0] || '') + ((parts[1] || '')[0] || '')).toUpperCase() || '?';
    },
  },
};
</script>

<style scoped>
/* ============================================================
   Stats1 — 8-tab dashboard with Brain AI view
   MAESTRO design system bridge applied
   ============================================================ */
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&family=DM+Mono:wght@400;500&family=Plus+Jakarta+Sans:wght@700;800&display=swap');

/* ── Inline accordion drill-down ────────────────────────── */
.s1-hbar-row { cursor:pointer; transition:background .12s; }
.s1-hbar-row--open { background:rgba(124,92,252,.06); }
.s1-arr { font-size:9px; color:var(--c1-muted,#9ca3af); width:12px; flex-shrink:0; margin-right:2px; }
.s1-dil-wrap { background:var(--c1-surface2,#f7f7f7); border-bottom:1px solid var(--c1-border,#e5e7eb); padding:14px 16px 16px 28px; animation:s1DilSlide .18s ease; }
@keyframes s1DilSlide { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:none; } }
.s1-dil-body { display:grid; grid-template-columns:repeat(auto-fill,minmax(200px,1fr)); gap:18px 28px; }
.s1-dil-col { min-width:0; }
.s1-dil-col-right { padding-left:0; }
.s1-dil-col + .s1-dil-col { border-top:1px solid transparent; }
.s1-dil-title { font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:.7px; color:var(--c1-muted,#9ca3af); margin-bottom:10px; }
.s1-dil-row { display:flex; align-items:center; gap:7px; margin-bottom:7px; }
.s1-dil-lbl { font-size:11px; font-weight:600; color:var(--c1-text,#374151); width:50px; flex-shrink:0; }
.s1-dil-lbl-wide { width:120px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.s1-dil-track { flex:1; height:5px; background:var(--c1-border,#e5e7eb); border-radius:3px; overflow:hidden; }
.s1-dil-fill { height:100%; border-radius:3px; transition:width .3s; }
.s1-dil-num { font-size:11px; font-weight:700; color:var(--c1-text,#111); width:28px; text-align:right; flex-shrink:0; }
.s1-dil-pct { font-size:10px; color:var(--c1-muted,#9ca3af); width:26px; text-align:right; flex-shrink:0; }
.s1-dil-spin { display:flex; justify-content:center; padding:10px 0; }
.s1-dil-empty { font-size:12px; color:var(--c1-muted,#9ca3af); padding:8px 0; }

/* ── Panels ───────────────────────────────────────────────── */
/* .c1-panel positioning handled globally by c1-design.css */
.c1-panel.c1-panel--open { transform: translateX(0); box-shadow: -4px 0 24px rgba(0,0,0,.1); }

.s1-tib-title {
  display: flex; align-items: center; gap: 6px;
  font-size: 13px; font-weight: 800; color: var(--c1-text); letter-spacing: -.3px; margin-right: 8px;
}
.s1-tib-title svg { width: 14px; height: 14px; flex-shrink: 0; stroke: var(--c1-accent); }

.s1-live-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--c1-muted); flex-shrink: 0; margin-right: 4px; transition: background .3s; }
.s1-live-dot.active { background: var(--c1-dp); animation: s1pulse 2s infinite; }
@keyframes s1pulse { 0%,100%{opacity:1} 50%{opacity:.4} }

.s1-time-display { font-family: 'DM Mono', monospace; font-size: 11px; font-weight: 600; color: var(--c1-muted); letter-spacing: .5px; margin-right: 8px; white-space: nowrap; }

.s1-loading-bar { height: 3px; background: var(--c1-border); flex-shrink: 0; overflow: hidden; }
.s1-loading-fill { height: 100%; width: 40%; background: var(--c1-accent); animation: s1loadmove 1.2s ease-in-out infinite; }
@keyframes s1loadmove { 0%{transform:translateX(-100%)} 100%{transform:translateX(350%)} }

.s1-error-banner { display: flex; align-items: center; gap: 8px; padding: 10px 16px; background: rgba(239,68,68,.1); border-bottom: 1px solid rgba(239,68,68,.3); color: var(--c1-na); font-size: 12px; flex-shrink: 0; }
.s1-error-banner svg { width: 14px; height: 14px; flex-shrink: 0; }
.s1-error-banner button { margin-left: auto; padding: 4px 12px; border: 1px solid var(--c1-na); border-radius: 4px; background: none; color: var(--c1-na); cursor: pointer; font-size: 11px; font-weight: 600; }

.c1-body { flex: 1; overflow-y: auto; overflow-x: hidden; display: flex; flex-direction: column; min-height: 0; padding: 16px; box-sizing: border-box; }

.s1-title-row {
  display: flex; align-items: center; gap: 10px;
  padding: 12px 16px 10px; flex-shrink: 0;
  border-bottom: 1px solid var(--c1-border, #e2e8f0);
  flex-wrap: wrap;
}
.s1-title-main {
  font-size: 16px; font-weight: 800; color: var(--c1-text);
  letter-spacing: -.5px; flex-shrink: 0;
  font-family: 'Plus Jakarta Sans', 'DM Sans', system-ui, sans-serif;
}
.s1-active-range-badge { font-size: 11px; font-weight: 600; color: #0057ff; background: #0057ff14; border: 1px solid #0057ff33; border-radius: 50px; padding: 3px 10px; white-space: nowrap; }
.s1-active-agent-badge { display: inline-flex; align-items: center; gap: 4px; font-size: 11px; font-weight: 600; color: #d97706; background: #f59e0b14; border: 1px solid #f59e0b33; border-radius: 50px; padding: 3px 8px; white-space: nowrap; }
.s1-badge-x { cursor: pointer; font-size: 13px; line-height: 1; margin-left: 2px; opacity: .7; transition: opacity .15s; }
.s1-badge-x:hover { opacity: 1; }
.s1-refresh-btn { display: flex; align-items: center; gap: 5px; padding: 5px 12px; border: 1px solid var(--c1-border); border-radius: 6px; background: var(--c1-surface); color: var(--c1-muted); font-size: 10px; font-weight: 600; cursor: pointer; transition: border-color .15s, color .15s; }
.s1-refresh-btn:hover:not(:disabled) { border-color: var(--c1-accent); color: var(--c1-accent); }
.s1-refresh-btn:disabled { opacity: .4; cursor: default; }
.s1-refresh-btn svg { width: 13px; height: 13px; }
@keyframes s1spin { 0%{transform:rotate(0deg)} 100%{transform:rotate(360deg)} }
.s1-spin { animation: s1spin 1s linear infinite; }

/* ── KPI Hero Row ─────────────────────────────────────────── */
.s1-kpi-hero {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1px;
  background: var(--c1-border, #e2e8f0);
  border-top: 1px solid var(--c1-border, #e2e8f0);
  border-bottom: 1px solid var(--c1-border, #e2e8f0);
  flex-shrink: 0;
}
@media (max-width: 600px) { .s1-kpi-hero { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 600px) { .s1-kpi-hero-card:last-child:nth-child(odd) { grid-column: span 2; } }
.s1-kpi-hero-card {
  background: var(--c1-surface, #f8fafc);
  padding: 16px 14px 14px;
  display: flex; flex-direction: column; gap: 4px;
  transition: background .12s;
  cursor: default;
}
.s1-kpi-hero-card:hover { background: #fff; }
.s1-kpi-hero-top { display: flex; align-items: center; gap: 6px; }
.s1-kpi-hero-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
.s1-kpi-hero-lbl {
  font-size: 10px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .06em; color: var(--c1-muted, #64748b);
  font-family: 'DM Sans', system-ui, sans-serif;
}
.s1-kpi-hero-num {
  font-family: 'DM Mono', monospace;
  font-size: 32px; font-weight: 700; letter-spacing: -1.5px; line-height: 1;
  margin-top: 2px;
}
.s1-kpi-hero-sub { font-size: 9px; color: var(--c1-muted, #64748b); }
.s1-kpi-hero-bar {
  height: 3px; background: var(--c1-border, #e2e8f0);
  border-radius: 2px; overflow: hidden; margin-top: 8px;
}
.s1-kpi-hero-bar-fill { height: 100%; border-radius: 2px; transition: width .5s ease; }
.s1-kpi-hero-bar-inner { height: 100%; border-radius: 2px; }

/* KPI today badge */
.s1-kpi-hero-wrap { display: flex; flex-direction: column; flex-shrink: 0; }
.s1-kpi-today-badge {
  align-self: flex-end;
  margin: 6px 10px 4px;
  font-size: 8px; font-weight: 800; letter-spacing: .8px;
  color: #0057ff; background: rgba(0,87,255,.08);
  border: 1px solid rgba(0,87,255,.2); border-radius: 20px;
  padding: 2px 8px; pointer-events: none;
  font-family: 'DM Mono', monospace;
}

/* Body inner — centered in available space */
.s1-body-inner {
  max-width: 1100px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
}
/* When right panel is open, keep content from sliding under it */
@media (min-width: 768px) {
  .s1-body-panel-open { padding-right: 396px !important; }
}

/* Tab panels */
.s1-tab-panels { margin-top: 16px; }
.s1-tab-panel { padding: 16px; background: var(--c1-surface, #fff); border: 1px solid var(--c1-border, #e5e7eb); border-radius: 10px; }
.s1-akg-panel { padding: 16px; background: var(--c1-surface, #fff); border: 1px solid var(--c1-border, #e5e7eb); border-radius: 10px; }

.s1-section-hdr { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; flex-wrap: wrap; gap: 8px; }
.s1-section-hdr > span:first-child { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-muted); }
.s1-section-hint { font-size: 10px; color: var(--c1-muted); opacity: .7; }

/* Today tab: horizontal bars */
.s1-today-chart { display: flex; flex-direction: column; gap: 10px; }
.s1-tc-row { display: flex; align-items: center; gap: 10px; }
.s1-tc-lbl { font-family: 'DM Mono', monospace; font-size: 9px; font-weight: 700; text-transform: uppercase; color: var(--c1-muted); width: 44px; flex-shrink: 0; text-align: right; }
.s1-tc-track { flex: 1; height: 30px; background: var(--c1-surface2); border-radius: 4px; overflow: hidden; position: relative; display: flex; align-items: center; cursor: default; }
.s1-tc-fill { height: 100%; border-radius: 4px; transition: width .5s ease; display: flex; align-items: center; padding-left: 8px; min-width: 4px; }
.s1-tc-inline-val { font-family: 'DM Mono', monospace; font-size: 12px; font-weight: 700; color: rgba(255,255,255,.9); }
.s1-tc-out-val { font-family: 'DM Mono', monospace; font-size: 12px; font-weight: 700; color: var(--c1-muted); position: absolute; left: 8px; }

/* Table header + total row */
.s1-table-hdr {
  display: flex; align-items: center; gap: 10px;
  padding: 3px 6px 5px; margin-bottom: 2px;
  border-bottom: 1px solid var(--c1-border);
}
.s1-table-hdr > span { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; color: var(--c1-muted); }
.s1-table-hdr > span:first-child { width: 140px; flex-shrink: 0; }
.s1-table-hdr > span:nth-child(2) { flex: 1; text-align: right; width: 40px; }
.s1-table-hdr > span:nth-child(3) { width: 36px; text-align: right; flex-shrink: 0; }
.s1-table-total {
  display: flex; align-items: center; gap: 10px;
  padding: 6px 6px 2px; margin-top: 4px;
  border-top: 1px solid var(--c1-border);
  font-size: 11px; font-weight: 700; color: var(--c1-text);
}
.s1-table-total > span:first-child { width: 140px; flex-shrink: 0; }
.s1-table-total > span:nth-child(2) { flex: 1; text-align: right; font-family: 'DM Mono', monospace; font-size: 12px; }
.s1-table-total > span:nth-child(3) { width: 36px; text-align: right; flex-shrink: 0; font-family: 'DM Mono', monospace; font-size: 11px; color: var(--c1-muted); }

/* Horizontal bar lists */
.s1-hbar-list { display: flex; flex-direction: column; gap: 5px; }
.s1-hbar-row { display: flex; align-items: center; gap: 10px; cursor: default; padding: 4px 6px; border-radius: 6px; transition: background .1s; }
.s1-hbar-row:hover { background: var(--c1-surface2); }
.s1-hbar-lbl { font-size: 11px; font-weight: 600; color: var(--c1-text); width: 140px; flex-shrink: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.s1-hbar-track { flex: 1; height: 8px; background: var(--c1-surface2); border-radius: 4px; overflow: hidden; }
.s1-hbar-fill { height: 100%; border-radius: 4px; transition: width .5s ease; }
.s1-fill-dp     { background: #22c55e; }
.s1-fill-ld     { background: #f59e0b; }
.s1-fill-na     { background: #ef4444; }
.s1-fill-sc     { background: #3b82f6; }
.s1-fill-sc2    { background: #f97316; }
.s1-fill-tr-lv  { background: #8b5cf6; }
.s1-fill-tr-on  { background: #14b8a6; }
.s1-fill-rf     { background: #f97316; }
.s1-fill-bn     { background: #78716c; }
.s1-fill-ni     { background: #b45309; }
.s1-fill-assign { background: #0057ff; }
.s1-hbar-val { font-family: 'DM Mono', monospace; font-size: 12px; font-weight: 700; color: var(--c1-text); width: 40px; text-align: right; flex-shrink: 0; }
.s1-hbar-pct { font-family: 'DM Mono', monospace; font-size: 10px; font-weight: 600; color: var(--c1-muted); width: 36px; text-align: right; flex-shrink: 0; }

/* Toggle buttons */
.s1-toggle-btns { display: flex; gap: 4px; }
.s1-toggle-btn { padding: 4px 12px; border-radius: 4px; font-size: 10px; font-weight: 700; cursor: pointer; border: 1px solid var(--c1-border); color: var(--c1-muted); background: var(--c1-surface); transition: all .12s; }
.s1-toggle-btn.on { background: var(--c1-accent); border-color: var(--c1-accent); color: #fff; }

/* AKG Excel-style table */
.s1-akg-body { padding-bottom: 0; }
.s1-akg-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; border: 1px solid var(--c1-border); border-radius: 8px; }
.s1-akg-table { width: 100%; border-collapse: collapse; font-family: 'DM Mono', monospace; white-space: nowrap; }
.s1-akg-th {
  padding: 8px 12px; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px;
  background: var(--c1-surface); border-bottom: 2px solid var(--c1-border);
  position: sticky; top: 0; text-align: center;
}
.s1-akg-date-col { text-align: left; min-width: 100px; color: var(--c1-muted) !important; position: sticky; left: 0; z-index: 2; background: inherit; }
.s1-akg-td { padding: 7px 12px; font-size: 12px; border-bottom: 1px solid var(--c1-border); background: var(--c1-surface); }
.s1-akg-num { text-align: center; font-weight: 600; }
.s1-akg-zero { color: var(--c1-muted) !important; opacity: .4; }
.s1-akg-tr:hover .s1-akg-td { background: var(--c1-surface2); }
.s1-akg-tr:hover .s1-akg-date-col { background: var(--c1-surface2); }
.s1-akg-total-row .s1-akg-td {
  background: var(--c1-surface);
  font-weight: 800; font-size: 13px;
  border-top: 2px solid var(--c1-border); border-bottom: none;
  position: sticky; bottom: 0;
}
.s1-akg-total-cell { font-size: 13px !important; }
.s1-akg-tr-clickable { cursor: pointer; }
.s1-akg-expand-ico { font-size: 10px; margin-right: 4px; color: var(--c1-muted); display: inline-block; width: 10px; }
.s1-akg-user-row .s1-akg-td { background: #f5f3ff; border-bottom: 1px solid #ede9fe; }
.s1-akg-user-row:last-child .s1-akg-td { border-bottom: 2px solid #c4b5fd; }
.s1-akg-user-name-col { font-size: 11px !important; color: #5b21b6 !important; display: flex; align-items: center; gap: 6px; }
.s1-akg-user-av { width: 20px; height: 20px; border-radius: 50%; background: #7c3aed; color: #fff; font-size: 9px; font-weight: 700; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
.s1-akg-exp-loading { text-align: center; background: #f5f3ff; padding: 8px; }
.s1-akg-exp-empty { text-align: center; color: var(--c1-muted); font-size: 11px; background: #f5f3ff; padding: 8px; }

/* Hours chart */
.s1-hours-chart { display: flex; gap: 3px; align-items: flex-end; height: 180px; overflow-x: auto; padding: 0 4px 0; }
.s1-hour-col { display: flex; flex-direction: column; align-items: center; gap: 2px; min-width: 28px; flex: 1; height: 100%; justify-content: flex-end; cursor: default; }
.s1-hour-bar-wrap { flex: 1; width: 100%; display: flex; align-items: flex-end; }
.s1-hour-bar-fill { width: 100%; min-height: 2px; border-radius: 3px 3px 0 0; background: linear-gradient(180deg, #0057ff, #93b4ff); transition: height .4s ease; }
.s1-hour-val { font-family: 'DM Mono', monospace; font-size: 8px; font-weight: 700; color: var(--c1-muted); }
.s1-hour-lbl { font-size: 8px; font-weight: 700; color: var(--c1-muted); text-transform: uppercase; }

/* New fill colors */
.s1-fill-countries { background: linear-gradient(90deg, #0057ff, #93b4ff); }
.s1-fill-adv       { background: linear-gradient(90deg, #7c3aed, #c4b5fd); }

/* Timeline */
.s1-timeline-wrap { display: flex; flex-direction: column; gap: 6px; }
.s1-timeline-svg { width: 100%; height: 160px; display: block; }
.s1-tl-x-labels { display: flex; justify-content: space-between; padding: 0 4px; }
.s1-tl-x-lbl { font-size: 9px; color: var(--c1-muted); font-family: monospace; }

/* Live tab */
.s1-live-badge { display: flex; align-items: center; gap: 5px; font-size: 9px; font-weight: 700; color: var(--c1-dp); letter-spacing: .5px; }
.s1-live-pulse { width: 6px; height: 6px; border-radius: 50%; background: var(--c1-dp); animation: s1pulse 1s infinite; }
.s1-live-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
@media (min-width: 480px) { .s1-live-grid { grid-template-columns: repeat(3, 1fr); } }
@media (min-width: 900px) { .s1-live-grid { grid-template-columns: repeat(6, 1fr); } }
.s1-live-cell { background: var(--c1-surface); border: 1px solid var(--c1-border); border-radius: 10px; padding: 16px 14px; position: relative; overflow: hidden; display: flex; flex-direction: column; gap: 4px; transition: border-color .2s; }
.s1-live-cell:hover { border-color: var(--c1-accent); }
.s1-live-key { font-family: 'DM Mono', monospace; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; }
.s1-live-val { font-family: 'DM Mono', monospace; font-size: 32px; font-weight: 700; letter-spacing: -1px; line-height: 1.1; }
.s1-live-lbl { font-size: 9px; color: var(--c1-muted); font-weight: 500; }
.s1-live-pulse-ring { position: absolute; bottom: -8px; right: -8px; width: 48px; height: 48px; border-radius: 50%; border: 2px solid; opacity: .3; animation: s1ringpulse 2s infinite; }
@keyframes s1ringpulse { 0%,100%{transform:scale(1);opacity:.3} 50%{transform:scale(1.15);opacity:.1} }
.s1-live-footer { font-size: 10px; color: var(--c1-muted); text-align: right; margin-top: 10px; }

/* ── Always-visible calendar widget ─── */
.s1-cal-widget { margin-top: 20px; background: var(--c1-surface, #fff); border: 1px solid var(--c1-border, #e5e7eb); border-radius: 10px; padding: 14px 16px 16px; }
.s1-cal-widget-hdr { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 12px; flex-wrap: wrap; gap: 8px; }
.s1-cal-widget-title { display: flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 700; color: var(--c1-text); text-transform: uppercase; letter-spacing: .5px; }
.s1-cal-widget-hint { font-size: 10px; font-weight: 400; color: var(--c1-muted); text-transform: none; letter-spacing: 0; display: flex; align-items: center; gap: 4px; margin-left: 4px; }

/* ── Panel inline date pills ─── */
.s1-panel-date-pills { display: flex; gap: 6px; flex-wrap: wrap; padding: 6px 14px 10px; }
.s1-panel-pill { padding: 4px 13px; border-radius: 50px; border: 1px solid var(--c1-border); font-size: 11px; font-weight: 600; color: var(--c1-muted); cursor: pointer; transition: all .15s; }
.s1-panel-pill:hover { border-color: #0057ff; color: #0057ff; }
.s1-panel-pill.on { background: #0057ff; border-color: #0057ff; color: #fff; }

/* ── Agent Filter Block (top of panel) ─── */
.s1-af-block { padding: 12px 14px 10px; border-bottom: 1px solid var(--c1-border); }
.s1-af-hdr { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; }
.s1-af-ttl { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: #7c3aed; }
.s1-af-count-badge { background: #7c3aed; color: #fff; font-size: 9px; font-weight: 800; border-radius: 50px; padding: 1px 6px; min-width: 18px; text-align: center; }
.s1-af-clear-btn { font-size: 10px; color: #ef4444; cursor: pointer; font-weight: 600; padding: 2px 4px; border-radius: 4px; transition: background .1s; }
.s1-af-clear-btn:hover { background: #fef2f2; }

/* Selected chips strip */
.s1-af-chips { display: flex; flex-wrap: wrap; gap: 4px; margin-bottom: 8px; max-height: 72px; overflow-y: auto; }
.s1-af-chip { display: inline-flex; align-items: center; gap: 3px; background: #ede9fe; border: 1px solid #c4b5fd; border-radius: 50px; padding: 2px 6px 2px 8px; font-size: 10px; font-weight: 600; color: #5b21b6; white-space: nowrap; max-width: 100px; }
.s1-af-chip span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.s1-af-chip svg { width: 9px; height: 9px; flex-shrink: 0; cursor: pointer; opacity: .6; }
.s1-af-chip svg:hover { opacity: 1; }

/* Search bar */
.s1-af-search { display: flex; align-items: center; gap: 6px; border: 1.5px solid var(--c1-border); border-radius: 8px; padding: 6px 10px; background: var(--c1-surface); transition: border-color .15s; margin-bottom: 6px; }
.s1-af-search:focus-within { border-color: #7c3aed; }
.s1-af-search svg { width: 13px; height: 13px; flex-shrink: 0; color: var(--c1-muted); }
.s1-af-search-inp { flex: 1; border: none; background: none; font-size: 12px; color: var(--c1-text); outline: none; }
.s1-af-search-inp::placeholder { color: var(--c1-muted); }
.s1-af-search-clr { cursor: pointer; display: flex; color: var(--c1-muted); }
.s1-af-search-clr svg { width: 11px; height: 11px; }

/* Compact agent list */
.s1-af-list { max-height: 230px; overflow-y: auto; border: 1px solid var(--c1-border); border-radius: 8px; background: var(--c1-surface); }
.s1-af-row { display: flex; align-items: center; gap: 8px; padding: 6px 10px; cursor: pointer; transition: background .1s; border-bottom: 1px solid transparent; }
.s1-af-row:last-child { border-bottom: none; }
.s1-af-row:hover { background: #f5f3ff; }
.s1-af-row.on { background: #ede9fe; }
.s1-af-av { width: 26px; height: 26px; border-radius: 50%; background: #d4d4f7; color: #5b21b6; font-size: 9px; font-weight: 800; display: grid; place-items: center; flex-shrink: 0; transition: all .15s; letter-spacing: .5px; }
.s1-af-av.on { background: #7c3aed; color: #fff; }
.s1-af-nm { flex: 1; font-size: 12px; font-weight: 500; color: var(--c1-text); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.s1-af-row.on .s1-af-nm { font-weight: 600; color: #5b21b6; }
.s1-af-chk { width: 16px; height: 16px; border-radius: 4px; border: 1.5px solid var(--c1-border); display: grid; place-items: center; flex-shrink: 0; transition: all .15s; }
.s1-af-chk.on { background: #7c3aed; border-color: #7c3aed; }
.s1-af-chk svg { width: 9px; height: 9px; color: #fff; }
.s1-af-empty { font-size: 11px; color: var(--c1-muted); padding: 12px; text-align: center; }
/* Collapsible toggle chevron */
.s1-af-chevron { width: 14px; height: 14px; flex-shrink: 0; color: var(--c1-muted); transition: transform .2s; }
.s1-af-chevron.open { transform: rotate(180deg); }
.s1-af-hdr { cursor: pointer; }
.s1-af-expanded { margin-top: 8px; }
/* Custom range pill */
.s1-panel-pill-cal { display: inline-flex; align-items: center; gap: 4px; }

/* ── Panel inline calendar ─── */
.s1-panel-cal { padding: 0 14px 10px; }
.s1-pcal-range-bar { display: flex; align-items: center; gap: 6px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 6px; padding: 5px 8px; margin-bottom: 8px; font-size: 10px; }
.s1-pcal-range-lbl { flex: 1; font-weight: 600; color: #1d4ed8; font-family: 'DM Mono', monospace; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.s1-pcal-clear { border: none; background: none; color: #ef4444; font-size: 10px; font-weight: 600; cursor: pointer; padding: 0; flex-shrink: 0; }
.s1-pcal-hint { display: flex; align-items: center; gap: 5px; font-size: 10px; color: #7c3aed; background: #f5f3ff; border-radius: 6px; padding: 5px 8px; margin-bottom: 8px; }
.s1-pcal-nav { display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px; }
.s1-pcal-month { font-size: 12px; font-weight: 700; color: var(--c1-text); }
.s1-pcal-btn { background: none; border: 1px solid var(--c1-border); border-radius: 5px; width: 24px; height: 24px; display: grid; place-items: center; cursor: pointer; color: var(--c1-muted); transition: all .12s; }
.s1-pcal-btn:hover { border-color: #7c3aed; color: #7c3aed; }
.s1-pcal-btn svg { width: 12px; height: 12px; fill: none; stroke: currentColor; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.s1-pcal-dow-row { display: grid; grid-template-columns: repeat(7, 1fr); margin-bottom: 2px; }
.s1-pcal-dow { text-align: center; font-size: 9px; font-weight: 700; color: var(--c1-muted); padding: 2px 0; text-transform: uppercase; }
.s1-pcal-week { display: grid; grid-template-columns: repeat(7, 1fr); }
.s1-pcal-day { position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 30px; border-radius: 5px; cursor: pointer; transition: background .1s; }
.s1-pcal-day:hover { background: #f5f3ff; }
.s1-pcal-day.other-month .s1-pcal-dn { color: var(--c1-muted); opacity: .35; }
.s1-pcal-day.today { background: #ede9fe; }
.s1-pcal-day.today .s1-pcal-dn { color: #7c3aed; font-weight: 700; }
.s1-pcal-day.selected, .s1-pcal-day.range-start, .s1-pcal-day.range-end { background: #7c3aed !important; }
.s1-pcal-day.selected .s1-pcal-dn, .s1-pcal-day.range-start .s1-pcal-dn, .s1-pcal-day.range-end .s1-pcal-dn { color: #fff !important; font-weight: 700; }
.s1-pcal-day.in-range { background: #ede9fe; border-radius: 0; }
.s1-pcal-day.range-start { border-radius: 5px 0 0 5px; }
.s1-pcal-day.range-end { border-radius: 0 5px 5px 0; }
.s1-pcal-dn { font-size: 11px; font-weight: 500; color: var(--c1-text); line-height: 1; }
.s1-pcal-dot { width: 4px; height: 4px; border-radius: 50%; background: #0057ff; margin-top: 1px; }

/* ── Calendar tab panel (main body) ─── */
.s1-cal-hdr-row { display: flex; align-items: center; justify-content: space-between; padding: 8px 0 10px; }
.s1-cal-body--main .s1-cal-dow { font-size: 11px; }
.s1-cal-day--main { min-height: 44px; }
.s1-cal-legend { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 10px; }
.s1-cal-legend-item { display: flex; align-items: center; gap: 5px; font-size: 11px; color: var(--c1-muted); }
.s1-cal-legend-dot { width: 10px; height: 10px; border-radius: 3px; display: inline-block; }
.s1-cal-legend-today { width: 10px; height: 10px; border-radius: 3px; border: 2px solid #0057ff; display: inline-block; }
.s1-cal-legend-sel { width: 10px; height: 10px; border-radius: 3px; background: #0057ff; display: inline-block; }

/* Charts panel helpers */
.c1-co-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: var(--c1-muted); margin-bottom: 8px; width: 100%; }
.s1-today-bars { display: flex; gap: 8px; align-items: flex-end; height: 80px; width: 100%; }
.s1-bar-col { flex: 1; display: flex; flex-direction: column; align-items: center; gap: 3px; height: 100%; justify-content: flex-end; cursor: default; }
.s1-bar-track { flex: 1; width: 100%; background: rgba(0,0,0,.06); border-radius: 3px 3px 0 0; display: flex; align-items: flex-end; overflow: hidden; }
.s1-bar-fill { width: 100%; border-radius: 3px 3px 0 0; min-height: 2px; transition: height .4s ease; }
.s1-bar-val { font-family: 'DM Mono', monospace; font-size: 8px; font-weight: 600; color: var(--c1-muted); }
.s1-bar-lbl { font-size: 7px; font-weight: 700; color: var(--c1-muted); text-transform: uppercase; letter-spacing: .3px; }
.s1-trend-wrap { width: 100%; }
.s1-trend-legend { display: flex; gap: 12px; margin-top: 4px; }
.s1-tl-item { display: flex; align-items: center; gap: 4px; font-size: 9px; color: var(--c1-muted); font-weight: 600; }
.s1-tl-dot { width: 8px; height: 3px; border-radius: 2px; }
.s1-agent-perf { display: flex; flex-direction: column; gap: 6px; width: 100%; }
.s1-ap-row { display: flex; align-items: center; gap: 8px; }
.s1-ap-av { width: 22px; height: 22px; border-radius: 50%; background: var(--c1-accent); display: grid; place-items: center; font-size: 8px; font-weight: 700; color: #fff; flex-shrink: 0; }
.s1-ap-name { font-size: 10px; font-weight: 600; color: var(--c1-text); min-width: 50px; max-width: 60px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.s1-ap-bars { flex: 1; display: flex; flex-direction: column; gap: 2px; }
.s1-ap-bar-wrap { height: 4px; background: rgba(0,0,0,.08); border-radius: 2px; overflow: hidden; }
.s1-ap-bar-fill { height: 100%; border-radius: 2px; transition: width .4s ease; }
.s1-ap-nums { display: flex; flex-direction: column; gap: 2px; min-width: 22px; text-align: right; }
.s1-ap-nums span { font-family: 'DM Mono', monospace; font-size: 8px; font-weight: 700; }

/* Calendar panel */
.s1-cal-panel { background: var(--c1-surface); border-bottom: 2px solid var(--c1-border); }
.s1-cal-hdr { display: flex; align-items: center; gap: 8px; padding: 10px 16px; border-bottom: 1px solid var(--c1-border); font-size: 12px; font-weight: 700; color: var(--c1-text); }
.s1-cal-hdr svg { width: 14px; height: 14px; flex-shrink: 0; }
.s1-cal-nav { display: flex; align-items: center; gap: 6px; }
.s1-cal-nav-btn { width: 24px; height: 24px; border: 1px solid var(--c1-border); border-radius: 4px; background: none; color: var(--c1-muted); cursor: pointer; display: grid; place-items: center; }
.s1-cal-nav-btn svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; }
.s1-cal-month-lbl { font-size: 11px; font-weight: 700; color: var(--c1-text); white-space: nowrap; min-width: 120px; text-align: center; }
.s1-cal-close-btn { display: flex; align-items: center; gap: 4px; padding: 5px 10px; border: 1px solid var(--c1-border); border-radius: 6px; background: none; color: var(--c1-muted); cursor: pointer; font-size: 10px; font-weight: 600; }
.s1-cal-close-btn svg { width: 10px; height: 10px; stroke: currentColor; fill: none; stroke-width: 2; }
.s1-cal-body { padding: 8px 14px 10px; }
.s1-cal-dow-row { display: grid; grid-template-columns: repeat(7, 1fr); margin-bottom: 4px; }
.s1-cal-dow { text-align: center; font-size: 8px; font-weight: 700; text-transform: uppercase; color: var(--c1-muted); letter-spacing: .4px; padding: 2px 0; }
.s1-cal-week { display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px; margin-bottom: 2px; }
.s1-cal-day { min-height: 34px; display: flex; flex-direction: column; align-items: center; justify-content: center; border-radius: 6px; cursor: pointer; font-size: 11px; font-weight: 600; color: var(--c1-text); transition: background .12s; position: relative; border: 1px solid transparent; }

.s1-cal-day:hover { background: var(--c1-surface2); border-color: var(--c1-border); }
.s1-cal-day.today { border-color: var(--c1-accent); color: var(--c1-accent); background: rgba(99,102,241,.08); }
.s1-cal-day.selected { background: var(--c1-accent); color: #fff; border-color: var(--c1-accent); }
.s1-cal-day.other-month { opacity: .3; cursor: default; }
.s1-cal-dn { position: relative; }
.s1-cal-day.has-data .s1-cal-dn::after { content: ''; position: absolute; bottom: -3px; left: 50%; transform: translateX(-50%); width: 3px; height: 3px; border-radius: 50%; background: var(--c1-dp); }
.s1-cal-badge { font-family: 'DM Mono', monospace; font-size: 7px; font-weight: 700; position: absolute; top: 1px; right: 2px; }
.s1-cb-reg { color: var(--c1-accent); }
.s1-cal-day.range-start,
.s1-cal-day.range-end { background: #0057ff; color: #fff; border-radius: 6px; }
.s1-cal-day.in-range { background: #0057ff18; border-radius: 0; }
.s1-cal-selecting-hint { display: flex; align-items: center; gap: 5px; font-size: 10px; color: #0057ff; padding: 4px 14px 8px; font-weight: 600; }
.s1-cal-range-bar { display: flex; align-items: center; justify-content: space-between; padding: 6px 14px 8px; font-size: 11px; }
.s1-cal-range-lbl { font-weight: 600; color: var(--c1-text); font-family: 'DM Mono', monospace; }
.s1-cal-range-clear { font-size: 10px; color: #ef4444; background: none; border: 1px solid #ef444444; border-radius: 4px; padding: 2px 8px; cursor: pointer; }
.s1-snap { padding: 10px 14px 14px; border-top: 1px solid var(--c1-border); }
.s1-snap-hdr { display: flex; align-items: center; gap: 6px; font-size: 10px; font-weight: 700; color: var(--c1-muted); margin-bottom: 8px; }
.s1-snap-hdr svg { width: 12px; height: 12px; }
.s1-snap-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 6px; }
@media (min-width: 480px) { .s1-snap-grid { grid-template-columns: repeat(6, 1fr); } }
.s1-snap-cell { background: rgba(255,255,255,.03); border: 1px solid var(--c1-border); border-radius: 6px; padding: 6px 8px; text-align: center; }
.s1-snap-lbl { font-size: 8px; text-transform: uppercase; letter-spacing: .3px; color: var(--c1-muted); font-weight: 700; }
.s1-snap-val { font-family: 'DM Mono', monospace; font-size: 16px; font-weight: 700; margin-top: 2px; }
.s1-snap-loading { display: flex; justify-content: center; padding: 20px; }

/* Shared filter helpers */
.c1-fp-lbl-badge { display: inline-block; padding: 1px 5px; border-radius: 10px; background: var(--c1-accent); color: #fff; font-size: 8px; font-weight: 700; margin-left: 4px; }
.c1-fp-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-muted); margin-bottom: 6px; }
.c1-fp-opts { display: flex; flex-wrap: wrap; gap: 5px; }
.c1-fp-opt { display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px; border-radius: 20px; border: 1px solid var(--c1-border); cursor: pointer; font-size: 10px; font-weight: 600; color: var(--c1-muted); background: var(--c1-surface); transition: all .12s; white-space: nowrap; }
.c1-fp-opt:hover { border-color: var(--c1-muted); color: var(--c1-text); }
.c1-fp-opt.on { background: var(--c1-accent); border-color: var(--c1-accent); color: #fff; }
.c1-agent-grid { display: flex; flex-wrap: wrap; gap: 6px; }
.c1-agent-chip { display: flex; align-items: center; gap: 5px; padding: 4px 8px 4px 4px; border: 1px solid var(--c1-border); border-radius: 20px; cursor: pointer; transition: all .12s; background: var(--c1-surface); }
.c1-agent-chip:hover { border-color: var(--c1-muted); }
.c1-agent-chip.on { border-color: var(--c1-accent); background: rgba(99,102,241,.12); }
.c1-agent-av { width: 20px; height: 20px; border-radius: 50%; background: var(--c1-accent); display: grid; place-items: center; font-size: 7px; font-weight: 700; color: #fff; flex-shrink: 0; }
.c1-agent-nm { font-size: 10px; font-weight: 600; color: var(--c1-text); }
.s1-empty { color: var(--c1-muted); font-size: 11px; padding: 12px 0; font-style: italic; }
.s1-empty-state { display: flex; align-items: center; justify-content: center; gap: 8px; padding: 40px 20px; color: var(--c1-muted); font-size: 12px; font-style: italic; }

.c1-spinner { width: 20px; height: 20px; border: 2px solid var(--c1-border); border-top-color: var(--c1-accent); border-radius: 50%; animation: s1spin .8s linear infinite; }

/* Tooltip */
.s1-tooltip { position: absolute; z-index: 999; background: #fff; border: 1px solid var(--c1-border); border-radius: 6px; padding: 6px 10px; font-size: 11px; font-weight: 600; color: var(--c1-t1); white-space: pre-line; pointer-events: none; box-shadow: 0 4px 16px rgba(0,0,0,.12); max-width: 240px; line-height: 1.6; }

/* Legacy KPI grid — kept for reference, replaced by s1-kpi-hero */
.s1-kpi-grid { display: none; }

/* ════════════════════════════════════════════════════════════════════════════
   MAESTRO DESIGN SYSTEM BRIDGE — Stats1
   ════════════════════════════════════════════════════════════════════════════ */
.s1-title-main {
  font-family: 'Plus Jakarta Sans', 'DM Sans', system-ui, sans-serif !important;
  font-weight: 800 !important;
  letter-spacing: -.6px !important;
}
/* ── Time-frame pills (panel only, kept for c1-fp-opt) ────── */
.s1-tf-pill {
  padding: 4px 12px; border-radius: 50px;
  border: 1.5px solid var(--c1-border, #e2e8f0);
  font-size: 11px; font-weight: 600;
  color: var(--c1-muted, #64748b);
  cursor: pointer; background: transparent;
  transition: all .15s; white-space: nowrap;
  font-family: 'DM Sans', system-ui, sans-serif;
}
.s1-tf-pill:hover { border-color: #0057ff; color: #0057ff; }
.s1-tf-pill.on {
  background: #0057ff; border-color: #0057ff; color: #fff;
  box-shadow: 0 2px 8px rgba(0,87,255,.22);
}

/* Toggle buttons — blue */
.s1-toggle-btn.on    { background: #0057ff; border-color: #0057ff; }
/* Bar fills — Maestro gradient palette */
.s1-fill-dp     { background: linear-gradient(90deg, #00b67a, #6ee7b7); }
.s1-fill-ld     { background: linear-gradient(90deg, #f59e0b, #fcd34d); }
.s1-fill-na     { background: linear-gradient(90deg, #ef4444, #fca5a5); }
.s1-fill-sc     { background: linear-gradient(90deg, #0057ff, #93b4ff); }
.s1-fill-sc2    { background: linear-gradient(90deg, #7c3aed, #c4b5fd); }
.s1-fill-tr-lv  { background: linear-gradient(90deg, #8b5cf6, #c4b5fd); }
.s1-fill-tr-on  { background: linear-gradient(90deg, #14b8a6, #99f6e4); }
.s1-fill-rf     { background: linear-gradient(90deg, #f97316, #fdba74); }
.s1-fill-bn     { background: linear-gradient(90deg, #78716c, #d6d3d1); }
.s1-fill-ni     { background: linear-gradient(90deg, #b45309, #fcd34d); }
.s1-fill-assign { background: linear-gradient(90deg, #0057ff, #93b4ff); }
/* Live */
.s1-live-cell:hover  { border-color: #0057ff; }
.s1-live-badge       { color: #7c3aed; }
.s1-live-pulse       { background: #7c3aed; }
/* Brain leaderboard */
.s1-rank-1 { color: #00b67a; }
.s1-rank-2 { color: #f59e0b; }
.s1-rank-3 { color: #0057ff; }
/* Calendar */
.s1-cal-day.today     { border-color: #0057ff; color: #0057ff; background: rgba(0,87,255,.06); }
.s1-cal-day.selected  { background: #0057ff; color: #fff; border-color: #0057ff; }
.s1-cal-day.has-data .s1-cal-dn::after { background: #7c3aed; }
.s1-cb-reg            { color: #0057ff; }
/* Filter chips */
.c1-fp-opt.on         { background: #0057ff; border-color: #0057ff; color: #fff; }
.c1-fp-lbl-badge      { background: #0057ff; }
.c1-agent-chip.on     { border-color: #0057ff; background: rgba(0,87,255,.08); }
.c1-agent-av          { background: #0057ff; }
/* Spinner / loading */
.c1-spinner           { border-top-color: #0057ff; }
.s1-loading-fill      { background: #0057ff; }
/* Misc */
.s1-refresh-btn:hover:not(:disabled) { border-color: #0057ff; color: #0057ff; }
.s1-live-dot.active   { background: #0057ff; }
.s1-tib-title svg     { stroke: #0057ff; }
.c1-panel.c1-panel--open { box-shadow: -4px 0 24px rgba(0,87,255,.08); }
/* DM Mono for all numbers */
.s1-card-val, .s1-card-key, .s1-live-val, .s1-live-key,
.s1-tc-lbl, .s1-hbar-val,
.s1-snap-val, .s1-bar-val, .s1-cal-badge, .s1-time-display
  { font-family: 'DM Mono', monospace !important; }

/* ── Mobile responsive ──────────────────────────────────── */
@media (max-width: 480px) {
  /* Remove all side padding — content fills edge-to-edge */
  .c1-body { padding: 0; }
  .s1-tab-panels { margin-top: 0; }
  .s1-tab-panel { border-radius: 0; border-left: none; border-right: none; padding: 0 0 16px; }

  /* Section header keeps minimal side padding for readability */
  .s1-section-hdr { padding: 0 12px; margin-bottom: 12px; }

  /* Title row: stack pills below title on very small screens */
  .s1-title-row { gap: 8px; padding: 10px 12px 8px; }
  .s1-title-main { font-size: 14px; }
  .s1-refresh-btn { font-size: 10px; padding: 4px 10px; }

  /* KPI hero: 2 columns on small mobile */
  .s1-kpi-hero { grid-template-columns: repeat(2, 1fr); }
  .s1-kpi-hero-num { font-size: 22px; }
  .s1-kpi-hero-card { padding: 12px 10px 10px; }

  /* Horizontal bar label truncation on mobile */
  .s1-hbar-lbl { width: 100px; font-size: 10px; }
  .s1-hbar-val { font-size: 11px; width: 34px; }
  .s1-hbar-pct { width: 30px; font-size: 9px; }
  .s1-table-hdr > span:first-child { width: 100px; }
  .s1-table-total > span:first-child { width: 100px; }

  /* Section header: stack toggle buttons */
  .s1-section-hdr { flex-direction: column; align-items: flex-start; gap: 8px; }
  .s1-toggle-btns { flex-wrap: wrap; }

  /* Live grid: 2 cols on mobile */
  .s1-live-grid { grid-template-columns: repeat(2, 1fr); }
  .s1-live-val { font-size: 24px; }
  .s1-live-cell { padding: 12px 10px; }

  /* Timeline SVG: allow shorter height */
  .s1-timeline-svg { height: 120px; }
}

@media (min-width: 481px) and (max-width: 768px) {
  .s1-kpi-hero { grid-template-columns: repeat(5, 1fr); }
  .s1-kpi-hero-num { font-size: 26px; }
  .s1-hbar-lbl { width: 120px; }
}

@media (min-width: 769px) {
  /* Desktop: larger KPI numbers */
  .s1-kpi-hero-num { font-size: 36px; }
  .s1-kpi-hero-card { padding: 20px 18px 16px; }

  /* Desktop: wider bar labels */
  .s1-hbar-lbl { width: 180px; }

  /* Desktop: section header stays in one row */
  .s1-section-hdr { flex-wrap: nowrap; }

  /* Desktop: title row doesn't wrap */
  .s1-title-row { flex-wrap: nowrap; padding: 14px 24px 12px; }
  .s1-title-main { font-size: 18px; }
}

@media (min-width: 1200px) {
  /* Wide desktop: even wider labels */
  .s1-hbar-lbl { width: 220px; }
}

@media (max-width: 600px) {
  .s1-body-inner {
    padding: 0 8px;
  }
  .s1-kpi-hero {
    gap: 8px;
  }
  .s1-kpi-hero-card {
    min-width: 130px;
  }
  .s1-tab-panel { padding: 10px 0; }
}

/* ═══ NEW REPORT TABS — Professional tables ════════════════ */
.s1-report-table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; border: 1px solid var(--c1-border); border-radius: 8px; }
.s1-report-table { width: 100%; border-collapse: collapse; font-family: 'DM Sans', system-ui, sans-serif; white-space: nowrap; }
.s1-rt-th {
  padding: 10px 14px; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px;
  background: var(--c1-surface); border-bottom: 2px solid var(--c1-border);
  color: var(--c1-muted); position: sticky; top: 0;
}
.s1-rt-name { text-align: left; min-width: 140px; }
.s1-rt-num { text-align: right; font-family: 'DM Mono', monospace; min-width: 60px; }
.s1-rt-td { padding: 8px 14px; font-size: 12px; border-bottom: 1px solid var(--c1-border); background: var(--c1-surface); }
.s1-rt-td.s1-rt-name { font-weight: 600; color: var(--c1-text); overflow: hidden; text-overflow: ellipsis; max-width: 220px; }
.s1-rt-td.s1-rt-num { font-weight: 600; color: var(--c1-text); }
.s1-rt-tr:hover .s1-rt-td { background: var(--c1-surface2); }
.s1-rt-total .s1-rt-td {
  background: var(--c1-surface); font-weight: 800; font-size: 13px;
  border-top: 2px solid var(--c1-border); border-bottom: none;
}

/* Daily Report avatar */
.s1-dr-av { width: 22px; height: 22px; border-radius: 50%; background: #7c3aed; color: #fff; font-size: 8px; font-weight: 800; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }

/* Costs summary cards */
.s1-costs-wrap { }
.s1-costs-summary { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 10px; }
.s1-costs-card { background: var(--c1-surface); border: 1px solid var(--c1-border); border-radius: 10px; padding: 16px 14px; display: flex; flex-direction: column; gap: 4px; }
.s1-costs-card-lbl { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-muted); }
.s1-costs-card-val { font-family: 'DM Mono', monospace; font-size: 28px; font-weight: 700; letter-spacing: -1px; line-height: 1.1; }

/* Total Stats KPI grid */
.s1-total-kpi-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 10px; }
.s1-total-kpi-card {
  background: var(--c1-surface); border: 1px solid var(--c1-border); border-radius: 10px;
  padding: 18px 16px; display: flex; flex-direction: column; gap: 4px;
  transition: border-color .2s; cursor: default;
}
.s1-total-kpi-card:hover { border-color: var(--c1-accent); }
.s1-total-kpi-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
.s1-total-kpi-lbl { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-muted); }
.s1-total-kpi-val { font-family: 'DM Mono', monospace; font-size: 32px; font-weight: 700; letter-spacing: -1.5px; line-height: 1; margin-top: 4px; }
.s1-total-kpi-sub { font-size: 9px; color: var(--c1-muted); margin-top: 2px; }
.s1-ts-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 8px; flex-shrink: 0; vertical-align: middle; }

/* Responsive: report tables on mobile */
@media (max-width: 480px) {
  .s1-rt-name { min-width: 100px; }
  .s1-rt-num { min-width: 44px; }
  .s1-costs-card-val { font-size: 20px; }
  .s1-total-kpi-val { font-size: 24px; }
  .s1-total-kpi-grid { grid-template-columns: repeat(2, 1fr); }
}

/* ── Hide right panel (replaced by top-strip) ─────── */
.c1-stats-page .c1-panel { display: none !important; }

/* ── Deposit Goals ─────────────────────────────────── */
.s1-goals-wrap { background: rgba(255,255,255,.04); border: 1px solid rgba(255,255,255,.08); border-radius: 12px; padding: 16px; margin: 12px 0; }
.s1-goals-hdr { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }
.s1-goals-title { font-weight: 600; font-size: 13px; }
.s1-goals-edit-btn { font-size: 12px; color: var(--blue, #0057ff); cursor: pointer; }
.s1-goals-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
.s1-goal-card { background: rgba(255,255,255,.03); border-radius: 8px; padding: 12px; }
.s1-goal-period { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .5px; opacity: .6; margin-bottom: 8px; }
.s1-goal-bar-wrap { height: 4px; background: rgba(255,255,255,.1); border-radius: 2px; margin-bottom: 8px; overflow: hidden; }
.s1-goal-bar { height: 100%; border-radius: 2px; transition: width .4s; }
.s1-goal-nums { font-size: 12px; opacity: .8; }
.s1-goal-actual { font-weight: 700; font-size: 15px; }
.s1-goal-pct { font-size: 12px; font-weight: 700; margin-top: 2px; }
.s1-goal-edit { margin-top: 8px; display: flex; gap: 6px; }
.s1-goal-input { flex: 1; background: rgba(255,255,255,.08); border: 1px solid rgba(255,255,255,.15); border-radius: 5px; padding: 4px 8px; color: inherit; font-size: 12px; width: 60px; }
.s1-goal-save { background: var(--blue, #0057ff); border: none; border-radius: 5px; color: #fff; padding: 4px 10px; font-size: 12px; cursor: pointer; }
@media (max-width: 480px) {
  .s1-goals-grid { grid-template-columns: 1fr; }
}

/* ── Agent Transfer Rankings ──────────────────────────────────── */
.s1-transfer-wrap { background: #fff; border-radius: 10px; padding: 16px; margin: 16px 0; box-shadow: 0 1px 4px rgba(0,0,0,.06); }
.s1-transfer-list { display: flex; flex-direction: column; gap: 4px; }
.s1-transfer-row { display: flex; align-items: center; gap: 10px; padding: 6px 0; border-bottom: 1px solid #f1f5f9; font-size: 13px; }
.s1-transfer-row:last-child { border-bottom: none; }
.s1-transfer-rank { width: 28px; font-weight: 700; font-size: 12px; }
.s1-transfer-name { flex: 1; color: #1e293b; }
.s1-transfer-deps { color: #64748b; font-size: 12px; }

/* ── Teams Competition ──────────────────────────────────────────── */
.s1-teams-section { padding: 16px; }
.s1-scope-toggle { display: flex; gap: 8px; margin-bottom: 20px; flex-wrap: wrap; }
.s1-scope-pill { padding: 6px 18px; border-radius: 20px; border: 1.5px solid rgba(255,255,255,.15); background: transparent; color: rgba(255,255,255,.6); font-size: 12px; font-weight: 500; cursor: pointer; transition: all .15s; display: flex; align-items: center; gap: 5px; }
.s1-scope-pill:hover { border-color: rgba(255,255,255,.3); color: rgba(255,255,255,.85); }
.s1-scope-pill.on { background: var(--c1-dp, #0e7490); border-color: var(--c1-dp, #0e7490); color: #fff; }

.s1-h2h { display: flex; gap: 20px; align-items: stretch; margin-bottom: 24px; }
.s1-team-panel { flex: 1; background: rgba(255,255,255,.04); border-radius: 14px; overflow: hidden; border: 1px solid rgba(255,255,255,.08); }
.s1-tp-header { padding: 14px 18px; display: flex; align-items: center; gap: 10px; }
.s1-tp-emoji { font-size: 22px; }
.s1-tp-name { font-size: 16px; font-weight: 700; color: #fff; }
.s1-tp-body { padding: 14px 18px; }
.s1-tp-kpi-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; }
.s1-kpi-card { background: rgba(255,255,255,.05); border-radius: 10px; padding: 10px 12px; transition: all .15s; }
.s1-kpi-lbl { font-size: 10px; color: rgba(255,255,255,.5); text-transform: uppercase; letter-spacing: .05em; margin-bottom: 4px; }
.s1-kpi-val { font-size: 18px; font-weight: 700; color: #fff; display: flex; align-items: center; }
.s1-kpi-crown { font-size: 13px; margin-left: 4px; }
.s1-kpi-card.winning { background: rgba(255,255,255,.1); box-shadow: 0 0 0 1.5px rgba(255,255,255,.2); }

.s1-vs-badge { display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 800; color: rgba(255,255,255,.3); flex-shrink: 0; padding: 0 6px; }

/* Teams chart */
.s1-teams-chart-wrap { background: rgba(255,255,255,.03); border: 1px solid rgba(255,255,255,.07); border-radius: 12px; padding: 16px; margin-bottom: 8px; }
.s1-teams-svg { width: 100%; height: 160px; display: block; }
.s1-teams-chart-empty { text-align: center; color: rgba(255,255,255,.25); font-size: 12px; padding: 40px 0; }
.s1-teams-chart-legend { display: flex; gap: 16px; margin-top: 10px; }
.s1-tcl-item { display: flex; align-items: center; gap: 6px; font-size: 11px; color: rgba(255,255,255,.6); }
.s1-tcl-item span { display: inline-block; width: 22px; height: 3px; border-radius: 2px; flex-shrink: 0; }

/* Leaderboard table */
.s1-lb-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.s1-lb-table th { color: rgba(255,255,255,.4); font-weight: 600; text-transform: uppercase; font-size: 10px; letter-spacing: .05em; padding: 8px 10px; border-bottom: 1px solid rgba(255,255,255,.08); text-align: center; }
.s1-lb-table td { padding: 9px 10px; border-bottom: 1px solid rgba(255,255,255,.05); }
.s1-lb-rank { font-weight: 700; font-size: 15px; text-align: center; }
.s1-lb-av { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; color: #fff; }
.s1-lb-name { font-weight: 600; color: #fff; }
.s1-lb-team-badge { display: inline-block; padding: 2px 8px; border-radius: 10px; font-size: 10px; font-weight: 600; color: #fff; }

/* Goals section */
.s1-goals-section { margin-top: 8px; }
.s1-goal-row { margin-bottom: 14px; }
.s1-goal-label { display: flex; justify-content: space-between; font-size: 11px; color: rgba(255,255,255,.6); margin-bottom: 4px; }
.s1-goal-bar-track { height: 8px; background: rgba(255,255,255,.08); border-radius: 4px; overflow: hidden; }
.s1-goal-bar-fill { height: 100%; border-radius: 4px; transition: width .6s ease; }

@media (max-width: 600px) {
  .s1-h2h { flex-direction: column; }
  .s1-vs-badge { padding: 4px; }
  .s1-tp-kpi-grid { grid-template-columns: 1fr 1fr; }
}

</style>
